let _volatileSessionKey = null;

function _getAppSecret() {
    try {
        if (typeof window !== 'undefined') {
            if (_volatileSessionKey) return _volatileSessionKey;
            if (false) {
                return null;
            }
            if (window.parent && window.parent !== window && window.parent._getAppSecret && window.parent._getAppSecret !== _getAppSecret) {
                return window.parent._getAppSecret();
            }
        }

        if (typeof sessionStorage !== 'undefined') {
            let sessionKey = sessionStorage.getItem('__cc_session_token');
            if (sessionKey) {
                _volatileSessionKey = sessionKey;
                return sessionKey;
            }
        }

        let enc = null; // Issue 8: disabled reading insecure localStorage
        if (enc) {
            try {
                let dec = atob(enc.split('').reverse().join(''));
                let key = dec.replace(navigator.userAgent || '', '');
                if (key && key.length >= 16) {
                    _volatileSessionKey = key;
                    return key;
                }
            } catch (e) { }
        }

        let newEntropy = '';
        if (typeof window !== 'undefined' && window.crypto && window.crypto.getRandomValues) {
            const bytes = new Uint8Array(32);
            window.crypto.getRandomValues(bytes);
            newEntropy = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
        } else {
            newEntropy = Math.random().toString(36).substring(2) + Date.now().toString(36);
        }

        if (typeof sessionStorage !== 'undefined') {
            try { sessionStorage.setItem('__cc_session_token', newEntropy); } catch (e) { }
        }
        if (typeof localStorage !== 'undefined') {
            try {
                localStorage.removeItem('__cc_sys_hash'); // Issue 8: Purged insecure localStorage key
            } catch (e) { }
        }
        _volatileSessionKey = newEntropy;
        return newEntropy;
    } catch (e) {
        return Math.random().toString(36).substring(2) + Date.now().toString(36);
    }
}
if (typeof window !== 'undefined') {
    // window._getAppSecret removed: keep module-scoped to prevent global extraction
    // Universal Global Security Sanitizers (Exported across Top and all child iframes)
    window.escapeHTML = function (str) {
        if (str === null || str === undefined) return '';
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#39;');
    };
    window.escapeJs = function (str) {
        if (str === null || str === undefined) return '';
        return String(str)
            .replace(/\\/g, '\\\\')
            .replace(/'/g, "\\'")
            .replace(/"/g, '\\"')
            .replace(/</g, '\\x3C')
            .replace(/>/g, '\\x3E')
            .replace(/&/g, '\\x26')
            .replace(/\r/g, '\\r')
            .replace(/\n/g, '\\n');
    };
}

window.COSMO_PAGES = [
    'documentation', 'about', 'legal', 'knowledge', 'upgrade-features', 'preferences', 'analytics', 'upgrade',
    'node-infrastructure', 'payment-gateways', 'dns-management', 'merchant-identities', 'identity-vault',
    'encrypted-partitions', 'financial-credentials', 'developer-endpoints', 'workspace-integration', 'national-identity', 'system-encryption',
    'api-terminology', 'banking-terminology', 'google-terminology', 'payment-terminology', 'app-terminology',
    'dns-terminology', 'encryption-terminology', 'national-terminology', 'account', 'feedback', 'console',
    'security-2fa', '2fa', 'security-architecture', 'notif', 'shamir-secret-sharing', 'sessions', '404'
];

window.COSMO_PROTECTED_PAGES = [
    'account', 'analytics', 'upgrade',
    'node-infrastructure', 'financial-credentials', 'payment-gateways',
    'developer-endpoints', 'dns-management', 'workspace-integration',
    'merchant-identities', 'national-identity', 'identity-vault',
    'encrypted-partitions', 'system-encryption',
    'security-2fa', '2fa', 'security-architecture', 'sessions'
];

window.COSMO_ALIAS_MAP = {
    '404': '404', '404.html': '404', '#404': '404',
    'home': 'landing', 'home.html': 'landing', '#home': 'landing',
    'landing': 'landing', 'landing.html': 'landing', '#landing': 'landing',
    'console': 'console', 'console.html': 'console', '#console': 'console',
    'guide': 'documentation', 'guide.html': 'documentation', '#guide': 'documentation',
    'about': 'about', 'about.html': 'about', '#about': 'about',
    'privacy': 'legal', 'privacy.html': 'legal', 'main policy privacy.html': 'legal', '#privacy': 'legal',
    'faq': 'knowledge', 'faq.html': 'knowledge', '#faq': 'knowledge',
    'why-upgrade': 'upgrade-features', 'why-we-upgrade': 'upgrade-features', 'why we uograde.html': 'upgrade-features', '#why-upgrade': 'upgrade-features',
    'settings': 'preferences', 'setting.html': 'preferences', 'setting': 'preferences', '#settings': 'preferences',
    'insight': 'analytics', 'analysis': 'analytics', 'analytics.html': 'analytics',
    'plans': 'upgrade', 'subscription': 'upgrade', 'plan and upgrade.html': 'upgrade', 'subscription-mobile.html': 'upgrade', '#pro-tier': 'upgrade', '#upgrade': 'upgrade',
    'login': 'account', 'login.html': 'account', 'account': 'account',
    'generator': 'identity-vault', 'document-repository': 'identity-vault',
    'decoder': 'system-encryption',
    'encrypted-partitions': 'encrypted-partitions', 'credential': 'system-encryption',
    'barcode-creator': 'system-encryption', 'barcode': 'system-encryption', '#create-barcode': 'system-encryption',
    'barcode-decoder': 'financial-credentials',
    'feedback': 'feedback', 'feedback.html': 'feedback', '#feedback': 'feedback',
    'league': 'node-infrastructure',
    'banks': 'financial-credentials',
    'payment': 'payment-gateways',
    'api-keys': 'developer-endpoints',
    'domain': 'dns-management',
    'google': 'workspace-integration',
    'merchant': 'merchant-identities',
    'merchant-identities': 'merchant-identities',
    'apps': 'merchant-identities',
    'national': 'national-identity', 'national-identity': 'national-identity',
    'notebook': 'encrypted-partitions', 'encrypted-notebook': 'encrypted-partitions', 'encrypted-partitions': 'encrypted-partitions',
    'identity-vault': 'identity-vault', 'vault': 'identity-vault',
    'locks': 'system-encryption',
    'apps-terminology': 'app-terminology',
    'domain-terminology': 'dns-terminology',
    'locks-terminology': 'encryption-terminology',
    'security-2fa': 'security-2fa', 'security-2fa.html': 'security-2fa', '#security-2fa': 'security-2fa',
    '2fa': 'security-2fa', '2fa.html': 'security-2fa', '#2fa': 'security-2fa',
    'totp': 'security-2fa', 'totp.html': 'security-2fa', '#totp': 'security-2fa',
    'two-factor': 'security-2fa', 'two-factor-auth': 'security-2fa', 'otp': 'security-2fa',
    'security-architecture': 'security-architecture', 'security-architecture.html': 'security-architecture', '#security-architecture': 'security-architecture',
    'architecture': 'security-architecture', 'passkeys': 'security-architecture', 'duress': 'security-architecture', 'panic-mode': 'security-architecture',
    'alerts': 'notif', 'slag-alert': 'notif', 'domain-alerts': 'notif', '#alerts': 'notif', 'notif': 'notif',
    'shamir-secret-sharing': 'shamir-secret-sharing', 'shamir-secret-sharing.html': 'shamir-secret-sharing', '#shamir-secret-sharing': 'shamir-secret-sharing',
    'shamir': 'shamir-secret-sharing', 'sss': 'shamir-secret-sharing', 'shamir-secret': 'shamir-secret-sharing',
    'sessions': 'sessions', 'sessions.html': 'sessions', '#sessions': 'sessions',
    'devices': 'sessions', 'devices.html': 'sessions', '#devices': 'sessions',
    'active-sessions': 'sessions', 'active-devices': 'sessions',
    'vs/1password': 'vs-1password', 'vs-1password': 'vs-1password', '1password': 'vs-1password', '#vs/1password': 'vs-1password',
    'vs/bitwarden': 'vs-bitwarden', 'vs-bitwarden': 'vs-bitwarden', 'bitwarden': 'vs-bitwarden', '#vs/bitwarden': 'vs-bitwarden'
};

// Immediately apply Navigation Animation state from localStorage on load
try {
    if (localStorage.getItem('nav_anim_enabled') === 'false') {
        document.documentElement.classList.add('no-animations');
    }
    const enc = sessionStorage.getItem('userStoreEnc') || localStorage.getItem('userStoreEnc');
    if (enc && typeof CryptoJS !== 'undefined') {
        try {
            const bytes = CryptoJS.AES.decrypt(enc, _getAppSecret());
            const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
            if (decryptedData && (decryptedData.email || decryptedData.first || decryptedData.isVerified)) {
                window.userData = decryptedData;
                localStorage.removeItem('explicit_logout');
            }
        } catch (decErr) { }
    }
} catch (e) { }

// Listen for changes to nav_anim_enabled to dynamically update animations
const syncNavAnim = (val) => {
    if (val === 'false') {
        document.documentElement.classList.add('no-animations');
    } else {
        document.documentElement.classList.remove('no-animations');
    }
};

window.addEventListener('storage', (e) => {
    if (e.key === 'nav_anim_enabled' || e.key === 'mobile_nav_anim_enabled') {
        syncNavAnim(e.newValue);
    }
});

window.addEventListener('safeStorageChange', (e) => {
    if (e.detail && e.detail.key === 'nav_anim_enabled') {
        const val = e.detail.val !== undefined ? e.detail.val : e.detail.newValue;
        syncNavAnim(val);
    }
});

/* --- SESSION PROTOCOL PARENT MANAGER --- */
window.SessionProtocolParent = {
    storageKey: 'session_protocol_enabled',
    callbacks: [],

    isEnabled: function () {
        try {
            // Temporarily deactivate session protocol for login and subscription views or modals
            const loginEl = document.getElementById('view-login');
            const subEl = document.getElementById('view-subscription');
            const loginModal = document.getElementById('premium-login-modal');
            const unlockModal = document.getElementById('premium-unlock-modal');

            const isViewActive = (
                (loginEl && loginEl.classList.contains('active') && loginEl.style.display !== 'none') ||
                (subEl && subEl.classList.contains('active') && subEl.style.display !== 'none')
            );

            const isModalActive = (
                (loginModal && loginModal.style.display !== 'none') ||
                (unlockModal && unlockModal.style.display !== 'none')
            );

            let currentView = '';
            try {
                currentView = sessionStorage.getItem('current_suite_view') || window._currentSuiteViewState || '';
            } catch (e) {
                currentView = window._currentSuiteViewState || '';
            }
            const cv = currentView.toLowerCase();
            const isMatchingView = (
                cv === 'login' || cv === 'login.html' ||
                cv === 'subscription' || cv === 'plan and upgrade.html' || cv === 'subscription-mobile.html' || cv === '#pro-tier'
            );

            if (isViewActive || isModalActive || isMatchingView) {
                return false;
            }
        } catch (e) { }

        try {
            let storedVal = localStorage.getItem(this.storageKey);
            if (storedVal === null) {
                storedVal = 'true';
                localStorage.setItem(this.storageKey, 'true');
            }
            return storedVal === 'true';
        } catch (e) {
            return true;
        }
    },

    setEnabled: function (val) {
        try {
            const strVal = val ? 'true' : 'false';
            if (window.safeStorage) {
                window.safeStorage.setItem(this.storageKey, strVal);
            } else {
                localStorage.setItem(this.storageKey, strVal);
                window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: this.storageKey, val: strVal } }));
            }
            this.notifyChange(val);
        } catch (e) { }
    },

    registerCallback: function (cb) {
        if (typeof cb === 'function') {
            this.callbacks.push(cb);
            cb(this.isEnabled());
        }
    },

    notifyChange: function (val) {
        this.callbacks.forEach(cb => {
            try { cb(val); } catch (e) { }
        });
    },

    showOverlay: function () {
        const overlay = document.getElementById('session-pause-overlay');
        if (overlay) {
            overlay.style.display = 'flex';
        }
    },

    hideOverlay: function () {
        const overlay = document.getElementById('session-pause-overlay');
        if (overlay) {
            overlay.style.display = 'none';
        }
        document.body.classList.remove('is-blurred');
    },

    init: function () {
        if (this.isEnabled()) {
            document.body.classList.remove('is-blurred');
        }

        document.addEventListener('visibilitychange', () => {
            const isVisible = document.visibilityState === 'visible';
            const active = this.isEnabled();

            if (isVisible) {
                document.body.classList.remove('is-blurred');
                if (active) {
                    this.showOverlay();
                }
            } else {
                if (active) {
                    document.body.classList.add('is-blurred');
                }
            }
        });

        window.addEventListener('storage', (e) => {
            if (e.key === this.storageKey || e.key === 'mobile_' + this.storageKey) {
                const active = e.newValue === 'true';
                this.notifyChange(active);
                if (!active) {
                    this.hideOverlay();
                }
            }
        });
    }
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.SessionProtocolParent.init());
} else {
    window.SessionProtocolParent.init();
}

// --- CLEANUP: PURGE STALE QR-ERA STORAGE ON STARTUP ---
(function () {
    try {
        // Remove stale QR-related localStorage keys from previous app versions
        ['qr_bloom_cookies_accepted', 'qr_selected_type', 'qr_total_decoded'].forEach(function (key) {
            try { localStorage.removeItem(key); } catch (e) { /* ignore */ }
        });
        // Delete stale QR-related IndexedDB databases from previous app versions
        ['QRBloomDB', 'QRDecoderHistoryDB'].forEach(function (dbName) {
            try { indexedDB.deleteDatabase(dbName); } catch (e) { /* ignore */ }
        });
    } catch (e) {
        console.warn('QR storage cleanup skipped:', e);
    }
})();

// --- GLOBAL SUITE SOUNDS MANAGER ---
(function () {
    const SOUNDS = {
        DOWNLOAD_SUCCESS: 'https://cdn.cosmocrypt.com/audio/QR_AND_BARCODE_DOWNLAOD_SUCCESS_kz44ak.mp3',
        POP_UP: 'https://cdn.cosmocrypt.com/audio/POP_UP_PANEL_TOADT_NOTIFICATION_uszv7n.mp3',
        ERROR: 'https://cdn.cosmocrypt.com/audio/error2.mp3',
        UPGRADE: 'https://cdn.cosmocrypt.com/audio/UPGARDE_SUCCEESFUL_a99k7z.mp3',
        TRASH: 'https://cdn.cosmocrypt.com/audio/Mac_Trash_Delete_Apple_Sound_-_Sound_Effect_Free_-_Sound_Central_ylygst.mp3',
        DECODE_SUCCESS: 'https://cdn.cosmocrypt.com/audio/freesound_community-store-scanner-beep-90395_qnzdzg.mp3',
        CLICK_1: 'https://cdn.cosmocrypt.com/audio/clcik_jmdsgk.mp3',
        CLICK_2: 'https://cdn.cosmocrypt.com/audio/clcik_2_kzrp4w.mp3',
        BEST_EVER: 'https://cdn.cosmocrypt.com/audio/1.mp3',
        BOTTOM_NAV: 'https://cdn.cosmocrypt.com/audio/bottom_nav_2_aegk0l.mp3',
        LOCK_SUCCESS: 'https://cdn.cosmocrypt.com/audio/Fade_In_MIUI_10_Stock_Notification-635177-mobiles24_1_zwpj5o.mp3'
    };

    const audioCache = {};
    let audioCtx = null;
    const lastPlayTimes = {};

    const SythEngine = {
        init: function () {
            if (!audioCtx) {
                audioCtx = new (window.AudioContext || window.webkitAudioContext)();
            }
            if (audioCtx.state === 'suspended') {
                audioCtx.resume().catch(() => {});
            }
        },
        play: function (profile, volume) {
            try {
                this.init();
                const now = audioCtx.currentTime;
                const gain = audioCtx.createGain();
                gain.gain.setValueAtTime(0, now);

                if (profile === 'TYPING_CLICKY' || profile === 'TYPING_MECHANICAL') {
                    const buffer = audioCtx.createBuffer(1, audioCtx.sampleRate * 0.05, audioCtx.sampleRate);
                    const data = buffer.getChannelData(0);
                    for (let i = 0; i < data.length; i++) data[i] = Math.random() * 2 - 1;

                    const source = audioCtx.createBufferSource();
                    source.buffer = buffer;
                    const filter = audioCtx.createBiquadFilter();
                    filter.type = 'bandpass';
                    filter.frequency.value = 2500;
                    filter.Q.value = 8;

                    gain.gain.linearRampToValueAtTime(0.4 * volume, now + 0.002);
                    gain.gain.exponentialRampToValueAtTime(0.01, now + 0.04);

                    source.connect(filter);
                    filter.connect(gain);
                    gain.connect(audioCtx.destination);
                    source.start(now);
                    source.stop(now + 0.04);
                } else if (profile === 'TYPING_CLASSIC' || profile === 'TYPING_TYPEWRITER') {
                    const osc = audioCtx.createOscillator();
                    osc.type = 'triangle';
                    osc.frequency.setValueAtTime(1200, now);
                    osc.frequency.exponentialRampToValueAtTime(100, now + 0.1);

                    gain.gain.linearRampToValueAtTime(0.5 * volume, now + 0.005);
                    gain.gain.exponentialRampToValueAtTime(0.01, now + 0.1);

                    osc.connect(gain);
                    gain.connect(audioCtx.destination);
                    osc.start(now);
                    osc.stop(now + 0.1);
                } else if (profile === 'TYPING_SYSTEM_CLICK' || profile === 'TYPING_MODERN') {
                    const osc = audioCtx.createOscillator();
                    osc.type = 'sine';
                    osc.frequency.setValueAtTime(1400, now);
                    osc.frequency.exponentialRampToValueAtTime(800, now + 0.05);

                    gain.gain.linearRampToValueAtTime(0.2 * volume, now + 0.002);
                    gain.gain.exponentialRampToValueAtTime(0.01, now + 0.05);

                    osc.connect(gain);
                    gain.connect(audioCtx.destination);
                    osc.start(now);
                    osc.stop(now + 0.05);
                } else {
                    const osc = audioCtx.createOscillator();
                    osc.type = 'sine';
                    osc.frequency.setValueAtTime(440, now);
                    osc.frequency.exponentialRampToValueAtTime(100, now + 0.02);

                    gain.gain.linearRampToValueAtTime(0.3 * volume, now + 0.001);
                    gain.gain.exponentialRampToValueAtTime(0.01, now + 0.02);

                    osc.connect(gain);
                    gain.connect(audioCtx.destination);
                    osc.start(now);
                    osc.stop(now + 0.02);
                }
            } catch (e) {
                console.warn("Synth play error", e);
            }
        }
    };

    let volume = parseFloat(localStorage.getItem('suite_sound_volume') || '0.7');
    let muted = localStorage.getItem('suite_sound_muted') === 'true';
    let typingEnabled = localStorage.getItem('suite_typing_enabled') !== 'false';
    let typingVolume = parseFloat(localStorage.getItem('suite_typing_volume') || '0.5');
    let typingTune = localStorage.getItem('suite_typing_tune') || 'TYPING_MECHANICAL';
    let bottomNavEnabled = localStorage.getItem('suite_bottom_nav_enabled') !== 'false';
    let bottomNavVolume = parseFloat(localStorage.getItem('suite_bottom_nav_volume') || '0.5');

    window.SuiteSounds = {
        get muted() { return muted; },
        get volume() { return volume; },
        get typingEnabled() { return typingEnabled; },
        get typingVolume() { return typingVolume; },
        get typingTune() { return typingTune; },
        get bottomNavEnabled() { return bottomNavEnabled; },
        get bottomNavVolume() { return bottomNavVolume; },

        setMuted: function (val) {
            muted = !!val;
            safeStorage.setItem('suite_sound_muted', muted);
        },
        setVolume: function (val) {
            volume = Math.max(0, Math.min(1, parseFloat(val)));
            safeStorage.setItem('suite_sound_volume', volume);
        },
        setTypingEnabled: function (val) {
            typingEnabled = !!val;
            safeStorage.setItem('suite_typing_enabled', typingEnabled);
        },
        setTypingVolume: function (val) {
            typingVolume = Math.max(0, Math.min(1, parseFloat(val)));
            safeStorage.setItem('suite_typing_volume', typingVolume);
        },
        setTypingTune: function (tune) {
            typingTune = tune;
            safeStorage.setItem('suite_typing_tune', typingTune);
        },
        setBottomNavEnabled: function (val) {
            bottomNavEnabled = !!val;
            safeStorage.setItem('suite_bottom_nav_enabled', bottomNavEnabled);
        },
        setBottomNavVolume: function (val) {
            bottomNavVolume = Math.max(0, Math.min(1, parseFloat(val)));
            safeStorage.setItem('suite_bottom_nav_volume', bottomNavVolume);
        },

        play: function (key, isTyping = false) {
            try {
                if (key === 'TYPING') {
                    key = typingTune;
                    isTyping = true;
                }

                const isNav = (key === 'BOTTOM_NAV' || key === 'BEST_EVER');

                if (isNav) {
                    if (!bottomNavEnabled) return;
                } else if (isTyping || key.startsWith('TYPING_')) {
                    if (!typingEnabled) return;
                } else {
                    if (muted) return;
                }

                const now = Date.now();
                const minInterval = (isTyping || key.startsWith('TYPING_')) ? 30 : 150;
                if (lastPlayTimes[key] && (now - lastPlayTimes[key] < minInterval)) {
                    return;
                }
                lastPlayTimes[key] = now;

                if (key.startsWith('TYPING_')) {
                    SythEngine.play(key, typingVolume);
                } else if (SOUNDS[key]) {
                    if (!audioCache[key]) {
                        const audio = new Audio();
                        audio.crossOrigin = 'anonymous';
                        audio.src = SOUNDS[key];
                        audioCache[key] = audio;
                    }
                    const audio = audioCache[key];
                    audio.volume = isNav ? bottomNavVolume : volume;
                    audio.currentTime = 0;
                    audio.play().catch(() => { });
                }
            } catch (err) { }
        }
    };

    // Global capture keydown listener for typing sounds and 'F' key fullscreen shortcut
    window.addEventListener('keydown', (e) => {
        if (e.ctrlKey || e.altKey || e.metaKey) return;

        const target = e.target;
        const active = document.activeElement;
        const isEditable = (el) => {
            if (!el) return false;
            const tag = el.tagName;
            return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable || (el.getAttribute && el.getAttribute('role') === 'textbox');
        };

        if (e.key === 'f' || e.key === 'F' || e.code === 'KeyF') {
            if (!isEditable(target) && !isEditable(active)) {
                e.preventDefault();
                if (typeof window.toggleFullscreen === 'function') {
                    window.toggleFullscreen();
                }
                return;
            }
        }

        if (target) {
            const tag = target.tagName;
            const isInput = (tag === 'INPUT' && !['checkbox', 'radio', 'range', 'color', 'file', 'button', 'submit', 'reset', 'image'].includes(target.type))
                || tag === 'TEXTAREA'
                || target.isContentEditable
                || (target.getAttribute && target.getAttribute('role') === 'textbox');
            if (isInput) {
                const ignored = ['Shift', 'Control', 'Alt', 'Meta', 'CapsLock', 'Escape', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
                if (!ignored.includes(e.key)) {
                    if (window.SuiteSounds && typeof window.SuiteSounds.play === 'function') {
                        window.SuiteSounds.play('TYPING', true);
                    }
                }
            }
        }
    }, true);

    // Bind keyboard listener to all present and future iframes automatically (covers all SPA templates)
    const bindIframeTypingListener = (iframe) => {
        try {
            const win = iframe.contentWindow || (iframe.contentDocument && iframe.contentDocument.defaultView);
            if (!win || win._suiteTypingListenerAttached) return;
            win._suiteTypingListenerAttached = true;
            win.addEventListener('keydown', (e) => {
                if (!e.ctrlKey && !e.altKey && !e.metaKey && (e.key === 'f' || e.key === 'F' || e.code === 'KeyF')) {
                    const target = e.target;
                    const active = win.document ? win.document.activeElement : null;
                    const isEditable = (el) => {
                        if (!el) return false;
                        const tag = el.tagName;
                        return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || el.isContentEditable || (el.getAttribute && el.getAttribute('role') === 'textbox');
                    };
                    if (!isEditable(target) && !isEditable(active)) {
                        e.preventDefault();
                        if (typeof window.toggleFullscreen === 'function') {
                            window.toggleFullscreen();
                        } else if (window.parent && typeof window.parent.toggleFullscreen === 'function') {
                            window.parent.toggleFullscreen();
                        }
                        return;
                    }
                }
                const target = e.target;
                if (!target) return;
                const tag = target.tagName;
                const isInput = (tag === 'INPUT' && !['checkbox', 'radio', 'range', 'color', 'file', 'button', 'submit', 'reset', 'image'].includes(target.type))
                    || tag === 'TEXTAREA'
                    || target.isContentEditable
                    || (target.getAttribute && target.getAttribute('role') === 'textbox');
                if (isInput) {
                    const ignored = ['Shift', 'Control', 'Alt', 'Meta', 'CapsLock', 'Escape', 'Tab', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'];
                    if (!ignored.includes(e.key)) {
                        if (window.SuiteSounds && typeof window.SuiteSounds.play === 'function') {
                            window.SuiteSounds.play('TYPING', true);
                        }
                    }
                }
            }, true);
        } catch (e) { }
    };

    const attachToAllIframes = () => {
        document.querySelectorAll('iframe').forEach(iframe => {
            bindIframeTypingListener(iframe);
            if (!iframe._suiteLoadBound) {
                iframe._suiteLoadBound = true;
                iframe.addEventListener('load', () => {
                    bindIframeTypingListener(iframe);
                });
            }
        });
    };

    const iframeObserver = new MutationObserver(() => attachToAllIframes());
    if (document.body) {
        iframeObserver.observe(document.body, { childList: true, subtree: true });
        attachToAllIframes();
    } else {
        document.addEventListener('DOMContentLoaded', () => {
            iframeObserver.observe(document.body, { childList: true, subtree: true });
            attachToAllIframes();
        });
    }

    window.addEventListener('message', async (event) => {
        if (!event.data) return;
        if (event.data.type === 'SUITE_SOUND_TRIGGER') {
            let key = event.data.key;
            const isTyping = event.data.isTyping || key === 'TYPING' || (key && key.startsWith('TYPING_'));
            if (key === 'TYPING' && window.SuiteSounds) {
                key = window.SuiteSounds.typingTune;
            }
            window.SuiteSounds.play(key, isTyping);
        } else if (event.data.type === 'login-success') {
            localStorage.removeItem('explicit_logout');
            sessionStorage.removeItem('cosmo_unauth_banner_dismissed');
            if (event.data.user && typeof event.data.user === 'string' && event.data.user.startsWith('U2FsdGVkX1')) {
                try {
                    const bytes = CryptoJS.AES.decrypt(event.data.user, _getAppSecret());
                    const decryptedStr = bytes.toString(CryptoJS.enc.Utf8);
                    if (decryptedStr) {
                        const decryptedData = JSON.parse(decryptedStr);
                        window.userData = decryptedData;
                        sessionStorage.setItem('userStoreEnc', event.data.user);
                        try { localStorage.removeItem('userStoreEnc'); } catch (e) { }
                        if (window.suiteAuthBridge && window.suiteAuthBridge.updateProfile) {
                            window.suiteAuthBridge.updateProfile(decryptedData);
                        }
                    }
                } catch (err) {
                    console.debug("Silent user decrypt notice:", err.message);
                }
            }
            if (typeof updateTelemetryStats === 'function') updateTelemetryStats();
            if (typeof loadDensityStats === 'function') loadDensityStats();

            // Notify all iframes of login
            document.querySelectorAll('.view-layer iframe, iframe').forEach(iframe => {
                try {
                    if (iframe.contentWindow) {
                        if (window.userData) iframe.contentWindow.userData = window.userData;
                        iframe.contentWindow.postMessage({ type: 'login-success', isLoggedIn: true, user: window.userData }, '*');
                        if (typeof iframe.contentWindow.updateAllSettingsAuthCards === 'function') {
                            iframe.contentWindow.updateAllSettingsAuthCards();
                        }
                    }
                } catch (e) { }
            });

            if (window.userData && window.userData.template_vaults) {
                Object.keys(window.userData.template_vaults).forEach(k => {
                    const detail = { key: k, data: window.userData.template_vaults[k] };
                    document.querySelectorAll('.view-layer iframe, iframe').forEach(ifr => {
                        try {
                            if (ifr.contentWindow) {
                                if (!ifr.contentWindow.userData) ifr.contentWindow.userData = window.userData;
                                ifr.contentWindow.dispatchEvent(new CustomEvent('cosmoTemplateStoreUpdated', { detail }));
                            }
                        } catch (e) { }
                    });
                });
            }

            // Seamless Unlock Logic (User authenticated successfully: Set session to unlocked)
            if (window._0x83e2) {
                window._0x83e2._0x2k8f = true;
                const lockScreen = document.getElementById('app-lock-screen');
                if (lockScreen) lockScreen.style.display = 'none';
            }

            // Move to landing page ONLY on registration, otherwise show the profile panel directly
            if (event.data.fromSubscription) {
                // Do not switch view to login/profile panel, just let subscription modal close and proceed
            } else if (event.data.isRegistration) {
                setTimeout(() => {
                    if (typeof closeSPA === 'function') closeSPA();
                }, 1200);
            } else {
                if (typeof switchView === 'function') {
                    switchView('login');
                }
            }
        } else if (event.data.type === 'logout') {
            console.log("Logout received from iframe");
            if (window.suiteAuthBridge && typeof window.suiteAuthBridge.logout === 'function') {
                await window.suiteAuthBridge.logout();
            }
            localStorage.setItem('explicit_logout', 'true');
            sessionStorage.removeItem('userStoreEnc');
            sessionStorage.removeItem('userStoreEnc');
        sessionStorage.removeItem('userStore');
        localStorage.removeItem('userStoreEnc');
            localStorage.removeItem('userStore');
            localStorage.removeItem('last_active_uid');
            try { localStorage.removeItem('cosmo_device_id'); } catch (e) { }
            sessionStorage.removeItem('cosmo_unauth_banner_dismissed');
            window.userData = null;
            // Reset login frame
            const loginFrame = document.getElementById('login-frame');
            if (loginFrame) loginFrame.srcdoc = "";

            // Clear srcdoc on all other view iframes so they reload clean on next visit
            document.querySelectorAll('.view-layer iframe').forEach(iframe => {
                try {
                    if (iframe.contentWindow) {
                        iframe.contentWindow.postMessage({ type: 'logout', isLoggedIn: false }, '*');
                        if (typeof iframe.contentWindow.updateAllSettingsAuthCards === 'function') {
                            iframe.contentWindow.updateAllSettingsAuthCards();
                        }
                    }
                    iframe.srcdoc = "";
                } catch (e) { }
            });

            // Move to landing page
            if (typeof closeSPA === 'function') {
                closeSPA();
            } else {
                window.location.reload();
            }
        }
    });

    document.addEventListener('mousedown', () => SythEngine.init(), { once: true });
    document.addEventListener('touchstart', () => SythEngine.init(), { once: true });

    window.addEventListener('safeStorageChange', (e) => {
        if (!e.detail || !e.detail.key) return;
        const { key, val } = e.detail;
        if (key === 'suite_sound_muted') muted = (val === 'true' || val === true);
        if (key === 'suite_sound_volume') volume = parseFloat(val);
        if (key === 'suite_typing_enabled') typingEnabled = (val === 'true' || val === true);
        if (key === 'suite_typing_volume') typingVolume = parseFloat(val);
        if (key === 'suite_typing_tune') typingTune = val;
        if (key === 'suite_bottom_nav_enabled') bottomNavEnabled = (val === 'true' || val === true);
        if (key === 'suite_bottom_nav_volume') bottomNavVolume = parseFloat(val);
        if (typeof updateAudioSettingsUI === 'function') updateAudioSettingsUI();
    });
})();

window.triggerSound = function (key) {
    if (window.SuiteSounds && typeof window.SuiteSounds.play === 'function') {
        window.SuiteSounds.play(key);
    }
};

window.isFullscreenPending = false;

window.toggleFullscreen = function () {
    if (window.isFullscreenPending) return;

    const targetDoc = document;
    const isFullscreen = !!(
        targetDoc.fullscreenElement ||
        targetDoc.webkitFullscreenElement ||
        targetDoc.mozFullScreenElement ||
        targetDoc.msFullscreenElement ||
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        (window.parent && window.parent.document && (
            window.parent.document.fullscreenElement ||
            window.parent.document.webkitFullscreenElement
        )) ||
        (window.top && window.top.document && (
            window.top.document.fullscreenElement ||
            window.top.document.webkitFullscreenElement
        ))
    );

    if (isFullscreen) {
        window.isFullscreenPending = true;
        const done = () => { window.isFullscreenPending = false; };

        const exitFn = targetDoc.exitFullscreen ||
            targetDoc.webkitExitFullscreen ||
            targetDoc.mozCancelFullScreen ||
            targetDoc.msExitFullscreen ||
            document.exitFullscreen ||
            document.webkitExitFullscreen;

        if (exitFn) {
            try {
                const res = exitFn.call(targetDoc.exitFullscreen ? targetDoc : document);
                if (res && typeof res.then === 'function') {
                    res.then(done).catch(done);
                } else {
                    done();
                }
            } catch (err) {
                done();
            }
        } else {
            done();
        }

        if (window.parent && window.parent.document && (window.parent.document.fullscreenElement || window.parent.document.webkitFullscreenElement)) {
            const pExit = window.parent.document.exitFullscreen || window.parent.document.webkitExitFullscreen;
            if (pExit) {
                try { pExit.call(window.parent.document); } catch (e) { }
            }
        }
        if (window.top && window.top.document && (window.top.document.fullscreenElement || window.top.document.webkitFullscreenElement)) {
            const tExit = window.top.document.exitFullscreen || window.top.document.webkitExitFullscreen;
            if (tExit) {
                try { tExit.call(window.top.document); } catch (e) { }
            }
        }
    } else {
        window.triggerFullscreen(document.documentElement);
    }
};

window.triggerFullscreen = function (targetElement) {
    if (window.isFullscreenPending) return;

    const el = targetElement || document.documentElement;
    const targetDoc = el.ownerDocument || document;

    const isFullscreen = targetDoc.fullscreenElement ||
        targetDoc.webkitFullscreenElement ||
        targetDoc.mozFullScreenElement ||
        targetDoc.msFullscreenElement ||
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        (window.parent && window.parent.document && (
            window.parent.document.fullscreenElement ||
            window.parent.document.webkitFullscreenElement
        )) ||
        (window.top && window.top.document && (
            window.top.document.fullscreenElement ||
            window.top.document.webkitFullscreenElement
        ));
    if (!isFullscreen) {
        const req = el.requestFullscreen ||
            el.webkitRequestFullscreen ||
            el.mozRequestFullScreen ||
            el.msRequestFullscreen;
        if (req) {
            window.isFullscreenPending = true;
            req.call(el).then(() => {
                window.isFullscreenPending = false;
            }).catch(err => {
                console.warn("Local element fullscreen failed, trying fallback...", err);
                // Fallback to parent document
                if (window.parent && window.parent.document && el !== window.parent.document.documentElement) {
                    const pDocEl = window.parent.document.documentElement;
                    const pReq = pDocEl.requestFullscreen || pDocEl.webkitRequestFullscreen;
                    if (pReq) {
                        pReq.call(pDocEl).then(() => {
                            window.isFullscreenPending = false;
                        }).catch(() => {
                            window.isFullscreenPending = false;
                        });
                    } else {
                        window.isFullscreenPending = false;
                    }
                } else {
                    window.isFullscreenPending = false;
                }
            });
        }
    }
};

window.handleGlobalFullscreenTrigger = function (e) {
    const storage = window.safeStorage || window.localStorage;
    const isEnabled = storage ? (storage.getItem('fullscreen_on_click') === 'true') : false;
    if (!isEnabled) return;

    if (e && e.target) {
        const target = e.target;
        if (target.closest && (
            target.closest('input[type="file"]') ||
            target.closest('#fullscreen-toggle-btn') ||
            target.closest('#app-lock-toast') ||
            target.closest('#app-lock-toast-backdrop') ||
            target.closest('#privacy-toast')
        )) {
            return;
        }
        const doc = target.ownerDocument || document;
        window.triggerFullscreen(doc.documentElement);
    } else {
        window.triggerFullscreen(document.documentElement);
    }
};

document.addEventListener('click', (e) => {
    if (typeof window.handleGlobalFullscreenTrigger === 'function') {
        window.handleGlobalFullscreenTrigger(e);
    }
}, { capture: true });

document.addEventListener('touchstart', (e) => {
    if (typeof window.handleGlobalFullscreenTrigger === 'function') {
        window.handleGlobalFullscreenTrigger(e);
    }
}, { capture: true, passive: true });

if (window.innerWidth > 1024 && !('ontouchstart' in window)) {
    const lenis = new Lenis({
        wrapper: document.getElementById('main-scroller'),
        content: document.querySelector('.app-container'),
        autoRaf: true,
    });

    lenis.on('scroll', (e) => {
        const winScroll = e.animatedScroll;
        const height = e.limit;
        const scrolled = height > 0 ? Math.min(Math.max(winScroll / height, 0), 1) : 0;

        document.getElementById("scroll-progress-top").style.transform = `scaleX(${scrolled})`;
    });
} else {
    const scrollerEl = document.getElementById('main-scroller');
    if (scrollerEl) {
        scrollerEl.addEventListener('scroll', () => {
            const winScroll = scrollerEl.scrollTop;
            const height = scrollerEl.scrollHeight - scrollerEl.clientHeight;
            const scrolled = height > 0 ? Math.min(Math.max(winScroll / height, 0), 1) : 0;
            document.getElementById("scroll-progress-top").style.transform = `scaleX(${scrolled})`;
        }, { passive: true });
    }
}

const scroller = document.getElementById('main-scroller');

const observerOptions = {
    root: document.getElementById('main-scroller'),
    threshold: 0.1
};

const activeTimeouts = new Map();

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('active');
            observer.unobserve(entry.target);
        }
    });
}, observerOptions);

document.querySelectorAll('.reveal').forEach(el => observer.observe(el));

function animateOutHome(callback) {
    const homeView = document.getElementById('view-home');
    if (homeView && homeView.classList.contains('active')) {
        const reveals = homeView.querySelectorAll('.reveal');
        reveals.forEach(rev => {
            rev.classList.remove('active');
            rev.classList.add('exit-active');
        });
        setTimeout(() => {
            reveals.forEach(rev => {
                rev.classList.remove('exit-active');
            });
            callback();
        }, 600);
    } else {
        callback();
    }
}

function initAnimations() {
    setTimeout(() => {
        document.body.classList.add('loaded');
        showToast();
    }, 150);
}

function showToast(msg, isError = false, duration = 3000) {
    const isErr = isError === true || isError === 'error' || isError === 'warning' || (typeof msg === 'string' && (msg.toLowerCase().includes('error') || msg.toLowerCase().includes('wrong') || msg.toLowerCase().includes('incorrect') || msg.toLowerCase().includes('failed') || msg.toLowerCase().includes('denied')));
    if (isErr) {
        if (typeof window.triggerSound === 'function') {
            window.triggerSound('ERROR');
        }
    }
    const toast = document.getElementById('toast');
    if (toast) {
        toast.style.zIndex = '10000000';
        toast.style.position = 'fixed';
        const titleEl = toast.querySelector('.toast-title');
        const descEl = toast.querySelector('.toast-desc');
        const iconContainer = toast.querySelector('.toast-icon');

        // Determine if we should use the premium App Lock dark mode styling
        const isLockScreenActive = document.getElementById('app-lock-screen') &&
            document.getElementById('app-lock-screen').style.display === 'flex';
        const isAuthModalActive = document.getElementById('app-auth-modal') &&
            document.getElementById('app-auth-modal').style.display === 'flex';

        const useDarkSecurityTheme = isErr || isLockScreenActive || isAuthModalActive;

        if (msg) {
            if (titleEl) titleEl.innerText = isError ? "Security Alert" : "System Notification";
            if (descEl) descEl.innerText = msg;

            if (useDarkSecurityTheme) {
                if (isError) {
                    // Premium Glassmorphic Red Warning Style (Distinct from dark panel)
                    toast.style.background = 'linear-gradient(135deg, rgba(141, 10, 36, 0.95), rgba(76, 5, 25, 0.98))';
                    toast.style.borderColor = 'rgba(244, 63, 94, 0.5)';
                    toast.style.boxShadow = '0 15px 40px rgba(244, 63, 94, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.15)';
                    toast.style.color = '#ffffff';
                    if (titleEl) {
                        titleEl.style.color = '#ffe4e6';
                        titleEl.innerText = "SECURITY ALERT";
                    }
                    if (descEl) descEl.style.color = 'rgba(255, 255, 255, 0.85)';
                    if (iconContainer) {
                        iconContainer.style.background = 'rgba(244, 63, 94, 0.2)';
                        iconContainer.style.boxShadow = 'none';
                        iconContainer.innerHTML = '<span class="material-symbols-outlined" style="color: #fda4af; font-size: 20px;">gpp_bad</span>';
                    }
                } else {
                    // Premium Glassmorphic Green Success Style (Distinct from dark panel)
                    toast.style.background = 'linear-gradient(135deg, rgba(6, 95, 70, 0.95), rgba(4, 78, 64, 0.98))';
                    toast.style.borderColor = 'rgba(52, 211, 153, 0.5)';
                    toast.style.boxShadow = '0 15px 40px rgba(16, 185, 129, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.15)';
                    toast.style.color = '#ffffff';
                    if (titleEl) {
                        titleEl.style.color = '#d1fae5';
                        titleEl.innerText = "ACCESS CONTROL";
                    }
                    if (descEl) descEl.style.color = 'rgba(255, 255, 255, 0.85)';
                    if (iconContainer) {
                        iconContainer.style.background = 'rgba(52, 211, 153, 0.2)';
                        iconContainer.style.boxShadow = 'none';
                        iconContainer.innerHTML = '<span class="material-symbols-outlined" style="color: #a7f3d0; font-size: 20px;">verified_user</span>';
                    }
                }
            } else {
                // Standard Light Style
                toast.style.borderColor = '';
                toast.style.background = '';
                toast.style.boxShadow = '';
                toast.style.color = '';
                if (titleEl) titleEl.style.color = '';
                if (descEl) descEl.style.color = '';
                if (iconContainer) {
                    iconContainer.style.background = '';
                    iconContainer.style.boxShadow = '';
                    iconContainer.innerHTML = '<i data-lucide="sparkles" style="color: #70e000;"></i>';
                    if (window.lucide) window.lucide.createIcons();
                }
            }
        } else {
            // Default values if called without message (e.g. startup toast)
            toast.style.borderColor = '';
            toast.style.background = '';
            toast.style.boxShadow = '';
            toast.style.color = '';
            if (titleEl) {
                titleEl.style.color = '';
                titleEl.innerText = "Ecosystem Initialized";
            }
            if (descEl) {
                descEl.style.color = '';
                descEl.innerText = "Premium console ready for physical navigation";
            }
            if (iconContainer) {
                iconContainer.style.background = '';
                iconContainer.style.boxShadow = '';
                iconContainer.innerHTML = '<i data-lucide="sparkles"></i>';
                if (window.lucide) window.lucide.createIcons();
            }
        }

        toast.classList.add('show');

        if (toast.dismissTimer) clearTimeout(toast.dismissTimer);
        toast.dismissTimer = setTimeout(() => {
            toast.classList.remove('show');
        }, duration);

        if (!toast.hasClickListener) {
            toast.addEventListener('click', () => {
                clearTimeout(toast.dismissTimer);
                toast.classList.remove('show');
            });
            toast.hasClickListener = true;
        }
    }
}

// Expose showToast globally so window.pop (core.js) can call it across module boundaries
window.showToast = showToast;

if (document.readyState === 'complete') {
    initAnimations();
} else {
    window.addEventListener('load', initAnimations);
}



// ── TIER ACCESS HELPER FUNCTIONS ──
window.getRequiredPlanForTemplate = function (slug) {
    const s = String(slug || '').toLowerCase();
    const resolved = (window.COSMO_ALIAS_MAP && window.COSMO_ALIAS_MAP[s]) || s;
    // Always return the LOWEST plan tier that unlocks the feature:
    // National Identity (in Catalyst, Matrix, Quantum) -> Catalyst (lowest)
    if (resolved === 'national-identity') return 'catalyst';
    // Encrypted Notebook (in Matrix, Quantum) -> Matrix (lowest)
    if (resolved === 'encrypted-partitions') return 'matrix';
    // Identity Vault (in Quantum) -> Quantum
    if (resolved === 'identity-vault') return 'quantum';
    return 'element';
};

window.getPlanRank = function (planName) {
    const p = String(planName || 'element').toLowerCase();
    const map = {
        'element': 0, 'foundation': 0, 'normal': 0,
        'catalyst': 1, 'velocity': 1, 'max': 1,
        'matrix': 2, 'pro': 2,
        'quantum': 3, 'ultra': 3
    };
    return map[p] !== undefined ? map[p] : 0;
};

window.checkTemplateAccess = function (slug) {
    const reqPlan = window.getRequiredPlanForTemplate(slug);
    if (reqPlan === 'element') return { allowed: true, requiredPlan: 'element' };

    let userPlan = 'element';
    if (typeof window.CosmoCryptSubscription !== 'undefined' && typeof window.CosmoCryptSubscription.getActivePlan === 'function') {
        userPlan = window.CosmoCryptSubscription.getActivePlan();
    } else if (typeof window.cosmoSubscription !== 'undefined' && typeof window.cosmoSubscription.getActivePlan === 'function') {
        userPlan = window.cosmoSubscription.getActivePlan();
    } else {
        userPlan = localStorage.getItem('user_subscription') || 'element';
    }

    const userRank = window.getPlanRank(userPlan);
    const reqRank = window.getPlanRank(reqPlan);

    if (userRank >= reqRank) {
        return { allowed: true, requiredPlan: reqPlan, userPlan };
    }
    return { allowed: false, requiredPlan: reqPlan, userPlan };
};

window.showPremiumUnlockModal = function (requiredPlan, featureName, descriptionText) {
    if (window.SessionProtocolParent) {
        window.SessionProtocolParent.hideOverlay();
    }
    const getItemFn = (typeof window !== 'undefined' && window.originalGetItem) ? window.originalGetItem : Storage.prototype.getItem;
    // Check if user is logged in or has saved session (Firebase Auth, userStoreEnc, or window.userData)
    const user = (window.suiteAuth && window.suiteAuth.currentUser) || (window.auth && window.auth.currentUser);
    const hasSavedSession = !!(user || sessionStorage.getItem('userStoreEnc') || getItemFn.call(localStorage, 'userStoreEnc') || window.userData);

    if (!hasSavedSession) {
        let hasPlanRecorded = false;
        try {
            const history = window._cosmoPurchaseHistoryState || (window.userData && window.userData.subscription_history) || (window.parent && window.parent._cosmoPurchaseHistoryState);
            if (Array.isArray(history) && history.length > 0) {
                const activeItem = history.find(item => item.planName && item.planName !== 'Foundation' && item.planName !== 'normal' && new Date(item.expiryDate) > new Date());
                if (activeItem) hasPlanRecorded = true;
            }
        } catch (e) { }

        if (!hasPlanRecorded) {
            try {
                const enc = (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('cosmocrypt_sub_enc') : null) || getItemFn.call(localStorage, 'cosmocrypt_sub_enc');
                if (enc) {
                    const b = CryptoJS.AES.decrypt(enc, _getAppSecret());
                    const obj = JSON.parse(b.toString(CryptoJS.enc.Utf8));
                    const now = Date.now();
                    const exMs = obj.expiresAtMs || 0;
                    const isActive = (obj.plan === 'foundation' || obj.plan === 'normal') ? false : (exMs > now && obj.status === 'active');
                    if (isActive) hasPlanRecorded = true;
                }
            } catch (e) { }
        }

        if (!hasPlanRecorded) {
            const subInstance = window.CosmoCryptSubscription || window.cosmoSubscription;
            if (subInstance && typeof subInstance.hadPremiumPlan === 'function') {
                if (subInstance.hadPremiumPlan()) hasPlanRecorded = true;
            } else if (localStorage.getItem('had_premium_plan') === 'true') {
                hasPlanRecorded = true;
            }
        }

        if (hasPlanRecorded) {
            window.openPremiumLoginModal(descriptionText);
            return;
        }
    }

    const modal = document.getElementById('premium-unlock-modal');
    if (!modal) return;

    const titleEl = document.getElementById('premium-unlock-title');
    const descEl = document.getElementById('premium-unlock-desc');
    const upgradeBtn = document.getElementById('premium-upgrade-btn');
    const badgeEl = document.getElementById('premium-unlock-badge');
    const iconEl = document.getElementById('premium-unlock-icon');

    const normReq = String(requiredPlan || 'CATALYST').toUpperCase();

    if (upgradeBtn) {
        if (normReq.startsWith('LIMIT_EXCEEDED_ULTRA')) {
            upgradeBtn.style.display = 'none';
        } else {
            upgradeBtn.style.display = 'block';
            if (normReq.includes('CATALYST')) {
                upgradeBtn.innerText = 'Upgrade to Catalyst Plan';
                upgradeBtn.style.background = 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)';
            } else if (normReq.includes('MATRIX')) {
                upgradeBtn.innerText = 'Upgrade to Matrix Plan';
                upgradeBtn.style.background = 'linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)';
            } else if (normReq.includes('QUANTUM')) {
                upgradeBtn.innerText = 'Upgrade to Quantum Plan';
                upgradeBtn.style.background = 'linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)';
            } else {
                upgradeBtn.innerText = 'Upgrade Plan Now';
                upgradeBtn.style.background = 'linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)';
            }
        }
    }

    if (titleEl) {
        if (normReq.includes('CATALYST')) {
            titleEl.innerText = `CATALYST PLAN REQUIRED`;
            titleEl.style.background = 'linear-gradient(135deg, #fdba74 0%, #ea580c 100%)';
        } else if (normReq.includes('MATRIX')) {
            titleEl.innerText = `MATRIX PLAN REQUIRED`;
            titleEl.style.background = 'linear-gradient(135deg, #c084fc 0%, #a855f7 100%)';
        } else if (normReq.includes('QUANTUM')) {
            titleEl.innerText = `QUANTUM PLAN REQUIRED`;
            titleEl.style.background = 'linear-gradient(135deg, #fca5a5 0%, #ef4444 100%)';
        } else {
            titleEl.innerText = `${normReq} REQUIRED`;
            titleEl.style.background = 'linear-gradient(135deg, #c084fc 0%, #a855f7 100%)';
        }
        titleEl.style.webkitBackgroundClip = 'text';
        titleEl.style.webkitTextFillColor = 'transparent';
    }

    if (badgeEl) {
        if (normReq.startsWith('LIMIT_EXCEEDED')) {
            badgeEl.innerText = `Usage Limit Reached`;
        } else if (normReq.includes('CATALYST')) {
            badgeEl.innerText = `Catalyst Elevation Required`;
            badgeEl.style.color = '#f97316';
        } else if (normReq.includes('MATRIX')) {
            badgeEl.innerText = `Matrix Elevation Required`;
            badgeEl.style.color = '#a855f7';
        } else if (normReq.includes('QUANTUM')) {
            badgeEl.innerText = `Quantum Elevation Required`;
            badgeEl.style.color = '#ef4444';
        } else {
            badgeEl.innerText = `Premium Plan Required`;
            badgeEl.style.color = '#a855f7';
        }
    }

    if (iconEl) {
        if (normReq.includes('CATALYST')) {
            iconEl.innerText = 'bolt';
            iconEl.style.color = '#f97316';
        } else if (normReq.includes('MATRIX')) {
            iconEl.innerText = 'auto_awesome';
            iconEl.style.color = '#c084fc';
        } else if (normReq.includes('QUANTUM')) {
            iconEl.innerText = 'diamond';
            iconEl.style.color = '#ef4444';
        }
    }

    if (descEl) {
        if (descriptionText) {
            descEl.innerText = descriptionText;
        } else if (normReq.includes('CATALYST')) {
            descEl.innerText = 'The National Identity (India) template is exclusive to Catalyst Plan and higher. Upgrade to Catalyst to instantly unlock government identity & verification tools.';
        } else if (normReq.includes('MATRIX')) {
            descEl.innerText = 'The Encrypted Notebook template is exclusive to Matrix Plan and higher. Upgrade to Matrix to instantly unlock encrypted note storage & system-level access keys.';
        } else if (normReq.includes('QUANTUM')) {
            descEl.innerText = 'The Personal Documents Vault (Identity Vault) is exclusive to Quantum Plan. Upgrade to Quantum to unlock all templates and enterprise-grade multi-device vault synchronization.';
        } else {
            descEl.innerText = 'Upgrade your plan to access this exclusive template and high-capacity vault storage.';
        }
    }

    modal.style.display = 'flex';

    // Push history state to intercept Android back button
    if (window.history && window.history.pushState) {
        window.history.pushState({ modalId: 'premium-unlock', premiumModalOpen: true }, "");
    }
};

window.closePremiumUnlockModal = function (fromPopState = false) {
    const modal = document.getElementById('premium-unlock-modal');
    if (modal) modal.style.display = 'none';

    // Restore landing page panels if user remains on the active home screen
    const homeView = document.getElementById('view-home');
    if (homeView && homeView.classList.contains('active')) {
        const reveals = homeView.querySelectorAll('.reveal');
        reveals.forEach(rev => {
            rev.classList.remove('exit-active');
            rev.classList.remove('active');
            void rev.offsetWidth; // Force reflow
            rev.classList.add('active');
        });
    }

    // Pop history state if closed manually (not via popstate)
    if (!fromPopState) {
        if (window.history && window.history.state && window.history.state.modalId === 'premium-unlock') {
            window.history.back();
        }
    }
};

window.upgradePremiumAction = function () {
    window.closePremiumUnlockModal(true);
    if (typeof switchView === 'function') {
        switchView('subscription');
    }
};

window.openPremiumLoginModal = function (descriptionText) {
    if (typeof window.dismissGoogleOneTap === 'function') {
        window.dismissGoogleOneTap();
    }
    if (window.SessionProtocolParent) {
        window.SessionProtocolParent.hideOverlay();
    }
    const modal = document.getElementById('premium-login-modal');
    if (!modal) return;
    const descEl = document.getElementById('premium-login-desc');
    if (descEl && descriptionText) {
        descEl.innerText = `You have a premium plan recorded on this device, but you are not logged in. Please sign in to verify your account and use this feature.`;
    }
    modal.style.display = 'flex';

    // Push history state to intercept Android back button
    if (window.history && window.history.pushState) {
        window.history.pushState({ modalId: 'premium-login', premiumModalOpen: true }, "");
    }
};

window.closePremiumLoginModal = function (fromPopState = false) {
    const modal = document.getElementById('premium-login-modal');
    if (modal) modal.style.display = 'none';

    // Restore landing page panels if user remains on the active home screen
    const homeView = document.getElementById('view-home');
    if (homeView && homeView.classList.contains('active')) {
        const reveals = homeView.querySelectorAll('.reveal');
        reveals.forEach(rev => {
            rev.classList.remove('exit-active');
            rev.classList.remove('active');
            void rev.offsetWidth; // Force reflow
            rev.classList.add('active');
        });
    }

    // Pop history state if closed manually (not via popstate)
    if (!fromPopState) {
        if (window.history && window.history.state && window.history.state.modalId === 'premium-login') {
            window.history.back();
        }
    }
};

window.loginPremiumAction = function () {
    window.closePremiumLoginModal(true);
    if (typeof switchView === 'function') {
        switchView('login');
    }
};

function getHeadInjections(savedSession, matchedSlug) {
    let headInjections = '';
    const isSessionActive = sessionStorage.getItem('__cosmo_session_active') === 'true';
    const sessionToken = sessionStorage.getItem('__cc_session_token') || '';
    const hasUser = (window.userData && (window.userData.uid || window.userData.email)) ||
                    (window.suiteAuth && window.suiteAuth.currentUser) ||
                    (isSessionActive && savedSession);

    headInjections += `<script>try {
        ${savedSession ? `sessionStorage.setItem('userStoreEnc', '${savedSession}');` : ''}
        ${isSessionActive ? `sessionStorage.setItem('__cosmo_session_active', 'true');` : ''}
        ${sessionToken ? `sessionStorage.setItem('__cc_session_token', '${sessionToken}');` : ''}
        ${hasUser ? `document.documentElement.classList.add('profile-redirect');` : ''}
        localStorage.removeItem('userStoreEnc');
    } catch(e) {}<\/script>`;

    if (hasUser) {
        headInjections += `<style>
            html.profile-redirect #loginPanel { display: none !important; }
            html.profile-redirect .sidebar-left { display: flex !important; }
        </style>`;
    }

    headInjections += `
            <script>
            (function() {
                function shouldSuppress(msg, src) {
                    if (!msg && !src) return false;
                    var str = typeof msg === 'string' ? msg : (msg && msg.message ? msg.message : '');
                    return str.indexOf('Invalid URI scheme in origin: about') !== -1 ||
                           str.indexOf('fireauth is not defined') !== -1 ||
                           (src && src.indexOf('__/auth/iframe') !== -1);
                }
                window.addEventListener('error', function(e) {
                    if (shouldSuppress(e.message, e.filename)) {
                        e.preventDefault();
                        e.stopPropagation();
                        return true;
                    }
                }, true);
                window.addEventListener('unhandledrejection', function(e) {
                    if (shouldSuppress(e.reason)) {
                        e.preventDefault();
                        e.stopPropagation();
                        return true;
                    }
                }, true);

                function syncMetaToTop() {
                    try {
                        var metaTheme = document.querySelector('meta[name="theme-color"]');
                        if (metaTheme && metaTheme.content && window.top && window.top.document) {
                            var topTheme = window.top.document.querySelector('meta[name="theme-color"]');
                            if (topTheme) topTheme.setAttribute('content', metaTheme.content);
                            var topBg = window.top.document.querySelector('meta[name="background-color"]');
                            if (topBg) topBg.setAttribute('content', metaTheme.content);
                        }
                    } catch(e) {}
                }
                syncMetaToTop();
                if (document.readyState === 'loading') {
                    document.addEventListener('DOMContentLoaded', syncMetaToTop);
                }

                // Emergency Panic Hotkey (Ctrl + Shift + Alt + P)
                window.addEventListener('keydown', function(e) {
                    if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.altKey && (e.key === 'P' || e.key === 'p' || e.code === 'KeyP')) {
                        e.preventDefault();
                        e.stopPropagation();

                        const sub = (localStorage.getItem('user_subscription') || localStorage.getItem('cosmo_user_plan') || localStorage.getItem('current_plan') || '').toLowerCase();
                        const isMatrixOrQuantum = sub.includes('matrix') || sub.includes('quantum') || sub.includes('pro') || sub.includes('ultra') || sub.includes('infinite') || sub.includes('lifetime');
                        if (!isMatrixOrQuantum) {
                            if (typeof showToast === 'function') {
                                showToast("Emergency Panic Wipe is an exclusive Matrix & Quantum feature. Please upgrade your plan.", "warning");
                            }
                            return;
                        }

                        if (window.CosmoDuress && typeof window.CosmoDuress.executePanicWipe === 'function') {
                            window.CosmoDuress.executePanicWipe();
                        } else if (typeof window.executePanicWipe === 'function') {
                            window.executePanicWipe();
                        } else if (typeof window.triggerPanicWipe === 'function') {
                            window.triggerPanicWipe();
                        } else if (window.parent && window.parent.CosmoDuress && typeof window.parent.CosmoDuress.executePanicWipe === 'function') {
                            window.parent.CosmoDuress.executePanicWipe();
                        } else if (window.parent && typeof window.parent.executePanicWipe === 'function') {
                            window.parent.executePanicWipe();
                        } else if (window.parent && typeof window.parent.triggerPanicWipe === 'function') {
                            window.parent.triggerPanicWipe();
                        }
                    }
                }, true);
            })();
            // window.APP_SECRET is obsolete
            window.addEventListener('app-shutdown', function() {
            });
            (function() {
                const originalGet = Storage.prototype.getItem;
                const originalSet = Storage.prototype.setItem;
                const originalRemove = Storage.prototype.removeItem;
                const keys = ['active_layer_mode', 'suite_sound_muted', 'suite_sound_volume', 'suite_typing_enabled', 'suite_typing_volume', 'suite_typing_tune', 'suite_bottom_nav_enabled', 'suite_bottom_nav_volume', 'nav_anim_enabled', 'session_protocol_enabled', 'fullscreen_on_click'];
                Storage.prototype.getItem = function(k) {
                    if (keys.includes(k)) return originalGet.call(this, 'mobile_' + k);
                    return originalGet.call(this, k);
                };
                Storage.prototype.setItem = function(k, v) {
                    if (keys.includes(k)) return originalSet.call(this, 'mobile_' + k, v);
                    return originalSet.call(this, k, v);
                };
                Storage.prototype.removeItem = function(k) {
                    if (keys.includes(k)) return originalRemove.call(this, 'mobile_' + k);
                    return originalRemove.call(this, k);
                };
            })();
            <\/script>
            <link href="https://fonts.googleapis.com/css2?family=Bricolage+Grotesque:opsz,wght@12..96,200..800&family=Inter:wght@400;500;600&family=Lato:wght@300;400;700;900&family=Lora:ital,wght@1,400;1,500;1,600;1,700&family=Merriweather:ital,wght@1,300;1,400;1,700&family=Montserrat:wght@300;400;500;600;700;800&family=Space+Grotesk:wght@500;600;700&display=swap" rel="stylesheet">
            <link href="https://cdn.cosmocrypt.com/vendor/fonts.css" rel="stylesheet">
            <style id="neural-fonts-stylesheet">
                html body.font-mode-1, html body.font-mode-1 *:not(.material-symbols-outlined) { font-family: 'Space Grotesk', sans-serif !important; font-style: normal !important; }
                html body.font-mode-2, html body.font-mode-2 *:not(.material-symbols-outlined) { font-family: 'Montserrat', sans-serif !important; font-style: normal !important; }
                html body.font-mode-3, html body.font-mode-3 *:not(.material-symbols-outlined) { font-family: 'Inter', sans-serif !important; font-style: normal !important; }
                html body.font-mode-4, html body.font-mode-4 *:not(.material-symbols-outlined) { font-family: 'Lato', sans-serif !important; font-style: normal !important; }
                html body.font-mode-5, html body.font-mode-5 *:not(.material-symbols-outlined) { font-family: 'Merriweather', serif !important; font-style: italic !important; }
                html body.font-mode-6, html body.font-mode-6 *:not(.material-symbols-outlined) { font-family: 'Lora', serif !important; font-style: italic !important; }
                html body.font-mode-7, html body.font-mode-7 *:not(.material-symbols-outlined) { font-family: 'Clash Display', sans-serif !important; font-style: normal !important; }
                html body.font-mode-8, html body.font-mode-8 *:not(.material-symbols-outlined) { font-family: 'Bricolage Grotesque', sans-serif !important; font-style: normal !important; }
            </style>`;

    const securityModules = [
        'node-infrastructure', 'financial-credentials', 'payment-gateways',
        'developer-endpoints', 'dns-management', 'workspace-integration',
        'merchant-identities', 'national-identity', 'identity-vault',
        'encrypted-partitions', 'system-encryption'
    ];

    if (securityModules.includes(matchedSlug)) {
        headInjections += `
                <script>
                (function() {
                    function checkUserLoggedIn() {
                        try {
                            if (localStorage.getItem('explicit_logout') === 'true') return false;
                            const userEnc = sessionStorage.getItem('userStoreEnc') || localStorage.getItem('userStoreEnc');
                            if (userEnc && userEnc.length > 20) return true;
                            const ud = window.userData || (window.parent && window.parent.userData);
                            if (ud && (ud.email || ud.uid || ud.isVerified || ud.name || ud.first || ud.userName || ud.displayName)) return true;
                            const pAuth = window.parent && (window.parent.suiteAuth || window.parent.auth);
                            if (pAuth && pAuth.currentUser && (pAuth.currentUser.email || pAuth.currentUser.uid)) return true;
                            const wAuth = (window.suiteAuth || window.auth);
                            if (wAuth && wAuth.currentUser && (wAuth.currentUser.email || wAuth.currentUser.uid)) return true;
                        } catch(e) {}
                        return false;
                    }

                    function initLoginBannerNotice() {
                        const isLoggedIn = checkUserLoggedIn();
                        let existingBanner = document.getElementById('cosmo-unauth-login-banner');
                        
                        if (isLoggedIn || sessionStorage.getItem('cosmo_unauth_banner_dismissed') === 'true') {
                            if (existingBanner) existingBanner.remove();
                            return;
                        }

                        if (!existingBanner) {
                            const banner = document.createElement('div');
                            banner.id = 'cosmo-unauth-login-banner';
                            banner.className = 'cosmo-unauth-banner-container';
                            banner.onclick = function(e) {
                                if (e) e.stopPropagation();
                                if (window.parent && typeof window.parent.switchView === 'function') {
                                    window.parent.switchView('account');
                                } else if (typeof switchView === 'function') {
                                    switchView('account');
                                } else {
                                    window.location.href = '/account';
                                }
                            };

                            banner.innerHTML = \`
                                <div class="cosmo-unauth-banner-content">
                                    <div class="cosmo-unauth-banner-left">
                                        <div class="cosmo-unauth-shield-icon">
                                            <span class="material-symbols-outlined">lock</span>
                                        </div>
                                        <div class="cosmo-unauth-text-group">
                                            <span class="cosmo-unauth-title">Saved Card Credentials & Secrets Are Locked</span>
                                            <span class="cosmo-unauth-subtitle">Login to your Account to view, unlock, and manage saved card credentials.</span>
                                        </div>
                                    </div>
                                    <div class="cosmo-unauth-banner-right">
                                        <div class="cosmo-unauth-action-btn">
                                            <span>Go to Account</span>
                                            <span class="material-symbols-outlined">arrow_forward</span>
                                        </div>
                                        <button type="button" class="cosmo-unauth-dismiss-btn" title="Dismiss" onclick="dismissUnauthBanner(event)">
                                            <span class="material-symbols-outlined">close</span>
                                        </button>
                                    </div>
                                </div>
                            \`;

                            window.dismissUnauthBanner = function(e) {
                                if (e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                                sessionStorage.setItem('cosmo_unauth_banner_dismissed', 'true');
                                const b = document.getElementById('cosmo-unauth-login-banner');
                                if (b) b.remove();
                            };

                            const style = document.createElement('style');
                            style.id = 'cosmo-unauth-banner-styles';
                            style.textContent = \`
                                .cosmo-unauth-banner-container {
                                    width: fit-content;
                                    max-width: calc(100% - 32px);
                                    margin: 10px auto 14px auto;
                                    padding: 10px 16px;
                                    box-sizing: border-box;
                                    background: linear-gradient(135deg, rgba(20, 24, 33, 0.96), rgba(15, 23, 42, 0.98));
                                    border: 1px solid rgba(245, 158, 11, 0.5);
                                    border-radius: 12px;
                                    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.15);
                                    backdrop-filter: blur(12px);
                                    -webkit-backdrop-filter: blur(12px);
                                    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
                                    position: relative;
                                    z-index: 999999;
                                    cursor: pointer;
                                }
                                .cosmo-unauth-banner-container:hover {
                                    border-color: rgba(245, 158, 11, 0.9);
                                    box-shadow: 0 10px 28px rgba(245, 158, 11, 0.3);
                                }
                                .cosmo-unauth-banner-content {
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    gap: 16px;
                                    user-select: none;
                                }
                                .cosmo-unauth-banner-left {
                                    display: flex;
                                    align-items: center;
                                    gap: 12px;
                                    min-width: 0;
                                }
                                .cosmo-unauth-banner-right {
                                    display: flex;
                                    align-items: center;
                                    gap: 10px;
                                    flex-shrink: 0;
                                }
                                .cosmo-unauth-shield-icon {
                                    width: 36px;
                                    height: 36px;
                                    border-radius: 8px;
                                    background: rgba(245, 158, 11, 0.15);
                                    border: 1px solid rgba(245, 158, 11, 0.35);
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    flex-shrink: 0;
                                }
                                .cosmo-unauth-shield-icon span {
                                    color: #fbbf24;
                                    font-size: 20px;
                                }
                                .cosmo-unauth-text-group {
                                    display: flex;
                                    flex-direction: column;
                                    gap: 2px;
                                    min-width: 0;
                                }
                                .cosmo-unauth-title {
                                    font-family: 'Space Grotesk', 'Inter', sans-serif;
                                    font-weight: 700;
                                    font-size: 14px;
                                    color: #fef08a;
                                }
                                .cosmo-unauth-subtitle {
                                    font-family: 'Inter', sans-serif;
                                    font-weight: 400;
                                    font-size: 12px;
                                    color: rgba(255, 255, 255, 0.85);
                                    line-height: 1.35;
                                }
                                .cosmo-unauth-action-btn {
                                    display: inline-flex;
                                    align-items: center;
                                    gap: 6px;
                                    padding: 6px 14px;
                                    background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
                                    color: #0f172a;
                                    font-family: 'Space Grotesk', 'Inter', sans-serif;
                                    font-weight: 700;
                                    font-size: 13px;
                                    border-radius: 7px;
                                    flex-shrink: 0;
                                    box-shadow: 0 4px 10px rgba(245, 158, 11, 0.3);
                                    transition: all 0.2s ease;
                                }
                                .cosmo-unauth-banner-container:hover .cosmo-unauth-action-btn {
                                    background: linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%);
                                }
                                .cosmo-unauth-action-btn span {
                                    font-size: 15px;
                                }
                                .cosmo-unauth-dismiss-btn {
                                    width: 28px;
                                    height: 28px;
                                    border-radius: 7px;
                                    border: 1px solid rgba(255, 255, 255, 0.18);
                                    background: rgba(255, 255, 255, 0.08);
                                    color: rgba(255, 255, 255, 0.75);
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                    cursor: pointer;
                                    transition: all 0.2s ease;
                                    flex-shrink: 0;
                                    padding: 0;
                                }
                                .cosmo-unauth-dismiss-btn:hover {
                                    background: rgba(239, 68, 68, 0.28);
                                    border-color: rgba(239, 68, 68, 0.55);
                                    color: #fca5a5;
                                }
                                .cosmo-unauth-dismiss-btn span {
                                    font-size: 17px;
                                }
                                @media (max-width: 768px) {
                                    .cosmo-unauth-banner-container {
                                        width: calc(100% - 24px);
                                        max-width: 380px;
                                        margin: 10px auto 12px auto;
                                        padding: 14px 14px 12px 14px;
                                        border-radius: 12px;
                                        position: relative;
                                    }
                                    .cosmo-unauth-banner-content {
                                        flex-direction: column;
                                        align-items: center;
                                        text-align: center;
                                        gap: 10px;
                                    }
                                    .cosmo-unauth-banner-left {
                                        flex-direction: column;
                                        align-items: center;
                                        text-align: center;
                                        gap: 8px;
                                        width: 100%;
                                    }
                                    .cosmo-unauth-shield-icon {
                                        width: 36px;
                                        height: 36px;
                                        margin: 0 auto;
                                    }
                                    .cosmo-unauth-shield-icon span {
                                        font-size: 20px;
                                    }
                                    .cosmo-unauth-text-group {
                                        align-items: center;
                                        text-align: center;
                                        gap: 4px;
                                        width: 100%;
                                    }
                                    .cosmo-unauth-title {
                                        font-size: 13px;
                                        text-align: center;
                                        white-space: normal;
                                        line-height: 1.3;
                                    }
                                    .cosmo-unauth-subtitle {
                                        font-size: 11px;
                                        text-align: center;
                                        white-space: normal;
                                        line-height: 1.35;
                                        color: rgba(255, 255, 255, 0.8);
                                    }
                                    .cosmo-unauth-banner-right {
                                        width: 100%;
                                        justify-content: center;
                                        margin-top: 2px;
                                    }
                                    .cosmo-unauth-action-btn {
                                        width: 100%;
                                        max-width: 220px;
                                        justify-content: center;
                                        padding: 7px 14px;
                                        font-size: 12px;
                                    }
                                    .cosmo-unauth-action-btn span {
                                        font-size: 14px;
                                    }
                                    .cosmo-unauth-dismiss-btn {
                                        position: absolute;
                                        top: 8px;
                                        right: 8px;
                                        width: 26px;
                                        height: 26px;
                                    }
                                    .cosmo-unauth-dismiss-btn span {
                                        font-size: 16px;
                                    }
                                }
                            \`;

                            if (!document.getElementById('cosmo-unauth-banner-styles')) {
                                document.head.appendChild(style);
                            }

                            const targetEl = document.querySelector('.main-content') || document.querySelector('.container') || document.querySelector('.app-container') || document.body;
                            if (targetEl.firstChild) {
                                targetEl.insertBefore(banner, targetEl.firstChild);
                            } else {
                                targetEl.appendChild(banner);
                            }
                        }
                    }

                    if (document.readyState === 'loading') {
                        document.addEventListener('DOMContentLoaded', initLoginBannerNotice);
                    } else {
                        initLoginBannerNotice();
                    }
                })();
                <\/script>`;
    }

    return headInjections;
}

let isSubPageActive = false;

let _cachedOfflinePageHtml = null;

async function fetchOfflineHtmlForIframe() {
    if (_cachedOfflinePageHtml) return _cachedOfflinePageHtml;
    try {
        const res = await fetch('/offline.html');
        if (res.ok) {
            _cachedOfflinePageHtml = await res.text();
            return _cachedOfflinePageHtml;
        }
    } catch (e) { }
    try {
        const res2 = await fetch('/offline');
        if (res2.ok) {
            _cachedOfflinePageHtml = await res2.text();
            return _cachedOfflinePageHtml;
        }
    } catch (e) { }
}

function syncTopThemeColorFromContent(content) {
    if (!content) return;
    const match = content.match(/<meta\s+name=["']theme-color["']\s+content=["']([^"']+)["']/i);
    if (match && match[1]) {
        const color = match[1];
        let metaTheme = document.querySelector('meta[name="theme-color"]');
        if (metaTheme) metaTheme.setAttribute('content', color);
        let metaBg = document.querySelector('meta[name="background-color"]');
        if (metaBg) metaBg.setAttribute('content', color);
    }
}

async function loadTemplateContentAndSetSrcdoc(iframe, templateId, matchedSlug) {
    let templateEl = document.getElementById(templateId);

    // ⚡ Fast-Path: If template script is already in DOM, inject synchronously to avoid 0ms blank glitch
    if (templateEl && templateEl.textContent && templateEl.textContent.trim().length > 0) {
        let templateContent = templateEl.textContent
            .split('MATCH_CLOSING_SCRIPT').join('</' + 'script>')
            .split('MATCH_CLOSING_BODY').join('</' + 'body>')
            .split('MATCH_CLOSING_HTML').join('</' + 'html>');

        const savedSession = sessionStorage.getItem('userStoreEnc') || localStorage.getItem('userStoreEnc');
        if (templateContent.includes('<head>')) {
            let headInjections = getHeadInjections(savedSession, matchedSlug);
            templateContent = templateContent.replace('<head>', '<head>' + headInjections);
        }
        iframe.srcdoc = templateContent;
        iframe.onload = () => {
            try {
                if (window.userData && iframe.contentWindow) {
                    iframe.contentWindow.userData = window.userData;
                    iframe.contentWindow.postMessage({ type: 'login-success', isLoggedIn: true, user: window.userData }, '*');
                    if (typeof iframe.contentWindow.switchToProfilePanel === 'function') {
                        iframe.contentWindow.switchToProfilePanel(window.userData);
                    }
                    if (typeof iframe.contentWindow.updateAllSettingsAuthCards === 'function') {
                        iframe.contentWindow.updateAllSettingsAuthCards();
                    }
                    if (typeof iframe.contentWindow.updateUserLoginStatusCard === 'function') {
                        iframe.contentWindow.updateUserLoginStatusCard();
                    }
                }
            } catch (e) { }
        };
        syncTopThemeColorFromContent(templateContent);
        return;
    }

    try {
        const cleanSlug = matchedSlug.replace(/-template$/, '');
        const response = await fetch(`/templates/${cleanSlug}.html?t=` + Date.now());
        if (response.ok) {
            const htmlContent = await response.text();
            if (!templateEl) {
                templateEl = document.createElement('script');
                templateEl.type = 'text/plain';
                templateEl.id = templateId;
                document.body.appendChild(templateEl);
            }
            templateEl.textContent = htmlContent;

            let templateContent = htmlContent
                .split('MATCH_CLOSING_SCRIPT').join('</' + 'script>')
                .split('MATCH_CLOSING_BODY').join('</' + 'body>')
                .split('MATCH_CLOSING_HTML').join('</' + 'html>');

            const savedSession = sessionStorage.getItem('userStoreEnc') || localStorage.getItem('userStoreEnc');
            if (templateContent.includes('<head>')) {
                let headInjections = getHeadInjections(savedSession, matchedSlug);
                templateContent = templateContent.replace('<head>', '<head>' + headInjections);
            }
            iframe.srcdoc = templateContent;
            iframe.onload = () => {
                try {
                    if (window.userData && iframe.contentWindow) {
                        iframe.contentWindow.userData = window.userData;
                        iframe.contentWindow.postMessage({ type: 'login-success', isLoggedIn: true, user: window.userData }, '*');
                        if (typeof iframe.contentWindow.switchToProfilePanel === 'function') {
                            iframe.contentWindow.switchToProfilePanel(window.userData);
                        }
                        if (typeof iframe.contentWindow.updateAllSettingsAuthCards === 'function') {
                            iframe.contentWindow.updateAllSettingsAuthCards();
                        }
                        if (typeof iframe.contentWindow.updateUserLoginStatusCard === 'function') {
                            iframe.contentWindow.updateUserLoginStatusCard();
                        }
                    }
                } catch (e) { }
            };
            syncTopThemeColorFromContent(templateContent);
            return;
        }
    } catch (e) {
        console.error("Failed to fetch template on-demand:", matchedSlug, e);
    }
    const offlineHtml = await fetchOfflineHtmlForIframe();
    iframe.srcdoc = offlineHtml;
}

/* --- SPA SWITCH VIEW ENGINE (INDEX STYLE CONDITIONAL LOGIC) --- */
function switchView(view, pushHistoryState = true, groupNum = null) {
    if (!window.switchView || !window.switchView.__wrappedForThemeColor) {
        window.switchView = switchView;
    }
    if (!view) return false;

    // Cancel App Lock Suggestion timer if navigating away from homepage
    if (window._appLockSuggestionTimer) {
        clearTimeout(window._appLockSuggestionTimer);
        window._appLockSuggestionTimer = null;
    }

    let groupTab = groupNum;
    if (typeof pushHistoryState === 'number') {
        groupTab = pushHistoryState;
        pushHistoryState = true;
    }

    const v = view.toLowerCase();

    if (v === 'landing' || v === 'home' || v === '#home' || v === '#landing') {
        closeSPA(false, true);
        return true;
    }

    if (v === 'privacy' && groupTab) {
        if (typeof window.openPrivacyGroup === 'function') {
            window.openPrivacyGroup(groupTab);
            return true;
        }
    }

    // If navigating to subscription view, close the premium unlock modal
    if (v === 'subscription' || v === 'plan and upgrade.html' || v === 'subscription-mobile.html' || v === '#pro-tier') {
        if (typeof closePremiumUnlockModal === 'function') {
            closePremiumUnlockModal(true);
        }
    }

    // Deactivate and hide session overlay immediately for login and subscription views
    if (
        v === 'login' || v === 'login.html' ||
        v === 'subscription' || v === 'plan and upgrade.html' || v === 'subscription-mobile.html' || v === '#pro-tier'
    ) {
        if (window.SessionProtocolParent) {
            window.SessionProtocolParent.hideOverlay();
        }
    }

    // Persist the current view state in sessionStorage (Zero LocalStorage)
    window._currentSuiteViewState = view;
    try {
        sessionStorage.setItem('current_suite_view', view);
        localStorage.removeItem('current_suite_view');
    } catch (e) { }

    let matchedSlug = window.COSMO_ALIAS_MAP[v] || (window.COSMO_PAGES.includes(v) ? v : null);
    if (!matchedSlug) {
        matchedSlug = '404';
    }
    const isProtected = (matchedSlug && window.COSMO_PROTECTED_PAGES && window.COSMO_PROTECTED_PAGES.includes(matchedSlug)) ? true : false;

    if (window._0x83e2 && window._0x83e2.config && window._0x83e2.config.enabled && isProtected && !window._0x83e2._0x2k8f) {
        let lockScreen = document.getElementById('app-lock-screen');
        if (!lockScreen && window.parent && window.parent.document) {
            lockScreen = window.parent.document.getElementById('app-lock-screen');
        }
        if (!lockScreen) {
            console.error("SECURITY BREACH: Lock screen missing. Halting session.");
            if (typeof closeSPA === 'function') {
                closeSPA();
            } else if (window.parent && typeof window.parent.closeSPA === 'function') {
                window.parent.closeSPA();
            } else {
                switchView('landing');
            }
            return false;
        }

        window._0x83e2._0x1b7d = view;
        if (pushHistoryState) {
            let targetUrl = '/';
            if (matchedSlug === 'about') {
                targetUrl = '/';
            } else if (matchedSlug === 'landing' || v === 'landing' || v === 'home') {
                targetUrl = '/home';
            } else if (matchedSlug === 'notif') {
                targetUrl = '/alerts';
            } else if (matchedSlug) {
                targetUrl = '/' + matchedSlug;
            }
            try { history.replaceState({ spaView: view }, '', targetUrl); } catch (e) { }
        }
        if (lockScreen.style.display !== 'flex') {
            window._0x83e2.setLockState(true);
        }
        return true;
    }

    let templateId = '';
    let viewId = '';
    let frameId = '';

    if (matchedSlug) {
        const accessCheck = window.checkTemplateAccess(matchedSlug);
        if (!accessCheck.allowed) {
            window.showPremiumUnlockModal(accessCheck.requiredPlan.toUpperCase());
            return false;
        }
        templateId = `${matchedSlug}-template`;
        viewId = `view-${matchedSlug}`;
        frameId = `${matchedSlug}-frame`;
    }

    if (templateId) {
        if (pushHistoryState) {
            let targetUrl = '/';
            if (matchedSlug === 'about') {
                targetUrl = '/';
            } else if (matchedSlug === 'landing' || v === 'landing' || v === 'home') {
                targetUrl = '/home';
            } else if (matchedSlug === 'notif') {
                targetUrl = '/alerts';
            } else if (matchedSlug) {
                targetUrl = '/' + matchedSlug;
            }
            if (history.state && (history.state.modalOpen || history.state.premiumModalOpen || history.state.privacyModalOpen || history.state.appLockSuggestionModalOpen)) {
                history.replaceState({ spaView: view }, '', targetUrl);
            } else if (history.state && history.state.spaView === view) {
                history.replaceState({ spaView: view }, '', targetUrl);
            } else {
                history.pushState({ spaView: view }, '', targetUrl);
            }
        } else {
            let targetUrl = '/';
            if (matchedSlug === 'about') {
                targetUrl = '/';
            } else if (matchedSlug === 'landing' || v === 'landing' || v === 'home') {
                targetUrl = '/home';
            } else if (matchedSlug === 'notif') {
                targetUrl = '/alerts';
            } else if (matchedSlug) {
                targetUrl = '/' + matchedSlug;
            }
            try {
                history.replaceState({ spaView: view }, '', targetUrl);
            } catch (e) { }
        }
        isSubPageActive = true;

        let viewEl = document.getElementById(viewId);
        if (!viewEl) {
            viewEl = document.createElement('div');
            viewEl.id = viewId;
            viewEl.className = 'view-layer';
            viewEl.style.cssText = 'position: fixed; top: 0; bottom: 0; left: 0; right: 0; z-index: 20000; background: var(--bg-deep); border: none; overflow: hidden; display: none;';

            const iframe = document.createElement('iframe');
            iframe.id = frameId;
            iframe.style.cssText = 'width: 100%; height: 100%; border: none; display: block;';

            iframe.setAttribute('allow', 'fullscreen; clipboard-read; clipboard-write');

            iframe.addEventListener('load', () => {
                if (typeof window.installStorageSecurity === 'function') {
                    try { window.installStorageSecurity(iframe.contentWindow); } catch (e) { }
                }
                if (typeof window.syncActiveFontToIframe === 'function') {
                    window.syncActiveFontToIframe(iframe);
                }
                try {
                    if (iframe.contentWindow) {
                        if (window.userData) iframe.contentWindow.userData = window.userData;
                        const telem = window._cosmoPdfTelemetryState || (window.userData && window.userData.pdf_telemetry);
                        if (telem) {
                            iframe.contentWindow._cosmoPdfTelemetryState = telem;
                            if (typeof iframe.contentWindow.updateAnalyticsPdfDownloadsCount === 'function') {
                                iframe.contentWindow.updateAnalyticsPdfDownloadsCount(
                                    telem.downloads_count || 0,
                                    telem.encrypted_downloads_count || 0
                                );
                            }
                        }
                    }
                } catch (e) { }
                try {
                    const handleIframeCtrlK = (e) => {
                        if ((e.ctrlKey || e.metaKey) && (e.key.toLowerCase() === 'k' || e.code === 'KeyK' || e.keyCode === 75)) {
                            e.preventDefault();
                            e.stopPropagation();
                            e.stopImmediatePropagation();
                            if (typeof window.toggleCosmoSearch === 'function') {
                                window.toggleCosmoSearch();
                            } else if (typeof window.openCosmoSearch === 'function') {
                                window.openCosmoSearch();
                            }
                            return false;
                        }
                    };
                    if (iframe.contentWindow) iframe.contentWindow.addEventListener('keydown', handleIframeCtrlK, true);
                    if (iframe.contentDocument) iframe.contentDocument.addEventListener('keydown', handleIframeCtrlK, true);
                } catch (e) { }
            });

            loadTemplateContentAndSetSrcdoc(iframe, templateId, matchedSlug);

            viewEl.appendChild(iframe);
            document.body.appendChild(viewEl);
        } else {
            const iframe = document.getElementById(frameId);
            if (iframe && !iframe.srcdoc) {
                if (!iframe.__hasTelemetryLoadListener) {
                    iframe.__hasTelemetryLoadListener = true;
                    iframe.addEventListener('load', () => {
                        try {
                            if (iframe.contentWindow) {
                                if (window.userData) iframe.contentWindow.userData = window.userData;
                                const telem = window._cosmoPdfTelemetryState || (window.userData && window.userData.pdf_telemetry);
                                if (telem) {
                                    iframe.contentWindow._cosmoPdfTelemetryState = telem;
                                    if (typeof iframe.contentWindow.updateAnalyticsPdfDownloadsCount === 'function') {
                                        iframe.contentWindow.updateAnalyticsPdfDownloadsCount(
                                            telem.downloads_count || 0,
                                            telem.encrypted_downloads_count || 0
                                        );
                                    }
                                }
                            }
                        } catch (e) { }
                    });
                }
                loadTemplateContentAndSetSrcdoc(iframe, templateId, matchedSlug);
            }
        }

        // Deactivate all view layers and explicitly hide them to override inline styles
        // ── LAZY FREEZE: Stop background scripts in non-active iframes ──
        document.querySelectorAll('.view-layer').forEach(view => {
            view.classList.remove('active');
            view.style.display = 'none';
            // Clear srcdoc of non-active iframes to kill all running JS (timers, listeners, animations)
            // Template will reload from DOM <script type="text/plain"> on next visit (no network refetch)
            if (view.id !== viewId) {
                const iframeEl = view.querySelector('iframe');
                if (iframeEl && iframeEl.srcdoc) {
                    iframeEl.srcdoc = '';
                }
            }
        });

        viewEl.classList.add('active');
        viewEl.style.display = 'block'; // Force display: block for full-screen fixed view

        // Ensure active font is synced to the iframe immediately upon switching
        const activeIframe = document.getElementById(frameId);
        if (activeIframe) {
            if (typeof window.syncActiveFontToIframe === 'function') {
                window.syncActiveFontToIframe(activeIframe);
            }
        }

        return true;
    }
    return false;
}

window.closeSPA = function (fromPopState = false, forceLanding = false) {
    isSubPageActive = false;

    window._currentSuiteViewState = 'landing';
    try {
        sessionStorage.setItem('current_suite_view', 'landing');
        localStorage.removeItem('current_suite_view');
    } catch (e) { }

    const viewLayers = document.querySelectorAll('.view-layer');

    viewLayers.forEach(view => {
        view.classList.remove('active');
        view.style.display = 'none';
        view.style.zIndex = '20000';
    });

    // Remove any hide-style injected into head
    try {
        const hideStyle = document.getElementById('landing-overlay-hide-style');
        if (hideStyle) hideStyle.remove();
    } catch(e) {}

    // Restore Landing Page Overlay
    const landingOverlay = document.getElementById('landing-page-overlay');
    if (landingOverlay) {
        landingOverlay.style.display = 'block';
        landingOverlay.style.opacity = '1';
        const video = document.getElementById('landing-hero-video');
        if (video) {
            try { video.play().catch(() => { }); } catch (e) { }
        }
    }

    if (typeof window.updateLandingPersonalization === 'function') {
        try { window.updateLandingPersonalization(); } catch (e) { }
    }
    const homeView = document.getElementById('view-home');
    if (homeView) {
        homeView.classList.add('active');
        homeView.style.display = 'block';
        // Trigger entry animation again
        const reveals = homeView.querySelectorAll('.reveal');
        reveals.forEach(rev => {
            rev.classList.remove('exit-active');
            rev.classList.remove('active');
            void rev.offsetWidth;
            rev.classList.add('active');
        });
    }

    // Clean up dynamic frames to release memory and stop all background scripts
    document.querySelectorAll('.view-layer iframe').forEach(iframe => {
        if (iframe.srcdoc) {
            iframe.srcdoc = '';
        }
    });

    if (!fromPopState) {
        try { window.history.replaceState(null, '', '/home'); } catch(e) {}
    }
    if (typeof window.triggerAppLockSuggestionTimer === 'function') {
        window.triggerAppLockSuggestionTimer();
    }
};

window.navigateToConsole = function () {
    if (typeof window.switchView === 'function') {
        window.switchView('console');
    }
};

window.openMainPrivacyPolicy = function (origin, sectionId) {
    switchView('privacy');
    const targetSection = sectionId || 'privacy-section';
    const checkFrame = () => {
        const privacyFrame = document.getElementById('privacy-frame');
        if (privacyFrame) {
            let attempts = 0;
            const maxAttempts = 100; // 5 seconds max
            const tryScroll = () => {
                try {
                    const iframeDoc = privacyFrame.contentDocument || privacyFrame.contentWindow.document;
                    if (iframeDoc) {
                        const target = iframeDoc.getElementById(targetSection);
                        if (target) {
                            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            return;
                        }
                    }
                } catch (e) {
                    console.warn('Scroll attempt failed:', e);
                }
                attempts++;
                if (attempts < maxAttempts) {
                    setTimeout(tryScroll, 50);
                }
            };
            tryScroll();
        } else {
            setTimeout(checkFrame, 50);
        }
    };
    checkFrame();
};

function openPrivacyGroup(groupId) {
    if (typeof groupId === 'string') groupId = parseInt(groupId, 10);
    window.pendingPrivacyGroup = groupId;
    switchView('privacy');
    const checkFrame = () => {
        const privacyFrame = document.getElementById('legal-frame') || document.getElementById('privacy-frame');
        if (privacyFrame) {
            let attempts = 0;
            const maxAttempts = 100;
            const tryShowGroup = () => {
                try {
                    const win = privacyFrame.contentWindow;
                    if (win && typeof win.showGroup === 'function' && win.document && win.document.getElementById('portal-index-card')) {
                        win.showGroup(groupId);
                        return;
                    }
                } catch (e) { }
                attempts++;
                if (attempts < maxAttempts) {
                    setTimeout(tryShowGroup, 100);
                }
            };
            tryShowGroup();
        } else {
            setTimeout(checkFrame, 50);
        }
    };
    checkFrame();
}
window.openPrivacyGroup = openPrivacyGroup;


window.getPrivacyChoice = function () {
    try {
        const choices = JSON.parse(localStorage.getItem('user_choices') || '{}');
        const p = choices.privacy;
        if (!p) return null;
        if (typeof p === 'object' && p !== null) return p.choice || null;
        return p;
    } catch (e) {
        return null;
    }
};

// ─── Privacy Toast ─────────────────────────────────────────────
window.handlePrivacyToast = function (choice, fromPopState = false) {
    const toast = document.getElementById('privacy-toast');
    const backdrop = document.getElementById('privacy-toast-backdrop');
    if (!toast) return;

    // Clean up legacy separate key
    localStorage.removeItem('privacy_persistent_choice');

    // ── 1. Construct privacy choice payload ──
    const privacyChoiceData = {
        choice: choice,
        timestamp: new Date().toISOString()
    };

    // ── 2. Record choice via global preference engine ──
    if (typeof window.recordUserChoice === 'function') {
        window.recordUserChoice('privacy', privacyChoiceData);
    } else {
        try {
            const existingChoices = JSON.parse(localStorage.getItem('user_choices') || '{}');
            existingChoices.privacy = privacyChoiceData;
            if (existingChoices.mobile) {
                delete existingChoices.mobile;
            }
            localStorage.setItem('user_choices', JSON.stringify(existingChoices));
        } catch (e) { }
    }

    // ── 3. Direct Cloud Sync: if user is logged in → push to Firestore immediately via setDoc ────
    try {
        const auth = window.suiteAuth || (typeof auth !== 'undefined' ? auth : null);
        const db = window.suiteDb || (typeof db !== 'undefined' ? db : null);
        const user = auth && auth.currentUser;
        const setDocFn = window.suiteSetDoc;
        const docFn = window.suiteDoc;

        if (user && db && setDocFn && docFn) {
            setDocFn(
                docFn(db, 'users', user.uid),
                {
                    choices: {
                        privacy: privacyChoiceData
                    }
                },
                { merge: true }
            ).catch((err) => {
                console.warn("⚠️ Firebase privacy choice setDoc error:", err);
            });
        } else if (user && db && window.suiteUpdateDoc && docFn) {
            window.suiteUpdateDoc(
                docFn(db, 'users', user.uid),
                {
                    'choices.privacy': privacyChoiceData
                }
            ).catch((err) => {
                console.warn("⚠️ Firebase privacy choice updateDoc error:", err);
            });
        }
    } catch (e) {
        console.warn("⚠️ Firebase sync exception in handlePrivacyToast:", e);
    }

    if (!fromPopState) {
        if (choice === 'review') {
            // Keep toast open; navigate to policy
            if (typeof window.openMainPrivacyPolicy === 'function') window.openMainPrivacyPolicy('toast');
            else if (typeof openPolicy === 'function') openPolicy();
            return;
        }
        if (history.state && history.state.privacyModalOpen) {
            history.back();
        }
    }

    // ── Close animation — fling down from current position ──
    const currentTransform = toast.style.transform;
    toast.style.transition = 'opacity 0.3s ease, transform 0.35s cubic-bezier(0.55,0,1,0.45)';
    toast.style.transform = currentTransform.replace(/translateY\([^)]*\)/, 'translateY(130px)')
        || 'translateX(-50%) translateY(130px)';
    toast.style.opacity = '0';

    // Fade out backdrop
    if (backdrop) {
        backdrop.style.opacity = '0';
        setTimeout(() => { backdrop.style.display = 'none'; }, 350);
    }

    setTimeout(() => {
        toast.style.display = 'none';
        toast.style.transition = '';
    }, 380);
};

// ─── Drag logic: free 2D movement, clamped to screen ───────────────
function _attachPrivacyDrag() {
    const toast = document.getElementById('privacy-toast');
    if (!toast) return;

    // Live offset from the card's resting (bottom-center) position
    // Positive offsetX = moved right; positive offsetY = moved down.
    let offsetX = 0, offsetY = 0;

    // Pointer state
    let isDragging = false;
    let startPX = 0, startPY = 0;   // pointer coords at drag start
    let startOX = 0, startOY = 0;   // offsetX/Y at drag start
    let dragDeltaY = 0;             // raw vertical drag from start (unclamped)

    function getClient(e) {
        const src = e.touches ? e.touches[0] : e;
        return { x: src.clientX, y: src.clientY };
    }

    // Apply current offsets to the element
    function applyTransform(extraY) {
        const ey = extraY || 0;
        toast.style.transform = `translateX(calc(-50% + ${offsetX}px)) translateY(${offsetY + ey}px)`;
    }

    // Clamp X and upward Y — but NOT downward (so swipe-down-to-dismiss works)
    function clampOffsets() {
        const W = window.innerWidth;
        const H = window.innerHeight;
        const cW = toast.offsetWidth || 340;
        const cH = toast.offsetHeight || 220;

        const homeLeft = (W - cW) / 2;
        const maxRight = W - homeLeft - cW;
        const maxLeft = -homeLeft;

        const paddingB = 16;
        const homeTop = H - cH - paddingB;
        const maxUp = -homeTop;           // can drag up to top of screen

        // Clamp X fully, clamp upward Y — allow any downward drag (no maxDown clamp)
        offsetX = Math.max(maxLeft, Math.min(offsetX, maxRight));
        offsetY = Math.max(maxUp, offsetY);  // only block going above screen top
    }

    const SWIPE_DOWN_HOME = 80;   // px downward from start → snap to home
    const SWIPE_DOWN_DISMISS = 200; // px downward from start → dismiss

    function onDragStart(e) {
        const tag = e.target.tagName;
        if (tag === 'BUTTON' || tag === 'A') return;
        if (tag === 'SPAN' && typeof e.target.onclick === 'function') return;

        isDragging = true;
        const pt = getClient(e);
        startPX = pt.x;
        startPY = pt.y;
        startOX = offsetX;
        startOY = offsetY;
        dragDeltaY = 0;

        toast.style.transition = 'none';
        const pill = toast.querySelector('#privacy-drag-handle div');
        if (pill) pill.style.background = 'rgba(255,255,255,0.5)';
    }

    function onDragMove(e) {
        if (!isDragging) return;
        const pt = getClient(e);

        dragDeltaY = pt.y - startPY;         // raw vertical drag from start point
        offsetX = startOX + (pt.x - startPX);
        offsetY = startOY + dragDeltaY;
        clampOffsets();
        applyTransform();

        // Fade card slightly as user swipes downward past home threshold
        if (dragDeltaY > SWIPE_DOWN_HOME) {
            const progress = Math.min(1, (dragDeltaY - SWIPE_DOWN_HOME) / (SWIPE_DOWN_DISMISS - SWIPE_DOWN_HOME));
            toast.style.opacity = (1 - progress * 0.6).toString();
        } else {
            toast.style.opacity = '1';
        }

        if (e.cancelable) e.preventDefault();
    }

    function onDragEnd() {
        if (!isDragging) return;
        isDragging = false;

        const pill = toast.querySelector('#privacy-drag-handle div');
        if (pill) pill.style.background = 'rgba(255,255,255,0.22)';

        // ── Swipe-down gestures ──────────────────────────────────
        if (dragDeltaY >= SWIPE_DOWN_DISMISS) {
            // Flung far enough down → dismiss temporarily (later)
            window.handlePrivacyToast('later');
            return;
        }

        if (dragDeltaY >= SWIPE_DOWN_HOME) {
            // Moderate downward swipe → snap BACK to default home (bottom-center)
            toast.style.transition = 'transform 0.45s cubic-bezier(0.34,1.56,0.64,1), opacity 0.25s ease';
            toast.style.opacity = '1';
            offsetX = 0;
            offsetY = 0;
            applyTransform();
            return;
        }

        // ── Released anywhere else → STAY at current position ───
        toast.style.transition = 'transform 0.2s ease-out, opacity 0.15s ease';
        toast.style.opacity = '1';
        // offsetX / offsetY already hold the released position — just keep them
        applyTransform();
    }

    // Touch
    toast.addEventListener('touchstart', onDragStart, { passive: true });
    toast.addEventListener('touchmove', onDragMove, { passive: false });
    toast.addEventListener('touchend', onDragEnd, { passive: true });
    // Mouse
    toast.addEventListener('mousedown', onDragStart);
    document.addEventListener('mousemove', onDragMove);
    document.addEventListener('mouseup', onDragEnd);
}

// ─── Init & Dismiss ─────────────────────────────────────────────
window._privacyToastTimer = null;

window.dismissPrivacyToast = function () {
    if (window._privacyToastTimer) {
        clearTimeout(window._privacyToastTimer);
        window._privacyToastTimer = null;
    }
    const toast = document.getElementById('privacy-toast');
    const backdrop = document.getElementById('privacy-toast-backdrop');
    if (toast) {
        toast.style.display = 'none';
        toast.style.opacity = '0';
    }
    if (backdrop) {
        backdrop.style.display = 'none';
        backdrop.style.opacity = '0';
    }
};

function initPrivacyToast() {
    const toast = document.getElementById('privacy-toast');
    const backdrop = document.getElementById('privacy-toast-backdrop');
    if (!toast) return;

    // Clean up legacy single key
    localStorage.removeItem('privacy_persistent_choice');

    // Skip if user already answered with a permanent choice ('allow' or 'deny')
    const choice = window.getPrivacyChoice ? window.getPrivacyChoice() : null;
    if (choice === 'allow' || choice === 'deny') {
        window.dismissPrivacyToast();
        return;
    }

    _attachPrivacyDrag();

    if (window._privacyToastTimer) {
        clearTimeout(window._privacyToastTimer);
    }

    // Show after 1.5s with spring slide-up
    window._privacyToastTimer = setTimeout(() => {
        // Re-check before showing (in case choice was restored from Firebase or set during delay)
        const choiceNow = window.getPrivacyChoice ? window.getPrivacyChoice() : null;
        if (choiceNow === 'allow' || choiceNow === 'deny') {
            window.dismissPrivacyToast();
            return;
        }
        if (backdrop) {
            backdrop.style.display = 'block';
        }
        // Show toast — slide up from bottom-center
        toast.style.display = 'block';
        toast.offsetHeight;    // reflow
        toast.style.opacity = '1';
        toast.style.transform = 'translateX(-50%) translateY(0)';
        history.pushState({ privacyModalOpen: true }, '', '');
    }, 1500);
}

// ─── App Lock Suggestion Modal ─────────────────────────────────
window._appLockSuggestionTimer = null;

window.triggerAppLockSuggestionTimer = function () {
    // Clear any existing timer
    if (window._appLockSuggestionTimer) {
        clearTimeout(window._appLockSuggestionTimer);
        window._appLockSuggestionTimer = null;
    }

    // 1. Must not be a subpage
    if (isSubPageActive) return;

    // 2. App lock must not be enabled
    const appLockEnabled = window._0x83e2 && window._0x83e2.config && window._0x83e2.config.enabled;
    if (appLockEnabled) return;

    // 3. User must not have permanently denied in localStorage
    const choice = localStorage.getItem('app_lock_suggestion_choice');
    if (choice === 'deny') return;

    // 4. Check if user clicked 'later' or 'allow' in this session (sessionStorage resets on app reopen)
    try {
        const sessionChoice = sessionStorage.getItem('app_lock_session_choice');
        if (sessionChoice === 'later' || sessionChoice === 'allow') return;
    } catch (e) { }

    // 5. Modal must not be currently visible
    const overlay = document.getElementById('app-lock-toast-backdrop');
    if (overlay && (overlay.style.display === 'block' || overlay.style.display === 'flex')) return;

    // Start 5-second timer
    window._appLockSuggestionTimer = setTimeout(() => {
        if (isSubPageActive) return;
        const appLockEnabledNow = window._0x83e2 && window._0x83e2.config && window._0x83e2.config.enabled;
        if (appLockEnabledNow) return;
        const choiceNow = localStorage.getItem('app_lock_suggestion_choice');
        if (choiceNow === 'deny') return;
        try {
            const sessionChoiceNow = sessionStorage.getItem('app_lock_session_choice');
            if (sessionChoiceNow === 'later' || sessionChoiceNow === 'allow') return;
        } catch (e) { }

        // If privacy toast is still open, check again later
        const privacyToast = document.getElementById('privacy-toast');
        if (privacyToast && (privacyToast.style.display === 'block' || privacyToast.style.display === 'flex')) {
            window._appLockSuggestionTimer = setTimeout(window.triggerAppLockSuggestionTimer, 2000);
            return;
        }
        // Show App Lock suggestion modal
        const card = document.getElementById('app-lock-toast');
        if (overlay && card) {
            delete overlay.dataset.closing;
            overlay.style.display = 'flex';
            overlay.offsetHeight; // reflow
            overlay.style.opacity = '1';
            card.style.transform = 'scale(1)';
            history.pushState({ appLockSuggestionModalOpen: true }, '', '');
        }
    }, 5000);
};

window.handleAppLockSuggestion = function (choice, fromPopState = false) {
    const overlay = document.getElementById('app-lock-toast-backdrop');
    const card = document.getElementById('app-lock-toast');
    if (!overlay || !card) return;

    if (choice === 'allow') {
        // Record in session storage so it doesn't re-prompt in this session
        try { sessionStorage.setItem('app_lock_session_choice', 'allow'); } catch (e) { }

        // Instantly hide modal overlay to eliminate back-navigation conflicts
        overlay.style.display = 'none';
        overlay.style.opacity = '0';
        card.style.transform = 'scale(0.9)';
        delete overlay.dataset.closing;

        // Directly navigate to preferences (Settings) view
        if (typeof window.enterCosmoCryptApp === 'function') {
            window.enterCosmoCryptApp('preferences');
        } else if (typeof window.switchView === 'function') {
            window.switchView('preferences');
        }
        return;
    }

    if (choice === 'later') {
        // Only dismiss for the CURRENT session via sessionStorage.
        // When the user closes and reopens the app, sessionStorage is cleared,
        // so the app will re-ask them again on the next session.
        try { sessionStorage.setItem('app_lock_session_choice', 'later'); } catch (e) { }
        try {
            if (localStorage.getItem('app_lock_suggestion_choice') !== 'deny') {
                localStorage.removeItem('app_lock_suggestion_choice');
            }
        } catch (e) { }
    } else if (choice === 'deny') {
        // Persist "deny" across app restarts in localStorage
        try {
            localStorage.setItem('app_lock_suggestion_choice', 'deny');
            sessionStorage.setItem('app_lock_session_choice', 'deny');
        } catch (e) { }
    }

    overlay.dataset.closing = 'true';

    if (!fromPopState) {
        if (history.state && history.state.appLockSuggestionModalOpen) {
            history.back();
        }
    }

    // Close animation
    overlay.style.opacity = '0';
    card.style.transform = 'scale(0.9)';
    setTimeout(() => {
        overlay.style.display = 'none';
        delete overlay.dataset.closing;
    }, 300);
};

window.addEventListener('load', () => {
    initPrivacyToast();
});
if (typeof window.triggerAppLockSuggestionTimer === 'function') {
    window.triggerAppLockSuggestionTimer();
}


window.addEventListener('popstate', (event) => {
    const appLockHelp = document.getElementById('app-lock-help-overlay');
    if (appLockHelp && appLockHelp.style.display === 'flex') {
        appLockHelp.style.display = 'none';
        return;
    }
    const appLockOverlay = document.getElementById('app-lock-toast-backdrop');
    if (appLockOverlay && appLockOverlay.dataset.closing === 'true') {
        return;
    }
    if (appLockOverlay && (appLockOverlay.style.display === 'flex' || appLockOverlay.style.display === 'block')) {
        window.handleAppLockSuggestion('later', true);
        return;
    }
    const privacyToast = document.getElementById('privacy-toast');
    if (privacyToast && (privacyToast.style.display === 'flex' || privacyToast.style.display === 'block')) {
        const activeChoice = window.getPrivacyChoice ? window.getPrivacyChoice() : null;
        if (activeChoice === 'allow' || activeChoice === 'deny') {
            window.dismissPrivacyToast();
        } else {
            window.handlePrivacyToast('later', true);
        }
        return;
    }
    const premiumModal = document.getElementById('premium-unlock-modal');
    if (premiumModal && premiumModal.style.display === 'flex') {
        window.closePremiumUnlockModal(true);
        return;
    }
    const premiumLoginModal = document.getElementById('premium-login-modal');
    if (premiumLoginModal && premiumLoginModal.style.display === 'flex') {
        window.closePremiumLoginModal(true);
        return;
    }
    const sessionPause = document.getElementById('session-pause-overlay');
    if (sessionPause && sessionPause.style.display === 'flex') {
        if (window.SessionProtocolParent && typeof window.SessionProtocolParent.hideOverlay === 'function') {
            window.SessionProtocolParent.hideOverlay();
        } else {
            sessionPause.style.display = 'none';
        }
        return;
    }
    const secConfirm = document.getElementById('security-confirm-overlay');
    if (secConfirm && (secConfirm.style.display === 'flex' || secConfirm.classList.contains('active'))) {
        if (typeof closeSecurityConfirmation === 'function') closeSecurityConfirmation(true);
        else secConfirm.style.display = 'none';
        return;
    }
    const authModal = document.getElementById('app-auth-modal');
    if (authModal && (authModal.style.display === 'flex' || authModal.classList.contains('active'))) {
        if (typeof closeAuthModal === 'function') closeAuthModal();
        else authModal.style.display = 'none';
        return;
    }
    const cloudSync = document.getElementById('cloud-sync-modal-overlay');
    if (cloudSync && (cloudSync.style.display === 'flex' || cloudSync.classList.contains('active'))) {
        if (typeof dismissCloudSyncModal === 'function') dismissCloudSyncModal();
        else cloudSync.style.display = 'none';
        return;
    }
    const recPopup = document.getElementById('recommendation-popup-overlay');
    if (recPopup && (recPopup.style.display === 'flex' || recPopup.classList.contains('active'))) {
        if (window._0x83e2 && typeof window._0x83e2.dismissRecommendation === 'function') {
            window._0x83e2.dismissRecommendation();
        } else {
            recPopup.style.display = 'none';
        }
        return;
    }
    const securePdfModal = document.getElementById('securePdfVerificationModal');
    if (securePdfModal && (securePdfModal.style.display === 'flex' || securePdfModal.classList.contains('active'))) {
        if (typeof window.closeSecurePdfPromptModal === 'function') window.closeSecurePdfPromptModal(true);
        else securePdfModal.style.display = 'none';
        return;
    }
    const cardMutationModal = document.getElementById('cardMutationVerificationModal');
    if (cardMutationModal && (cardMutationModal.style.display === 'flex' || cardMutationModal.classList.contains('active'))) {
        if (typeof window.closeCardMutationPromptModal === 'function') window.closeCardMutationPromptModal(true);
        else cardMutationModal.style.display = 'none';
        return;
    }
    if (document.body.classList.contains('landing-menu-open')) {
        return; // Handled directly and cleanly by mobile-drawer.js popstate listener
    }
    if (window.isClosingSPA) {
        if (event.state && event.state.spaView) {
            history.back();
        } else {
            window.isClosingSPA = false;
            closeSPA(true);
        }
        return;
    }
    if (isSubPageActive) {
        if (!event.state || !event.state.spaView) {
            closeSPA(true, true);
        } else if (event.state.spaView) {
            const target = String(event.state.spaView).toLowerCase();
            if (target === 'landing' || target === 'home') {
                closeSPA(true, true);
            } else {
                switchView(event.state.spaView, false);
            }
        }
    }
});

// Universal ESC key listener for parent modals & overlays
window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
        const securePdfModal = document.getElementById('securePdfVerificationModal');
        if (securePdfModal && securePdfModal.style.display === 'flex') {
            if (typeof window.closeSecurePdfPromptModal === 'function') window.closeSecurePdfPromptModal(false);
            else securePdfModal.style.display = 'none';
            return;
        }
        const cardMutationModal = document.getElementById('cardMutationVerificationModal');
        if (cardMutationModal && cardMutationModal.style.display === 'flex') {
            if (typeof window.closeCardMutationPromptModal === 'function') window.closeCardMutationPromptModal(false);
            else cardMutationModal.style.display = 'none';
            return;
        }
        const appLockHelp = document.getElementById('app-lock-help-overlay');
        if (appLockHelp && appLockHelp.style.display === 'flex') {
            appLockHelp.style.display = 'none';
            return;
        }
        const premiumModal = document.getElementById('premium-unlock-modal');
        if (premiumModal && premiumModal.style.display === 'flex') {
            window.closePremiumUnlockModal();
            return;
        }
        const premiumLoginModal = document.getElementById('premium-login-modal');
        if (premiumLoginModal && premiumLoginModal.style.display === 'flex') {
            window.closePremiumLoginModal();
            return;
        }
        const sessionPause = document.getElementById('session-pause-overlay');
        if (sessionPause && sessionPause.style.display === 'flex') {
            if (window.SessionProtocolParent && typeof window.SessionProtocolParent.hideOverlay === 'function') {
                window.SessionProtocolParent.hideOverlay();
            } else {
                sessionPause.style.display = 'none';
            }
            return;
        }
        const secConfirm = document.getElementById('security-confirm-overlay');
        if (secConfirm && (secConfirm.style.display === 'flex' || secConfirm.classList.contains('active'))) {
            if (typeof closeSecurityConfirmation === 'function') closeSecurityConfirmation();
            else secConfirm.style.display = 'none';
            return;
        }
        const authModal = document.getElementById('app-auth-modal');
        if (authModal && (authModal.style.display === 'flex' || authModal.classList.contains('active'))) {
            if (typeof closeAuthModal === 'function') closeAuthModal();
            else authModal.style.display = 'none';
            return;
        }
        const cloudSync = document.getElementById('cloud-sync-modal-overlay');
        if (cloudSync && (cloudSync.style.display === 'flex' || cloudSync.classList.contains('active'))) {
            if (typeof dismissCloudSyncModal === 'function') dismissCloudSyncModal();
            else cloudSync.style.display = 'none';
            return;
        }
        const recPopup = document.getElementById('recommendation-popup-overlay');
        if (recPopup && (recPopup.style.display === 'flex' || recPopup.classList.contains('active'))) {
            if (window._0x83e2 && typeof window._0x83e2.dismissRecommendation === 'function') {
                window._0x83e2.dismissRecommendation();
            } else {
                recPopup.style.display = 'none';
            }
            return;
        }
        if (document.body.classList.contains('landing-menu-open')) {
            if (typeof window.handleDrawerCloseClick === 'function') {
                window.handleDrawerCloseClick();
            } else if (typeof window.closeLandingMobileMenu === 'function') {
                window.closeLandingMobileMenu(false);
            }
            return;
        }
    }
});





document.querySelectorAll('.panel-row').forEach(row => {
    const href = row.getAttribute('href');
    if (href) {
        row.addEventListener('click', function (e) {
            e.preventDefault();
            this.classList.add('clicked');
            if (navigator.vibrate) {
                navigator.vibrate(10);
            }

            const performRowNav = () => {
                this.classList.remove('clicked');
                if (!switchView(href)) {
                    if (href.startsWith('#')) {
                        const target = document.querySelector(href);
                        if (target) target.scrollIntoView({ behavior: 'smooth' });
                    } else {
                        window.location.href = href;
                    }
                }
            };

            const homeView = document.getElementById('view-home');
            if (homeView && homeView.classList.contains('active')) {
                animateOutHome(performRowNav);
            } else {
                setTimeout(performRowNav, 200);
            }
        });
    }
});


// Global PWA Install Prompt Handler
window.deferredPrompt = null;
window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    window.deferredPrompt = e;

    // Notify active iframe if available
    try {
        const ccIframe = document.getElementById('cc-creator-frame');
        if (ccIframe && ccIframe.contentWindow && typeof ccIframe.contentWindow.showPwaInstallButton === 'function') {
            ccIframe.contentWindow.showPwaInstallButton();
        }
    } catch (err) { }
});

window.installPWA = async function () {
    if (window.deferredPrompt) {
        window.deferredPrompt.prompt();
        const { outcome } = await window.deferredPrompt.userChoice;
        window.deferredPrompt = null;

        // Hide any local install buttons in parent
        const installBtn = document.getElementById('pwaInstallBtn');
        if (installBtn) installBtn.style.display = 'none';

        // Hide inside iframe if visible
        try {
            const ccIframe = document.getElementById('cc-creator-frame');
            if (ccIframe && ccIframe.contentWindow) {
                const localBtn = ccIframe.contentWindow.document.getElementById('pwaInstallBtn');
                if (localBtn) localBtn.style.display = 'none';
            }
        } catch (err) { }
    } else {
        const isStandalone = window.matchMedia('(display-mode: standalone)').matches ||
            window.matchMedia('(display-mode: fullscreen)').matches ||
            window.matchMedia('(display-mode: minimal-ui)').matches ||
            window.navigator.standalone === true;

        let isAlreadyInstalled = false;
        try {
            if (navigator.getInstalledRelatedApps) {
                const relatedApps = await navigator.getInstalledRelatedApps();
                isAlreadyInstalled = relatedApps.length > 0;
            }
        } catch (e) { }

        // Create animations if missing
        if (!document.getElementById('pwa-exit-style')) {
            const s = document.createElement('style');
            s.id = 'pwa-exit-style';
            s.innerHTML = `
                        @keyframes pwaFadeOut { from { opacity: 1; transform: translate(-50%, 0); } to { opacity: 0; transform: translate(-50%, 20px); } }
                        @keyframes pwaFadeIn { from { opacity: 0; transform: translate(-50%, 20px); } to { opacity: 1; transform: translate(-50%, 0); } }
                    `;
            document.head.appendChild(s);
        }

        const statusMsg = document.createElement('div');
        statusMsg.id = "pwa-status-toast";
        statusMsg.style.cssText = "position:fixed; bottom:30px; left:50%; transform:translateX(-50%); background:rgba(15, 23, 42, 0.95); backdrop-filter:blur(10px); border:1px solid rgba(255,255,255,0.1); color:white; padding:16px 24px; border-radius:16px; font-weight:600; z-index:2147483647; animation: pwaFadeIn 0.4s cubic-bezier(0.2, 0, 0, 1) forwards; box-shadow: 0 20px 40px rgba(0,0,0,0.5); display:flex; align-items:center; gap:14px; min-width:340px; pointer-events: none;";

        if (isStandalone || isAlreadyInstalled) {
            statusMsg.innerHTML = `<span class="material-symbols-outlined" style="color:#10b981; font-size:24px;">check_circle</span> <div style="display:flex; flex-direction:column; gap:2px;"><span style="font-size:11px; opacity:0.6; text-transform:uppercase; letter-spacing:1.5px; font-family: 'Space Grotesk', sans-serif;">Suite Status</span><span style="font-size:14px; font-family: 'Inter', sans-serif;">Already Installed & Active on this System</span></div>`;
        } else {
            const isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
            if (isiOS) {
                statusMsg.innerHTML = `<span class="material-symbols-outlined" style="color:#3b82f6; font-size:24px;">info</span> <div style="display:flex; flex-direction:column; gap:2px;"><span style="font-size:11px; opacity:0.6; text-transform:uppercase; letter-spacing:1.5px; font-family: 'Space Grotesk', sans-serif;">iOS Installation</span><span style="font-size:14px; font-family: 'Inter', sans-serif;">Tap Share button and select 'Add to Home Screen'.</span></div>`;
            } else {
                statusMsg.innerHTML = `<span class="material-symbols-outlined" style="color:#3b82f6; font-size:24px;">info</span> <div style="display:flex; flex-direction:column; gap:2px;"><span style="font-size:11px; opacity:0.6; text-transform:uppercase; letter-spacing:1.5px; font-family: 'Space Grotesk', sans-serif;">Connectivity Protocol</span><span style="font-size:14px; font-family: 'Inter', sans-serif;">Use browser settings menu to install this PWA.</span></div>`;
            }
        }

        const existing = document.getElementById('pwa-status-toast');
        if (existing) existing.remove();

        document.body.appendChild(statusMsg);
        setTimeout(() => {
            statusMsg.style.animation = "pwaFadeOut 0.4s forwards";
            setTimeout(() => statusMsg.remove(), 400);
        }, 4500);
    }
};

// Register Service Worker
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/sw.js?v=3.5.0', { scope: '/' });
    });
}


window.syncActiveFontToIframe = function (iframe) {
    return; // Bypass font synchronization to keep design fonts independent of system settings
    try {
        // If it is the why-upgrade iframe, bypass font synchronization to keep its design fonts independent of system settings
        if (iframe && iframe.id === 'why-upgrade-frame') return;

        const win = iframe.contentWindow;
        const doc = iframe.contentDocument || win.document;
        if (!doc || !doc.body || win.location.href === 'about:blank') return;

        const activeMode = parseInt(localStorage.getItem('active_layer_mode') || '1');

        if (win && typeof win.syncFontMode === 'function') {
            try {
                win.syncFontMode(activeMode);
            } catch (e) {
                console.warn("Error running local syncFontMode inside iframe:", e);
            }
        }


        doc.body.classList.remove('font-mode-1', 'font-mode-2', 'font-mode-3', 'font-mode-4', 'font-mode-5', 'font-mode-6', 'font-mode-7', 'font-mode-8');
        doc.body.classList.add(`font-mode-${activeMode}`);

        const protocols = [
            { font: "'Space Grotesk', sans-serif", accent: "#00f2fe" },
            { font: "'Montserrat', sans-serif", accent: "#3b82f6" },
            { font: "'Inter', sans-serif", accent: "#6366f1" },
            { font: "'Lato', sans-serif", accent: "#10b981" },
            { font: "'Merriweather', serif", accent: "#f59e0b" },
            { font: "'Lora', serif", accent: "#ec4899" },
            { font: "'Clash Display', sans-serif", accent: "#f43f5e" },
            { font: "'Bricolage Grotesque', sans-serif", accent: "#8b5cf6" }
        ];
        const activeProtocol = protocols[activeMode - 1];
        if (activeProtocol) {
            if (iframe.id === 'settings-frame') {
                doc.documentElement.style.setProperty('--primary-accent', activeProtocol.accent);
            }
            doc.documentElement.style.setProperty('--font-matrix', activeProtocol.font);
            doc.documentElement.style.setProperty('--font-sub', activeProtocol.font);
            doc.body.style.setProperty('--font-matrix', activeProtocol.font);
            doc.body.style.setProperty('--font-sub', activeProtocol.font);
            doc.body.style.fontFamily = activeProtocol.font;
        }
    } catch (e) {
        // Silence SecurityError as it normally occurs before iframe is fully loaded/initialized, 
        // or if the iframe is a third-party cross-origin frame.
        if (e.name !== 'SecurityError') {
            console.error("Error syncing active font to iframe:", e);
        }
    }
};

window.syncFontMode = function (mode) {
    document.body.classList.remove('font-mode-1', 'font-mode-2', 'font-mode-3', 'font-mode-4', 'font-mode-5', 'font-mode-6', 'font-mode-7', 'font-mode-8');
    document.body.classList.add(`font-mode-${mode}`);

    const protocols = [
        { font: "'Space Grotesk', sans-serif", accent: "#00f2fe" },
        { font: "'Montserrat', sans-serif", accent: "#3b82f6" },
        { font: "'Inter', sans-serif", accent: "#6366f1" },
        { font: "'Lato', sans-serif", accent: "#10b981" },
        { font: "'Merriweather', serif", accent: "#f59e0b" },
        { font: "'Lora', serif", accent: "#ec4899" },
        { font: "'Clash Display', sans-serif", accent: "#f43f5e" },
        { font: "'Bricolage Grotesque', sans-serif", accent: "#8b5cf6" }
    ];
    const activeProtocol = protocols[mode - 1];
    if (activeProtocol) {
        // Do NOT set --primary-accent on parent document to keep default theme color
        document.documentElement.style.setProperty('--font-matrix', activeProtocol.font);
        document.documentElement.style.setProperty('--font-sub', activeProtocol.font);
        document.body.style.setProperty('--font-matrix', activeProtocol.font);
        document.body.style.setProperty('--font-sub', activeProtocol.font);
        document.body.style.fontFamily = activeProtocol.font;
    }

    document.querySelectorAll('iframe').forEach(iframe => {
        window.syncActiveFontToIframe(iframe);
    });
};

window.addEventListener('load', () => {
    const mode = parseInt(localStorage.getItem('active_layer_mode') || '1');
    window.syncFontMode(mode);
});
window.addEventListener('storage', (e) => {
    if ((e.key === 'active_layer_mode' || e.key === 'mobile_active_layer_mode') && e.newValue) {
        window.syncFontMode(parseInt(e.newValue));
    }
});
window.addEventListener('safeStorageChange', (e) => {
    if (e.detail.key === 'active_layer_mode') {
        const val = e.detail.val !== undefined ? e.detail.val : e.detail.newValue;
        window.syncFontMode(parseInt(val));
    }
});

/* --- PREMIUM SaaS APPLICATION LOCK MODULE --- */
(function () {
    // Local encryption key (used when not logged in to make localStorage secure and undecryptable by others)
    const LOCAL_LOCK_KEY = "cosmocrypt_client_local_lock_salt_v2_2026";

    // Memory cache of the lock configuration
    let cachedLockConfig = null;

    // Map imported Firebase module functions for this non-module scope dynamically
    const doc = (...args) => window.suiteDoc(...args);
    const getDoc = (...args) => window.suiteGetDoc(...args);
    const updateDoc = (...args) => window.suiteUpdateDoc(...args);
    const deleteField = (...args) => window.suiteDeleteField(...args);

    // Helper to check if Firebase user is logged in
    function getFirebaseUser() {
        return (window.suiteAuth && window.suiteAuth.currentUser) || null;
    }

    // Encrypt helper using Hardware-Accelerated WebCrypto / CryptoJS fallback
    function secureEncrypt(text, keyString) {
        const key = keyString || LOCAL_LOCK_KEY;
        if (window.CosmoCryptoEngine && typeof window.CosmoCryptoEngine.secureEncryptSync === 'function') {
            return window.CosmoCryptoEngine.secureEncryptSync(text, key);
        }
        if (typeof CryptoJS !== 'undefined') {
            return CryptoJS.AES.encrypt(text, key).toString();
        }
        return text;
    }

    // Decrypt helper with Hardware WebCrypto & Legacy dual-mode fallback
    function secureDecrypt(ciphertext, keyString) {
        if (!ciphertext || typeof ciphertext !== 'string') return null;
        const key = keyString || LOCAL_LOCK_KEY;

        try {
            if (ciphertext.startsWith("cc_gcm256:") && window.CosmoCryptoEngine) {
                return window.CosmoCryptoEngine.secureDecryptSync(ciphertext, key);
            }
            if (typeof CryptoJS !== 'undefined') {
                const bytes = CryptoJS.AES.decrypt(ciphertext, key);
                const decrypted = bytes.toString(CryptoJS.enc.Utf8);
                if (decrypted) {
                    return decrypted;
                }
            }
        } catch (e) {
            // Fall through
        }

        // Fallback: Try decrypting with legacy LOCAL_LOCK_KEY
        if (keyString && keyString !== LOCAL_LOCK_KEY && typeof CryptoJS !== 'undefined') {
            try {
                const bytes = CryptoJS.AES.decrypt(ciphertext, LOCAL_LOCK_KEY);
                const decrypted = bytes.toString(CryptoJS.enc.Utf8);
                if (decrypted) {
                    return decrypted;
                }
            } catch (e) {
                return null;
            }
        }
        return null;
    }

    if (typeof window !== 'undefined') {
    async function hashAppLockSecret(secret, saltHex) {
        if (!secret) return '';
        try {
            if (typeof crypto !== 'undefined' && crypto.subtle && crypto.subtle.importKey) {
                const enc = new TextEncoder();
                const keyMaterial = await crypto.subtle.importKey(
                    "raw", enc.encode(secret), "PBKDF2", false, ["deriveBits"]
                );
                const saltBytes = new Uint8Array(saltHex.match(/.{1,2}/g).map(byte => parseInt(byte, 16)));
                const bits = await crypto.subtle.deriveBits({
                    name: "PBKDF2",
                    salt: saltBytes,
                    iterations: 120000,
                    hash: "SHA-256"
                }, keyMaterial, 256);
                return Array.from(new Uint8Array(bits), b => b.toString(16).padStart(2, '0')).join('');
            }
        } catch (e) { }
        try {
            if (typeof CryptoJS !== 'undefined' && CryptoJS.PBKDF2) {
                return CryptoJS.PBKDF2(secret, CryptoJS.enc.Hex.parse(saltHex), { keySize: 256 / 32, iterations: 120000 }).toString();
            }
        } catch (e) { }
        return (typeof CryptoJS !== 'undefined' ? CryptoJS.SHA256(secret + saltHex).toString() : secret);
    }

    function generateAppLockSalt() {
        if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
            const bytes = new Uint8Array(16);
            crypto.getRandomValues(bytes);
            return Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
        }
        return Math.random().toString(36).substring(2) + Date.now().toString(36);
    }

    async function verifyAppLockSecret(input, storedVal, salt) {
        if (!storedVal || !input) return false;
        if (typeof storedVal === 'string' && storedVal.startsWith('pbkdf2_')) {
            const parts = storedVal.split('_');
            const saltPart = parts[1];
            const hashPart = parts[2];
            const computed = await hashAppLockSecret(input, saltPart);
            return computed === hashPart;
        }
        if (salt) {
            const computed = await hashAppLockSecret(input, salt);
            if (computed === storedVal) return true;
        }
        try {
            const legacyDec = secureDecrypt(storedVal, getFirebaseUser() ? getFirebaseUser().uid : null);
            if (legacyDec === input) return true;
        } catch (e) { }
        return storedVal === input;
    }

    // PBKDF2 One-Way Hashing for App Lock PIN, Duress PIN & Security Recovery
        window.hashAppLockSecret = hashAppLockSecret;
        window.verifyAppLockSecret = verifyAppLockSecret;
        window.generateAppLockSalt = generateAppLockSalt;
        window.secureEncrypt = secureEncrypt;
        window.secureDecrypt = secureDecrypt;
    }

    // Load config (from Firebase if logged in, otherwise from localStorage)
    async function getLockConfig() {
        const user = getFirebaseUser();
        if (user) {
            try {
                const userDoc = await getDoc(doc(window.suiteDb, "users", user.uid));
                if (userDoc.exists()) {
                    const data = userDoc.data();
                    const config = (data.settings && data.settings.app_lock_config) || (data.settings && data.settings.mobile && data.settings.mobile.app_lock_config) || data.app_lock_config || null;
                    window._0x83e2.config = config;
                    // Clean up local storage if logged in
                    localStorage.removeItem('app_lock_config');
                    return config;
                }
            } catch (e) {
                console.error("Error loading config from Firebase:", e);
            }
        }

        // Fallback to localStorage (encrypted)
        const encryptedConfig = localStorage.getItem('app_lock_config');
        if (encryptedConfig) {
            try {
                const decryptedStr = secureDecrypt(encryptedConfig, user ? user.uid : null);
                if (decryptedStr) {
                    const config = JSON.parse(decryptedStr);
                    window._0x83e2.config = config;
                    return config;
                }
            } catch (e) {
                console.error("Error decrypting local config:", e);
            }
        }
        window._0x83e2.config = null;
        return null;
    }

    // Save config
    async function saveLockConfig(config) {
        window._0x83e2.config = config;
        const user = getFirebaseUser();
        if (user) {
            try {
                const userRef = doc(window.suiteDb, "users", user.uid);
                // Save under settings.app_lock_config
                await updateDoc(userRef, {
                    "settings.app_lock_config": config,
                    "settings.mobile.app_lock_config": deleteField()
                });
                // Remove from local storage
                localStorage.removeItem('app_lock_config');
                return true;
            } catch (e) {
                console.error("Error saving config to Firebase:", e);
                return false;
            }
        } else {
            // Not logged in -> encrypt and save in local storage
            try {
                const encryptedStr = secureEncrypt(JSON.stringify(config));
                localStorage.setItem('app_lock_config', encryptedStr);
                return true;
            } catch (e) {
                console.error("Error saving local config:", e);
                return false;
            }
        }
    }

    // Expose the API to window._0x83e2
    window._0x83e2 = {
        _0x2k8f: false, // isAppSessionUnlocked: once true, it stays true per session
        _0x1b7d: null,  // pendingView
        config: null,
        pendingCallback: null,
        _lockStatePushed: false,
        _0xR3z: function () {
            if (window.SessionProtocolParent) {
                window.SessionProtocolParent.hideOverlay();
            } else {
                const overlay = document.getElementById('session-pause-overlay');
                if (overlay) overlay.style.display = 'none';
                document.body.classList.remove('is-blurred');
            }
        },
        _0xP1: function () {
            if (window.SessionProtocolParent) {
                window.SessionProtocolParent.showOverlay();
            } else {
                const overlay = document.getElementById('session-pause-overlay');
                if (overlay) overlay.style.display = 'flex';
            }
        },

        init: async function () {
            await getLockConfig();

            // Check URL path or hash for shortcut deep linking
            let savedView = 'about';
            const path = window.location.pathname.toLowerCase();
            let cleanPath = path;
            if (cleanPath.endsWith('index.html')) {
                cleanPath = cleanPath.slice(0, -10);
            }
            if (cleanPath !== '/' && cleanPath.endsWith('/')) {
                cleanPath = cleanPath.slice(0, -1);
            }

            const cleanPathSlug = cleanPath.startsWith('/') ? cleanPath.substring(1) : cleanPath;
            if (!cleanPathSlug || cleanPathSlug === '' || cleanPathSlug === 'about') {
                savedView = 'about';
            } else if (cleanPathSlug === 'home' || cleanPathSlug === 'landing') {
                savedView = 'landing';
            } else if (cleanPathSlug === 'about') {
                savedView = 'about';
            } else {
                const aliasResolved = window.COSMO_ALIAS_MAP[cleanPathSlug];
                if (aliasResolved) {
                    savedView = aliasResolved;
                } else if (window.COSMO_PAGES.includes(cleanPathSlug)) {
                    savedView = cleanPathSlug;
                } else {
                    savedView = '404';
                    const hash = window.location.hash;
                    if (hash) {
                        const cleanHash = hash.replace('#', '').toLowerCase();
                        const matchedView = window.COSMO_ALIAS_MAP[cleanHash] || (window.COSMO_PAGES.includes(cleanHash) ? cleanHash : null);
                        if (matchedView) {
                            savedView = matchedView;
                        }
                    }
                }
            }

            // Force clean URL slugs for about and landing views
            if (savedView === 'about') {
                try { window.history.replaceState(null, '', '/'); } catch (e) { }
            } else if (savedView === 'landing') {
                try { window.history.replaceState(null, '', '/home'); } catch (e) { }
            }

            // Save the active view in sessionStorage (Zero LocalStorage)
            window._currentSuiteViewState = savedView;
            try {
                sessionStorage.setItem('current_suite_view', savedView);
                localStorage.removeItem('current_suite_view');
            } catch (e) { }

            // Wait for router's template pre-load to complete before rendering
            if (window.__cosmoTemplateReady) {
                try { await window.__cosmoTemplateReady; } catch (e) { }
            }

            // Also ensure the resolved slug's template is loaded (in case alias differs from URL slug)
            const resolvedTemplateId = savedView + '-template';
            if (!document.getElementById(resolvedTemplateId)) {
                try {
                    const resp = await fetch('/templates/' + savedView + '.html');
                    if (resp.ok) {
                        const html = await resp.text();
                        const el = document.createElement('script');
                        el.type = 'text/plain';
                        el.id = resolvedTemplateId;
                        el.textContent = html;
                        document.body.appendChild(el);

                    }
                } catch (e) {
                    console.warn('[Init] Could not pre-load template:', savedView, e);
                }
            }

            const isLocked = await this.checkAppLock(savedView);
            if (!isLocked) {
                try {
                    if (savedView && savedView !== 'landing' && typeof switchView === 'function') {
                        switchView(savedView, false);
                        // Hide the landing overlay so the view-layer is visible
                        const _lpo = document.getElementById('landing-page-overlay');
                        if (_lpo) {
                            const _vid = document.getElementById('landing-hero-video');
                            if (_vid) { try { _vid.pause(); } catch (e) { } }
                            document.body.classList.remove('landing-menu-open');
                            _lpo.style.transition = 'opacity 0.5s ease';
                            _lpo.style.opacity = '0';
                            setTimeout(function () { _lpo.style.display = 'none'; }, 500);
                        }
                    } else {
                        // Explicitly ensure landing overlay is active and URL slug is /home
                        const _lpo = document.getElementById('landing-page-overlay');
                        if (_lpo) {
                            _lpo.style.display = 'block';
                            _lpo.style.opacity = '1';
                        }
                        try { window.history.replaceState(null, '', '/home'); } catch (e) { }
                    }
                } catch (e) {
                    console.error("Failed to restore saved view on init:", e);
                }
            }
        },

        // Initialize lock check on page navigation/load
        checkAppLock: async function (targetView) {
            const config = await getLockConfig();
            if (config && config.enabled) {
                let view = targetView;
                if (!view) {
                    try { view = sessionStorage.getItem('current_suite_view') || window._currentSuiteViewState || 'landing'; } catch (e) { view = window._currentSuiteViewState || 'landing'; }
                }
                const vLower = view.toLowerCase();
                const matchedSlug = window.COSMO_ALIAS_MAP[vLower] || (window.COSMO_PAGES.includes(vLower) ? vLower : null);
                const isProtected = (matchedSlug && window.COSMO_PROTECTED_PAGES && window.COSMO_PROTECTED_PAGES.includes(matchedSlug)) ? true : false;

                if (isProtected && !this._0x2k8f) {
                    this.setLockState(true);
                    this._0x1b7d = view;
                    return true;
                }
            }
            this.setLockState(false);
            return false;
        },

        setLockState: async function (isVisible) {
            const lockScreen = document.getElementById('app-lock-screen');
            const mainWrapper = document.getElementById('main-scroller') || document.getElementById('main-app-wrapper');
            if (!lockScreen) return;

            // Clear fields
            const lockInp = document.getElementById('lock-password-input');
            if (lockInp) lockInp.value = '';
            const newLockInp = document.getElementById('new-lock-password');
            if (newLockInp) newLockInp.value = '';
            if (window.updatePinDisplay) window.updatePinDisplay();
            const recInp = document.getElementById('recovery-answer-input');
            if (recInp) recInp.value = '';

            if (isVisible) {
                const config = await getLockConfig();
                let targetLen = (config && config.pin_length) || 4; // default to 4 digits
                if (config && config.password) {
                    const user = typeof getFirebaseUser === 'function' ? getFirebaseUser() : null;
                    const decryptedPassword = typeof secureDecrypt === 'function' ? secureDecrypt(config.password, user ? user.uid : null) : null;
                    if (decryptedPassword && decryptedPassword.length >= 4) {
                        targetLen = decryptedPassword.length;
                    }
                }
                this.targetPinLength = targetLen;

                const pinDisplay = document.getElementById('pin-display');
                if (pinDisplay) {
                    pinDisplay.innerHTML = '';
                    for (let i = 0; i < targetLen; i++) {
                        const dot = document.createElement('div');
                        dot.className = 'pin-dot';
                        pinDisplay.appendChild(dot);
                    }
                }

                document.getElementById('primary-lock-view').style.display = 'block';
                document.getElementById('recovery-section').style.display = 'none';
                document.getElementById('reset-password-section').style.display = 'none';
                document.getElementById('lock-screen-header').style.display = 'block';
                lockScreen.style.display = 'flex';
                lockScreen.style.opacity = '1';
                const card = lockScreen.querySelector('.saas-premium-card');
                if (card) card.style.animation = '';
                if (mainWrapper) mainWrapper.style.filter = 'blur(20px)';
                document.body.classList.add('app-locked');

                const bioBtn = document.getElementById('btn-biometric-quick-unlock');
                if (bioBtn) {
                    const hasBioCache = !!sessionStorage.getItem('__cc_bio_unwrapped_key');
                    bioBtn.style.display = hasBioCache ? 'flex' : 'none';
                }

                // Intercept back button specifically for App Lock
                if (window.history && window.history.pushState) {
                    if (!this._lockStatePushed) {
                        window.history.pushState({ isAppLock: true }, "");
                        this._lockStatePushed = true;
                    }
                }
            } else {
                lockScreen.style.opacity = '0';
                setTimeout(() => {
                    lockScreen.style.display = 'none';
                    if (mainWrapper) mainWrapper.style.filter = 'none';
                }, 300);
                document.body.classList.remove('app-locked');

                // Clear history state if lock screen is dismissed programmatically
                if (this._lockStatePushed) {
                    this._lockStatePushed = false;
                    if (window.history.state && window.history.state.isAppLock) {
                        window.history.back();
                    }
                }
            }
        },

        // Verify the unlock password
        unlockApp: async function () {
            const passwordInput = document.getElementById('lock-password-input').value;
            const config = await getLockConfig();
            if (config) {
                const user = getFirebaseUser();

                // 1. Check Emergency Panic Kill-Switch PIN (e.g. 0000, 000000, or custom panic PIN)
                const isAllZeros = (/^0{4,}$/.test(passwordInput));
                const panicStored = (config && (config.panic_pin || config.panic_hash)) || null;
                const isPanicMatch = isAllZeros || (panicStored && await verifyAppLockSecret(passwordInput, panicStored, config.salt));



                if (isPanicMatch) {
                    const sub = (localStorage.getItem('user_subscription') || localStorage.getItem('cosmo_user_plan') || localStorage.getItem('current_plan') || '').toLowerCase();
                    const isMatrixOrQuantum = sub.includes('matrix') || sub.includes('quantum') || sub.includes('pro') || sub.includes('ultra') || sub.includes('infinite') || sub.includes('lifetime');
                    if (!isMatrixOrQuantum) {
                        showToast("Emergency Panic PIN Wipe requires Matrix or Quantum plan.", true);
                        return;
                    }
                    showToast("🚨 Emergency Panic Wipe Executed", true);
                    this.setLockState(false);
                    if (window.CosmoDuress && typeof window.CosmoDuress.executePanicWipe === 'function') {
                        await window.CosmoDuress.executePanicWipe();
                    } else if (typeof window.triggerPanicWipe === 'function') {
                        await window.triggerPanicWipe();
                    }
                    return;
                }

                const isPasswordMatch = await verifyAppLockSecret(passwordInput, (config && (config.password || config.pin_hash)) || '', config ? config.salt : null);

                const isAllNines = (/^9{4,}$/.test(passwordInput));
                const duressStored = (config && (config.duress_pin || config.duress_hash)) || null;
                const isDuressMatch = (duressStored && await verifyAppLockSecret(passwordInput, duressStored, config.salt)) || (isAllNines && !isPasswordMatch);

                if (isPasswordMatch || isDuressMatch) {






                    this._0x2k8f = true; // Mark as unlocked for this session

                    // Set Duress state (Plausible Deniability)
                    if (window.CosmoDuress && typeof window.CosmoDuress.setDuressMode === 'function') {
                        window.CosmoDuress.setDuressMode(isDuressMatch);
                    }

                    if (isDuressMatch) {
                        try {
                            window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { clear: true, isDuress: true } }));
                            document.querySelectorAll('iframe').forEach(f => {
                                try { f.contentWindow?.dispatchEvent?.(new CustomEvent('safeStorageChange', { detail: { clear: true, isDuress: true } })); } catch (e) { }
                            });
                        } catch (e) { }
                    }

                    if (!isDuressMatch && window.CosmoWebAuthn && typeof window.CosmoWebAuthn.storeBiometricVaultKey === 'function') {
                        window.CosmoWebAuthn.storeBiometricVaultKey(passwordInput);
                    }
                    this.setLockState(false);
                    showToast("Access Granted", false);
                    triggerSound('LOCK_SUCCESS');
                    if (this._0x1b7d) {
                        const targetView = this._0x1b7d;
                        this._0x1b7d = null;
                        setTimeout(() => {
                            if (typeof window.enterCosmoCryptApp === 'function') {
                                window.enterCosmoCryptApp(targetView);
                            } else if (typeof switchView === 'function') {
                                switchView(targetView);
                            }
                        }, 150);
                    } else if (isDuressMatch) {
                        // Refresh current template view so it displays default mock cards
                        const cur = window.currentSpaView || (window._currentView);
                        if (cur && typeof switchView === 'function') {
                            setTimeout(() => switchView(cur, false), 150);
                        }
                    }
                } else {
                    showToast("Incorrect PIN", true);
                    triggerSound('ERROR');
                    const dots = document.querySelectorAll('#pin-display .pin-dot');
                    dots.forEach(d => d.style.background = '#ef4444');
                    setTimeout(() => {
                        document.getElementById('lock-password-input').value = '';
                        dots.forEach(d => {
                            d.style.background = '';
                            d.classList.remove('filled');
                        });
                        if (window.updatePinDisplay) window.updatePinDisplay();
                    }, 400);
                    if (window.shakeLockCard) window.shakeLockCard();
                }
            }
        },

        cancelAppLock: function () {
            this.setLockState(false);
            this._0x1b7d = null;
            if (typeof window.closeSPA === 'function') {
                setTimeout(() => {
                    window.closeSPA();
                }, 150);
            } else {
                setTimeout(() => {
                    if (typeof switchView === 'function') switchView('landing');
                }, 150);
            }
        },

        showRecovery: async function () {
            const config = await getLockConfig();
            if (config) {
                const questionMap = {
                    "1": "What was the name of your first pet?",
                    "2": "In what city were you born?",
                    "3": "What is your mother's maiden name?",
                    "4": "What was the name of your first school?",
                    "5": "What is your favorite book?",
                    "6": "What is the make of your first car?",
                    "7": "What is your father's middle name?",
                    "8": "What is the name of your childhood best friend?",
                    "9": "What was your favorite food as a child?",
                    "10": "What is the name of the street you grew up on?"
                };
                const qText = questionMap[config.questionId] || "Security Question";
                document.getElementById('display-recovery-question').innerText = qText;

                // Clear PIN field when moving to recovery
                document.getElementById('lock-password-input').value = '';
                if (window.updatePinDisplay) window.updatePinDisplay();

                document.getElementById('primary-lock-view').style.display = 'none';
                document.getElementById('recovery-section').style.display = 'block';
            }
        },

        hideRecovery: function () {
            document.getElementById('recovery-section').style.display = 'none';
            document.getElementById('primary-lock-view').style.display = 'block';
            document.getElementById('lock-screen-header').style.display = 'block';
        },

        verifyRecovery: async function () {
            const answerInput = document.getElementById('recovery-answer-input').value.toLowerCase().trim();
            const config = await getLockConfig();
            if (config) {
                const user = getFirebaseUser();
                const isAnswerMatch = await verifyAppLockSecret(answerInput, (config && (config.answer || config.answer_hash)) || '', config ? config.salt : null);
                if (isAnswerMatch) {
                    document.getElementById('recovery-section').style.display = 'none';
                    document.getElementById('reset-password-section').style.display = 'block';
                    document.getElementById('lock-screen-header').style.display = 'none';
                    triggerSound('LOCK_SUCCESS');
                } else {
                    showToast("Incorrect Answer", true);
                    triggerSound('ERROR');
                    document.getElementById('recovery-answer-input').value = '';
                    if (window.shakeLockCard) window.shakeLockCard();
                }
            }
        },

        resetPassword: async function () {
            const newPassword = document.getElementById('new-lock-password').value;
            if (newPassword.length < 4) {
                showToast("Password must be at least 4 characters.", true);
                document.getElementById('new-lock-password').value = '';
                if (window.shakeLockCard) window.shakeLockCard();
                return;
            }
            const config = await getLockConfig();
            if (config) {
                const user = getFirebaseUser();
                config.salt = config.salt || generateAppLockSalt();
                config.password = `pbkdf2_${config.salt}_${await hashAppLockSecret(newPassword, config.salt)}`;
                config.pin_length = newPassword.length;
                await saveLockConfig(config);
                showToast("Password Reset Successful!", false);
                triggerSound('LOCK_SUCCESS');
                document.getElementById('reset-password-section').style.display = 'none';
                document.getElementById('primary-lock-view').style.display = 'block';
                this._0x2k8f = true;
                this.setLockState(false);
                if (this._0x1b7d) {
                    const targetView = this._0x1b7d;
                    this._0x1b7d = null;
                    setTimeout(() => {
                        if (typeof switchView === 'function') switchView(targetView);
                    }, 150);
                } else {
                    setTimeout(() => {
                        if (typeof switchView === 'function') switchView('landing');
                    }, 150);
                }
            }
        },

        // API for Settings frame to decrypt/view configuration
        getDecryptedConfigForSettings: async function () {
            const config = await getLockConfig();
            if (config) {
                const user = getFirebaseUser();
                const key = user ? user.uid : null;
                return {
                    password: (config.password && config.password.startsWith('pbkdf2_')) ? '••••••••' : secureDecrypt(config.password, key),
                    duress_pin: config.duress_pin ? (secureDecrypt(config.duress_pin, key) || config.duress_pin) : '',
                    panic_pin: config.panic_pin ? (secureDecrypt(config.panic_pin, key) || config.panic_pin) : '',
                    questionId: config.questionId,
                    answer: (config.answer && config.answer.startsWith('pbkdf2_')) ? '••••••••' : secureDecrypt(config.answer, key),
                    enabled: config.enabled
                };
            }
            return null;
        },

        // API for Settings frame to save config
        saveNewLockConfig: async function (newConfig) {
            if (!newConfig) return false;
            const user = getFirebaseUser();
            const key = user ? user.uid : null;
            const salt = newConfig.salt || generateAppLockSalt();
            const rawPassword = (newConfig.password && typeof newConfig.password === 'string') ? newConfig.password : '';
            const rawAnswer = (newConfig.answer && typeof newConfig.answer === 'string') ? newConfig.answer.toLowerCase().trim() : '';
            const rawDuress = (newConfig.duress_pin && typeof newConfig.duress_pin === 'string') ? newConfig.duress_pin.trim() : '';
            const rawPanic = (newConfig.panic_pin && typeof newConfig.panic_pin === 'string') ? newConfig.panic_pin.trim() : '';

            const encryptedConfig = {
                salt: salt,
                pin_length: (rawPassword && rawPassword !== '••••••••') ? rawPassword.length : (newConfig.pin_length || 4),
                password: (rawPassword && rawPassword !== '••••••••') ? `pbkdf2_${salt}_${await hashAppLockSecret(rawPassword, salt)}` : (rawPassword.startsWith('pbkdf2_') ? rawPassword : ''),
                duress_pin: (rawDuress && rawDuress !== '••••••••') ? `pbkdf2_${salt}_${await hashAppLockSecret(rawDuress, salt)}` : (rawDuress.startsWith('pbkdf2_') ? rawDuress : ''),
                panic_pin: (rawPanic && rawPanic !== '••••••••') ? `pbkdf2_${salt}_${await hashAppLockSecret(rawPanic, salt)}` : (rawPanic.startsWith('pbkdf2_') ? rawPanic : ''),
                questionId: newConfig.questionId || 1,
                answer: (rawAnswer && rawAnswer !== '••••••••') ? `pbkdf2_${salt}_${await hashAppLockSecret(rawAnswer, salt)}` : (rawAnswer.startsWith('pbkdf2_') ? rawAnswer : ''),
                enabled: !!newConfig.enabled
            };
            const success = await saveLockConfig(encryptedConfig);
            if (success) {
                showToast("App Lock & Threat Defense Configuration Synchronized.", false);
                triggerSound('UPGRADE');
            }
            return success;
        },

        removeAppLock: async function () {
            const currentConfigDecrypted = await this.getDecryptedConfigForSettings();
            const preservedDuress = currentConfigDecrypted ? (currentConfigDecrypted.duress_pin || '') : '';
            const preservedPanic = currentConfigDecrypted ? (currentConfigDecrypted.panic_pin || '') : '';
            const user = getFirebaseUser();
            const key = user ? user.uid : null;

            if (user) {
                const userRef = doc(window.suiteDb, "users", user.uid);
                if (preservedDuress || preservedPanic) {
                    const preservedConfig = {
                        password: '',
                        duress_pin: preservedDuress ? secureEncrypt(preservedDuress, key) : '',
                        panic_pin: preservedPanic ? secureEncrypt(preservedPanic, key) : '',
                        questionId: 1,
                        answer: '',
                        enabled: false
                    };
                    if (typeof window.suiteSetDoc === 'function') {
                        await window.suiteSetDoc(userRef, { settings: { app_lock_config: preservedConfig } }, { merge: true });
                    } else if (typeof updateDoc === 'function') {
                        await updateDoc(userRef, { "settings.app_lock_config": preservedConfig });
                    }
                    this.config = preservedConfig;
                } else {
                    if (typeof window.suiteUpdateDoc === 'function') {
                        await window.suiteUpdateDoc(userRef, {
                            "settings.app_lock_config": deleteField(),
                            "settings.mobile.app_lock_config": deleteField()
                        });
                    } else if (typeof updateDoc === 'function') {
                        await updateDoc(userRef, {
                            "settings.app_lock_config": deleteField(),
                            "settings.mobile.app_lock_config": deleteField()
                        });
                    }
                    this.config = null;
                }
            } else {
                if (preservedDuress || preservedPanic) {
                    const preservedConfig = {
                        password: '',
                        duress_pin: preservedDuress ? secureEncrypt(preservedDuress, key) : '',
                        panic_pin: preservedPanic ? secureEncrypt(preservedPanic, key) : '',
                        questionId: 1,
                        answer: '',
                        enabled: false
                    };
                    localStorage.setItem('app_lock_config', secureEncrypt(JSON.stringify(preservedConfig)));
                    this.config = preservedConfig;
                } else {
                    localStorage.removeItem('app_lock_config');
                    this.config = null;
                }
            }
            cachedLockConfig = null;
            this._0x2k8f = false;
            showToast("App Lock Removed. Threat Defense PINs preserved.", false);
            setTimeout(() => {
                if (typeof window.closeSPA === 'function') {
                    window.closeSPA();
                } else {
                    switchView('landing');
                }
            }, 1000);
        },

        requestAuth: function (callback, title = "Security Access") {
            getLockConfig().then(config => {
                if (!config || !config.enabled) {
                    if (callback) callback();
                    return;
                }
                this.pendingCallback = callback;
                const authModal = document.getElementById('app-auth-modal');
                const titleEl = document.getElementById('app-auth-title');
                if (authModal) {
                    if (titleEl) titleEl.innerText = title;
                    authModal.style.display = 'flex';
                    const card = authModal.querySelector('.saas-premium-card');
                    if (card) card.style.animation = '';
                    const input = document.getElementById('app-auth-input');
                    if (input) {
                        input.value = '';
                        input.focus();
                    }
                }
            });
        },

        verifyAuth: async function () {
            const inputField = document.getElementById('app-auth-input');
            const input = inputField ? inputField.value : '';
            const config = await getLockConfig();
            if (config) {
                const isPasswordMatch = await verifyAppLockSecret(input, (config && (config.password || config.pin_hash)) || '', config ? config.salt : null);
                if (isPasswordMatch) {
                    if (this.pendingCallback) {
                        this.pendingCallback();
                        this.pendingCallback = null;
                    }
                    this.closeAuthModal();
                    showToast("Access Granted", false);
                    triggerSound('LOCK_SUCCESS');
                    return;
                }
            }
            showToast("WRONG PASSWORD", true);
            triggerSound('ERROR');
            if (inputField) inputField.value = '';
            if (window.shakeAuthCard) window.shakeAuthCard();
        },
        _dummyOldAuth: async function () {

            const inputField = document.getElementById('app-auth-input');
            const input = inputField ? inputField.value : '';
            const config = await getLockConfig();
            if (config) {
                const user = getFirebaseUser();
                const isPasswordMatch = await verifyAppLockSecret(passwordInput, (config && (config.password || config.pin_hash)) || '', config ? config.salt : null);

                const isAllNines = (/^9{4,}$/.test(passwordInput));
                const duressStored = (config && (config.duress_pin || config.duress_hash)) || null;
                const isDuressMatch = (duressStored && await verifyAppLockSecret(passwordInput, duressStored, config.salt)) || (isAllNines && !isPasswordMatch);

                if (isPasswordMatch || isDuressMatch) {


                    if (this.pendingCallback) {
                        this.pendingCallback();
                        this.pendingCallback = null;
                    }
                    this.closeAuthModal();
                    showToast("Access Granted", false);
                    triggerSound('LOCK_SUCCESS');
                } else {
                    showToast("WRONG PASSWORD", true);
                    triggerSound('ERROR');
                    if (inputField) inputField.value = '';
                    if (window.shakeAuthCard) window.shakeAuthCard();
                }
            }
        },

        closeAuthModal: function () {
            const authModal = document.getElementById('app-auth-modal');
            if (authModal) authModal.style.display = 'none';
            this.pendingCallback = null;
        },

        unlockSettingsPrivacy: function () {
            // For mobile settings page compatibility
            const frame = document.getElementById('settings-frame');
            if (frame && frame.contentWindow) {
                try {
                    frame.contentWindow.unlockPrivacySection();
                } catch (e) { }
            }
        }
    };
})();

// Map global callbacks
window.unlockApp = function () { window._0x83e2.unlockApp(); };
window.unlockWithBiometricsAction = async function () {
    try {
        if (!window.CosmoWebAuthn) return;
        const pin = await window.CosmoWebAuthn.retrieveBiometricVaultKey();
        if (pin) {
            const inp = document.getElementById('lock-password-input');
            if (inp) inp.value = pin;
            if (window.updatePinDisplay) window.updatePinDisplay();
            if (window._0x83e2 && typeof window._0x83e2.unlockApp === 'function') {
                await window._0x83e2.unlockApp();
            }
        }
    } catch (e) {
        console.warn("Biometric quick unlock cancelled or not verified:", e);
    }
};
window.cancelAppLock = function () { window._0x83e2.cancelAppLock(); };
window.showRecovery = function () { window._0x83e2.showRecovery(); };
window.hideRecovery = function () { window._0x83e2.hideRecovery(); };
window.verifyRecovery = function () { window._0x83e2.verifyRecovery(); };
window.resetPassword = function () { window._0x83e2.resetPassword(); };
window.verifyAuth = function () { window._0x83e2.verifyAuth(); };
window.closeAuthModal = function () { window._0x83e2.closeAuthModal(); };
window.openLockHelpFeedback = function () {
    document.getElementById('app-lock-help-overlay').style.display = 'none';
    if (typeof switchView === 'function') {
        switchView('feedback');
        const fbEl = document.getElementById('view-feedback');
        if (fbEl) {
            fbEl.style.zIndex = '2147483645';
        }
    }
};

// Intercept back button specifically to dismiss/cancel the App Lock overlay
window.addEventListener('popstate', function (event) {
    if (window._0x83e2 && window._0x83e2._lockStatePushed) {
        window._0x83e2._lockStatePushed = false;
        window._0x83e2.cancelAppLock();
    }
});

window.addPinDigit = function (digit) {
    const isReset = document.getElementById('reset-password-section').style.display === 'block';
    const input = isReset ? document.getElementById('new-lock-password') : document.getElementById('lock-password-input');
    const maxLen = isReset ? 6 : ((window._0x83e2 && window._0x83e2.targetPinLength) || 4);
    if (input && input.value.length < maxLen) {
        input.value += digit;
        if (!isReset) window.updatePinDisplay();
        if (!isReset && input.value.length === maxLen) {
            setTimeout(() => {
                window._0x83e2.unlockApp();
            }, 60);
        }
    }
};
window.deletePinDigit = function () {
    const isReset = document.getElementById('reset-password-section').style.display === 'block';
    const input = isReset ? document.getElementById('new-lock-password') : document.getElementById('lock-password-input');
    if (input.value.length > 0) {
        input.value = input.value.slice(0, -1);
        if (!isReset) window.updatePinDisplay();
    }
};

// Handle physical keyboard input for Lock and Reset
window.addEventListener('keydown', function (e) {
    const lockScreen = document.getElementById('app-lock-screen');
    if (lockScreen && lockScreen.style.display !== 'none' && lockScreen.style.opacity !== '0') {
        const isRecovery = document.getElementById('recovery-section').style.display === 'block';
        if (isRecovery) return; // allow typing natively in recovery

        const isDigit = /^[0-9]$/.test(e.key);
        if (isDigit) {
            window.addPinDigit(e.key);
        } else if (e.key === 'Backspace') {
            window.deletePinDigit();
        } else if (e.key === 'Enter') {
            const isReset = document.getElementById('reset-password-section').style.display === 'block';
            if (!isReset && document.getElementById('lock-password-input').value.length >= 4) {
                window._0x83e2.unlockApp();
            }
        }
    }
});

window.updatePinDisplay = function () {
    const len = document.getElementById('lock-password-input').value.length;
    const dots = document.querySelectorAll('#pin-display .pin-dot');
    dots.forEach((dot, index) => {
        if (index < len) {
            dot.classList.add('filled');
        } else {
            dot.classList.remove('filled');
        }
    });
};

window.toggleLockPassword = function (inputId, eyeId) {
    const field = document.getElementById(inputId);
    const eye = document.getElementById(eyeId);
    if (field) {
        if (field.type === 'password') {
            field.type = 'text';
            if (eye) eye.innerText = 'visibility_off';
        } else {
            field.type = 'password';
            if (eye) eye.innerText = 'visibility';
        }
    }
};

window.shakeLockCard = function () {
    const card = document.querySelector('#app-lock-screen .saas-premium-card');
    if (card) {
        card.classList.add('saas-shake-error');
        setTimeout(() => card.classList.remove('saas-shake-error'), 800);
    }
};

window.shakeAuthCard = function () {
    const card = document.querySelector('#app-auth-modal .saas-premium-card');
    if (card) {
        card.classList.add('saas-shake-error');
        setTimeout(() => card.classList.remove('saas-shake-error'), 800);
    }
};

// Global animationend listener to clean up entrance animations on premium cards
document.addEventListener('animationend', function (e) {
    if (e.animationName === 'premium-slide-up' && e.target.classList.contains('saas-premium-card')) {
        e.target.style.animation = 'none';
    }
});



window.commitAppLock = async function () {
    function findEl(id) {
        // 1. Check settings-frame iframe if it exists
        const frame = document.getElementById('settings-frame');
        if (frame && frame.contentWindow) {
            try {
                const doc = frame.contentDocument || frame.contentWindow.document;
                if (doc && doc.getElementById(id)) return doc.getElementById(id);
            } catch (e) { }
        }
        // 2. Check current document
        if (document.getElementById(id)) return document.getElementById(id);

        // 3. Check all iframes in document
        const iframes = document.querySelectorAll('iframe');
        for (let i = 0; i < iframes.length; i++) {
            try {
                const doc = iframes[i].contentDocument || iframes[i].contentWindow.document;
                if (doc && doc.getElementById(id)) return doc.getElementById(id);
            } catch (e) { }
        }
        return null;
    }

    const passwordEl = findEl('global-cipher-field');
    const questionEl = findEl('security-question-select');
    const answerEl = findEl('security-answer-field');

    if (!passwordEl || !questionEl || !answerEl) {
        showToast("Security fields not found in Settings.", true);
        return;
    }

    const password = passwordEl.value;
    const questionId = questionEl.value;
    const answer = answerEl.value;

    const decoyEl = findEl('custom-decoy-pin-field');
    const panicEl = findEl('custom-panic-pin-field');
    const decoyPinVal = decoyEl ? decoyEl.value.trim() : '';
    const panicPinVal = panicEl ? panicEl.value.trim() : '';

    // Check if fields are still dummy values (unchanged)
    const isPasswordUntouched = (password === '••••••••');
    const isAnswerUntouched = (answer === '••••••••');

    const currentConfigDecrypted = await window._0x83e2.getDecryptedConfigForSettings();

    if (!isPasswordUntouched) {
        if (!password || password.length < 4 || password.length > 6 || !/^\d+$/.test(password)) {
            showToast("Password must be a 4 to 6 digit numeric PIN.", true);
            return;
        }
    }
    if (decoyPinVal && !/^\d{4,6}$/.test(decoyPinVal)) {
        showToast("Custom Decoy PIN must be a 4 to 6 digit numeric PIN.", true);
        return;
    }
    if (panicPinVal && !/^\d{4,6}$/.test(panicPinVal)) {
        showToast("Custom Panic PIN must be a 4 to 6 digit numeric PIN.", true);
        return;
    }
    if (decoyPinVal && (decoyPinVal === password || (isPasswordUntouched && currentConfigDecrypted && decoyPinVal === currentConfigDecrypted.password))) {
        showToast("Custom Decoy PIN cannot be the same as your Master PIN.", true);
        return;
    }
    if (panicPinVal && (panicPinVal === password || (isPasswordUntouched && currentConfigDecrypted && panicPinVal === currentConfigDecrypted.password))) {
        showToast("Custom Panic PIN cannot be the same as your Master PIN.", true);
        return;
    }
    if (decoyPinVal && panicPinVal && decoyPinVal === panicPinVal) {
        showToast("Custom Decoy PIN and Custom Panic PIN cannot be identical.", true);
        return;
    }

    if (!questionId) {
        showToast("Please select a security question.", true);
        return;
    }
    if (!isAnswerUntouched && !answer) {
        showToast("Please provide a security answer.", true);
        return;
    }

    const existingDuress = (currentConfigDecrypted && currentConfigDecrypted.duress_pin) ? currentConfigDecrypted.duress_pin : '';
    const existingPanic = (currentConfigDecrypted && currentConfigDecrypted.panic_pin) ? currentConfigDecrypted.panic_pin : '';
    const finalDuress = decoyPinVal || existingDuress;
    const finalPanic = panicPinVal || existingPanic;

    const config = {
        password: isPasswordUntouched ? (currentConfigDecrypted ? currentConfigDecrypted.password : '') : password,
        duress_pin: finalDuress,
        panic_pin: finalPanic,
        questionId: questionId,
        answer: isAnswerUntouched ? (currentConfigDecrypted ? currentConfigDecrypted.answer : '') : answer.toLowerCase().trim(),
        enabled: true
    };

    const container = findEl('settings-privacy-container');
    if (container && container.classList.contains('privacy-restricted')) {
        showToast("Unlock security settings before committing.", true);
        return;
    }

    window.startSecurityConfirmation(config);
};

let pendingLockConfig = null;
window.startSecurityConfirmation = function (config) {
    pendingLockConfig = config;
    const overlay = document.getElementById('security-confirm-overlay');
    if (overlay) {
        overlay.style.display = 'flex';
        window.nextSecurityLayer(1);
        try {
            history.pushState({ modalOpen: true, modalId: 'securityConfirmOverlay' }, "");
        } catch (e) { }
    }
};
window.nextSecurityLayer = function (step) {
    for (let i = 1; i <= 3; i++) {
        const layer = document.getElementById(`confirm-layer-${i}`);
        if (layer) layer.classList.remove('active');
    }
    const target = document.getElementById(`confirm-layer-${step}`);
    if (target) target.classList.add('active');
};
window.closeSecurityConfirmation = function (fromPopState = false) {
    const overlay = document.getElementById('security-confirm-overlay');
    if (overlay) {
        overlay.style.display = 'none';
        window.nextSecurityLayer(1);
    }
    pendingLockConfig = null;

    // Direct close all related App Lock / Settings modals in active frames
    const iframes = document.querySelectorAll('iframe');
    iframes.forEach(frame => {
        try {
            if (frame.contentWindow) {
                if (typeof frame.contentWindow.closeDestructiveWarning === 'function') {
                    frame.contentWindow.closeDestructiveWarning(true);
                }
                if (typeof frame.contentWindow.closeSettingsModal === 'function') {
                    frame.contentWindow.closeSettingsModal(true);
                }
            }
        } catch (e) { }
    });

    if (!fromPopState) {
        if (history.state && history.state.modalId === 'securityConfirmOverlay') {
            history.back();
        }
    }
};
window.finalizeAppLock = async function () {
    if (pendingLockConfig) {
        await window._0x83e2.saveNewLockConfig(pendingLockConfig);
        window.closeSecurityConfirmation();
    }
};

// --- SECURE PDF DOWNLOAD MANAGER ---
let pendingPDFAuthorizedCallback = null;

function showAppToast(msg, isError = false) {
    if (typeof showToast === 'function') {
        showToast(msg, isError);
    } else if (window.parent && typeof window.parent.showToast === 'function') {
        window.parent.showToast(msg, isError);
    } else {
        alert(msg);
    }
}

try {
    localStorage.removeItem('card_mutation_config');
    localStorage.removeItem('secure_pdf_config');
} catch (e) { }

// ── Universal Security Limiter & Cooldown Manager ──────────────────
window.CosmoSecurityLimiter = {
    activeTimers: {},
    activeBindings: {},
    isLocked: function (scopeKey) {
        try {
            const until = Math.max((window._cosmoLockoutState && window._cosmoLockoutState[scopeKey]) || 0, (window.parent && window.parent._cosmoLockoutState && window.parent._cosmoLockoutState[scopeKey]) || 0, parseInt(sessionStorage.getItem(`cosmo_lockout_${scopeKey}`) || '0', 10), parseInt(localStorage.getItem(`cosmo_lockout_${scopeKey}`) || '0', 10), parseInt((window.parent && window.parent.localStorage && window.parent.localStorage.getItem(`cosmo_lockout_${scopeKey}`)) || '0', 10)); //


            if (until > Date.now()) {
                window._cosmoLockoutState = window._cosmoLockoutState || {}; window._cosmoLockoutState[scopeKey] = until;
                if (window.parent) { window.parent._cosmoLockoutState = window.parent._cosmoLockoutState || {}; window.parent._cosmoLockoutState[scopeKey] = until; }
                try { sessionStorage.setItem(`cosmo_lockout_${scopeKey}`, until.toString()); } catch (e) { }
                try { localStorage.setItem(`cosmo_lockout_${scopeKey}`, until.toString()); } catch (e) { }
                if (window.parent && window.parent.localStorage) { try { window.parent.localStorage.setItem(`cosmo_lockout_${scopeKey}`, until.toString()); } catch (e) { } }
                return true;
            }
            return false;
        } catch (e) { return false; }
    },
    getRemainingSeconds: function (scopeKey) {
        try {
            const until = Math.max((window._cosmoLockoutState && window._cosmoLockoutState[scopeKey]) || 0, (window.parent && window.parent._cosmoLockoutState && window.parent._cosmoLockoutState[scopeKey]) || 0, parseInt(sessionStorage.getItem(`cosmo_lockout_${scopeKey}`) || '0', 10), parseInt(localStorage.getItem(`cosmo_lockout_${scopeKey}`) || '0', 10), parseInt((window.parent && window.parent.localStorage && window.parent.localStorage.getItem(`cosmo_lockout_${scopeKey}`)) || '0', 10)); //


            return Math.max(0, Math.ceil((until - Date.now()) / 1000));
        } catch (e) { return 0; }
    },
    refreshActiveBindings: function () {
        try {
            for (const scopeKey in this.activeBindings) {
                const b = this.activeBindings[scopeKey];
                if (b && b.inputEl && b.submitBtnEl) {
                    this.bindCountdown(scopeKey, b.inputEl, b.submitBtnEl, b.bannerEl, b.originalBtnText);
                }
            }
        } catch (e) { }
    },
    recordFailure: function (scopeKey, maxAttempts = 3, lockoutMinutes = 5) {
        try {
            let attempts = parseInt(sessionStorage.getItem(`cosmo_attempts_${scopeKey}`) || '0', 10) + 1;
            sessionStorage.setItem(`cosmo_attempts_${scopeKey}`, attempts.toString());
            if (attempts >= maxAttempts) {
                const lockoutUntil = Date.now() + (lockoutMinutes * 60 * 1000);
                window._cosmoLockoutState = window._cosmoLockoutState || {};
                window._cosmoLockoutState[scopeKey] = lockoutUntil;
                if (window.parent) {
                    window.parent._cosmoLockoutState = window.parent._cosmoLockoutState || {};
                    window.parent._cosmoLockoutState[scopeKey] = lockoutUntil;
                }
                try { sessionStorage.setItem(`cosmo_lockout_${scopeKey}`, lockoutUntil.toString()); } catch (e) { }
                try { if (typeof lockoutUntil !== 'undefined' && lockoutUntil > 0) localStorage.setItem(`cosmo_lockout_${scopeKey}`, lockoutUntil.toString()); else localStorage.removeItem(`cosmo_lockout_${scopeKey}`); } catch (e) { }
                try { if (window.parent && window.parent.localStorage) { if (typeof lockoutUntil !== 'undefined' && lockoutUntil > 0) window.parent.localStorage.setItem(`cosmo_lockout_${scopeKey}`, lockoutUntil.toString()); else window.parent.localStorage.removeItem(`cosmo_lockout_${scopeKey}`); } } catch (e) { }
                sessionStorage.removeItem(`cosmo_attempts_${scopeKey}`);
                const syncFn = window.syncLockoutToCloud || (window.parent && window.parent.syncLockoutToCloud);
                if (typeof syncFn === 'function') syncFn(scopeKey, lockoutUntil);
                this.refreshActiveBindings();
                return { locked: true, remainingSeconds: lockoutMinutes * 60, attemptsLeft: 0 };
            }
            return { locked: false, remainingSeconds: 0, attemptsLeft: maxAttempts - attempts };
        } catch (e) {
            return { locked: false, remainingSeconds: 0, attemptsLeft: 1 };
        }
    },
    recordSuccess: function (scopeKey) {
        try {
            sessionStorage.removeItem(`cosmo_attempts_${scopeKey}`);
            if (window._cosmoLockoutState) delete window._cosmoLockoutState[scopeKey];
            if (window.parent && window.parent._cosmoLockoutState) delete window.parent._cosmoLockoutState[scopeKey];
            try { sessionStorage.removeItem(`cosmo_lockout_${scopeKey}`); } catch (e) { }
            try { if (typeof lockoutUntil !== 'undefined' && lockoutUntil > 0) localStorage.setItem(`cosmo_lockout_${scopeKey}`, lockoutUntil.toString()); else localStorage.removeItem(`cosmo_lockout_${scopeKey}`); } catch (e) { }
            try { if (window.parent && window.parent.localStorage) { if (typeof lockoutUntil !== 'undefined' && lockoutUntil > 0) window.parent.localStorage.setItem(`cosmo_lockout_${scopeKey}`, lockoutUntil.toString()); else window.parent.localStorage.removeItem(`cosmo_lockout_${scopeKey}`); } } catch (e) { }
            const syncFn = window.syncLockoutToCloud || (window.parent && window.parent.syncLockoutToCloud);
            if (typeof syncFn === 'function') syncFn(scopeKey, 0);
            if (this.activeTimers[scopeKey]) {
                clearInterval(this.activeTimers[scopeKey]);
                delete this.activeTimers[scopeKey];
            }
            this.refreshActiveBindings();
        } catch (e) { }
    },
    forceLock: function (scopeKey, lockoutMinutes = 5) {
        try {
            const lockoutUntil = Date.now() + (lockoutMinutes * 60 * 1000);
            window._cosmoLockoutState = window._cosmoLockoutState || {};
            window._cosmoLockoutState[scopeKey] = lockoutUntil;
            if (window.parent) {
                window.parent._cosmoLockoutState = window.parent._cosmoLockoutState || {};
                window.parent._cosmoLockoutState[scopeKey] = lockoutUntil;
            }
            try { sessionStorage.setItem(`cosmo_lockout_${scopeKey}`, lockoutUntil.toString()); } catch (e) { }
            try { if (typeof lockoutUntil !== 'undefined' && lockoutUntil > 0) localStorage.setItem(`cosmo_lockout_${scopeKey}`, lockoutUntil.toString()); else localStorage.removeItem(`cosmo_lockout_${scopeKey}`); } catch (e) { }
            try { if (window.parent && window.parent.localStorage) { if (typeof lockoutUntil !== 'undefined' && lockoutUntil > 0) window.parent.localStorage.setItem(`cosmo_lockout_${scopeKey}`, lockoutUntil.toString()); else window.parent.localStorage.removeItem(`cosmo_lockout_${scopeKey}`); } } catch (e) { }
            sessionStorage.removeItem(`cosmo_attempts_${scopeKey}`);
            const syncFn = window.syncLockoutToCloud || (window.parent && window.parent.syncLockoutToCloud);
            if (typeof syncFn === 'function') syncFn(scopeKey, lockoutUntil);
            this.refreshActiveBindings();
            return { locked: true, remainingSeconds: lockoutMinutes * 60, attemptsLeft: 0 };
        } catch (e) {
            return { locked: true, remainingSeconds: lockoutMinutes * 60, attemptsLeft: 0 };
        }
    },
    bindCountdown: function (scopeKey, inputEl, submitBtnEl, bannerEl, originalBtnText = 'Verify & Unlock') {
        if (inputEl && submitBtnEl) {
            this.activeBindings[scopeKey] = { inputEl, submitBtnEl, bannerEl, originalBtnText };
        }
        if (this.activeTimers[scopeKey]) {
            clearInterval(this.activeTimers[scopeKey]);
            delete this.activeTimers[scopeKey];
        }

        const updateUI = () => {
            const remaining = this.getRemainingSeconds(scopeKey);
            if (remaining <= 0) {
                if (this.activeTimers[scopeKey]) {
                    clearInterval(this.activeTimers[scopeKey]);
                    delete this.activeTimers[scopeKey];
                }
                try { sessionStorage.removeItem(`cosmo_lockout_${scopeKey}`); } catch (e) { }
                try { if (typeof lockoutUntil !== 'undefined' && lockoutUntil > 0) localStorage.setItem(`cosmo_lockout_${scopeKey}`, lockoutUntil.toString()); else localStorage.removeItem(`cosmo_lockout_${scopeKey}`); } catch (e) { }
                if (inputEl) {
                    inputEl.disabled = false;
                    inputEl.style.opacity = '1';
                    inputEl.style.cursor = 'text';
                }
                if (submitBtnEl) {
                    submitBtnEl.disabled = false;
                    submitBtnEl.style.opacity = '1';
                    submitBtnEl.style.cursor = 'pointer';
                    submitBtnEl.textContent = originalBtnText;
                }
                if (bannerEl) {
                    bannerEl.style.display = 'none';
                    bannerEl.innerHTML = '';
                }
                return false;
            }

            const mins = Math.floor(remaining / 60).toString().padStart(2, '0');
            const secs = (remaining % 60).toString().padStart(2, '0');

            if (inputEl) {
                inputEl.disabled = true;
                inputEl.style.opacity = '0.6';
                inputEl.style.cursor = 'not-allowed';
            }
            if (submitBtnEl) {
                submitBtnEl.disabled = true;
                submitBtnEl.style.opacity = '0.5';
                submitBtnEl.style.cursor = 'not-allowed';
                submitBtnEl.textContent = `Locked (${mins}:${secs})`;
            }
            if (bannerEl) {
                bannerEl.style.display = 'block';
                bannerEl.innerHTML = `🔒 <b>Security Lockout Active:</b> Too many failed attempts.<br/>Please wait <b>${mins}:${secs}</b> before trying again.`;
            }
            return true;
        };

        if (updateUI()) {
            this.activeTimers[scopeKey] = setInterval(updateUI, 1000);
        }
    }
};

if (window.parent && window.parent !== window) {
    window.parent.CosmoSecurityLimiter = window.CosmoSecurityLimiter;
}

window.CosmoCardMutationManager = {
    isUserLoggedIn: function () {
        try {
            if (localStorage.getItem('explicit_logout') === 'true') return false;
            const pAuth = (window.parent && (window.parent.suiteAuth || window.parent.auth)) || window.suiteAuth || window.auth;
            const fbAuth = (window.auth || (window.parent && window.parent.auth));
            const currentUser = (pAuth && pAuth.currentUser) ? pAuth.currentUser : (fbAuth && fbAuth.currentUser);
            if (!currentUser) return false;
            const userEnc = sessionStorage.getItem('userStoreEnc') || localStorage.getItem('userStoreEnc');
            const ud = window.userData || (window.parent && window.parent.userData);
            return !!(userEnc || ud);
        } catch (e) { }
        return false;
    },
    isCardMutationLockEnabled: function () {
        const contexts = [
            window.userData,
            (window.parent && window.parent !== window) ? window.parent.userData : null,
            (window.top && window.top !== window) ? window.top.userData : null
        ];
        for (const ud of contexts) {
            if (ud) {
                const cfg = (ud.settings && ud.settings.card_mutation_config) || ud.card_mutation_config;
                if (cfg && cfg.enabled !== undefined) return !!cfg.enabled;
            }
        }
        try {
            const enc = sessionStorage.getItem('userStoreEnc') || localStorage.getItem('userStoreEnc');
            if (enc && typeof CryptoJS !== 'undefined') {
                const bytes = CryptoJS.AES.decrypt(enc, _getAppSecret());
                const u = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                if (u && u.settings && u.settings.card_mutation_config) {
                    return !!u.settings.card_mutation_config.enabled;
                }
            }
        } catch (e) { }
        return false;
    },
    getCardMutationPassword: function () {
        const contexts = [
            window.userData,
            (window.parent && window.parent !== window) ? window.parent.userData : null,
            (window.top && window.top !== window) ? window.top.userData : null
        ];
        for (const ud of contexts) {
            if (ud) {
                const cfg = (ud.settings && ud.settings.card_mutation_config) || ud.card_mutation_config;
                if (cfg && cfg.password) return cfg.password;
            }
        }
        try {
            const enc = sessionStorage.getItem('userStoreEnc') || localStorage.getItem('userStoreEnc');
            if (enc && typeof CryptoJS !== 'undefined') {
                const bytes = CryptoJS.AES.decrypt(enc, _getAppSecret());
                const u = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                if (u && u.settings && u.settings.card_mutation_config) {
                    return u.settings.card_mutation_config.password || '';
                }
            }
        } catch (e) { }
        return '';
    },
    setCardMutationConfig: function (enabled, password) {
        const config = { enabled: !!enabled, password: password !== undefined ? password : this.getCardMutationPassword() };

        const contexts = [window, window.parent, window.top].filter(w => w && w.userData);
        contexts.forEach(ctx => {
            if (!ctx.userData.settings) ctx.userData.settings = {};
            ctx.userData.settings.card_mutation_config = config;
        });

        try {
            document.querySelectorAll('.view-layer iframe, iframe').forEach(iframe => {
                try {
                    if (iframe.contentWindow) {
                        if (iframe.contentWindow.userData) {
                            if (!iframe.contentWindow.userData.settings) iframe.contentWindow.userData.settings = {};
                            iframe.contentWindow.userData.settings.card_mutation_config = config;
                        }
                        if (typeof iframe.contentWindow.updateSettingsCardMutationCardState === 'function') {
                            iframe.contentWindow.updateSettingsCardMutationCardState();
                        }
                        if (typeof iframe.contentWindow.initCardMutationModalUI === 'function') {
                            iframe.contentWindow.initCardMutationModalUI();
                        }
                    }
                } catch (e) { }
            });
        } catch (e) { }

        const fn = window.saveCardMutationConfigToFirebase || (window.parent && window.parent.saveCardMutationConfigToFirebase) || (window.top && window.top.saveCardMutationConfigToFirebase);
        if (typeof fn === 'function') {
            fn(config.enabled, config.password);
        }
        if (typeof window.updateSettingsCardMutationCardState === 'function') {
            window.updateSettingsCardMutationCardState();
        }
        if (window.parent && typeof window.parent.updateSettingsCardMutationCardState === 'function') {
            window.parent.updateSettingsCardMutationCardState();
        }
    }
};

let pendingMutationAuthorizedCallback = null;

window.openCardMutationPromptModal = function (action) {
    let modal = document.getElementById('cardMutationVerificationModal');
    if (!modal) {
        modal = document.createElement('div');
        modal.className = 'confirm-modal-overlay';
        modal.id = 'cardMutationVerificationModal';
        modal.style.cssText = 'display: flex; z-index: 999999; position: fixed; inset: 0; background: rgba(0, 0, 0, 0.4); backdrop-filter: blur(8px); justify-content: center; align-items: center;';
        modal.innerHTML = `
                    <div class="confirm-modal-card" style="background: rgba(255, 255, 255, 0.96); border: 1px solid rgba(16, 185, 129, 0.4); border-radius: 24px; padding: 28px; max-width: 440px; width: 90%; color: #0f172a; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);">
                        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; gap: 8px; margin-bottom: 12px;">
                            <span class="material-symbols-outlined text-emerald-600" style="font-size: 36px; color: #10b981;">shield_lock</span>
                            <h3 class="confirm-modal-title" style="margin: 0; font-size: 1.15rem; font-weight: 800; color: #0f172a; text-align: center;">Card Mutation Lock</h3>
                        </div>
                        <p id="cardMutationPromptText" class="confirm-modal-text" style="font-size: 0.8rem; color: #475569; margin-bottom: 16px; text-align: center;">
                            Card Mutation protection is active. Enter your security passcode to modify or delete this credential card.
                        </p>
                        <div id="cardMutationLockoutBanner" style="display: none; background: rgba(239, 68, 68, 0.1); border: 1px solid rgba(239, 68, 68, 0.3); border-radius: 12px; padding: 10px; color: #ef4444; font-size: 0.8rem; font-weight: 700; text-align: center; margin-bottom: 16px;"></div>
                        <div style="position: relative; margin-bottom: 20px;">
                            <input type="password" id="cardMutationPromptInputPassword" placeholder="Mutation Security Passcode..."
                                onkeydown="if(event.key==='Enter') submitCardMutationPromptPassword()"
                                style="background: #ffffff; border: 1px solid #cbd5e1; border-radius: 12px; padding: 12px 40px 12px 14px; color: #0f172a; width: 100%; outline: none; font-size: 0.85rem;" />
                            <button type="button" onclick="togglePasswordVisibility('cardMutationPromptInputPassword', this)"
                                style="position: absolute; right: 12px; top: 50%; transform: translateY(-50%); color: #64748b; background: none; border: none; cursor: pointer;">👁️</button>
                        </div>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <button type="button" onclick="closeCardMutationPromptModal()" style="padding: 10px 18px; border-radius: 12px; border: 1px solid #cbd5e1; background: #f8fafc; color: #475569; font-size: 0.8rem; font-weight: 700; cursor: pointer;">Cancel</button>
                            <button type="button" id="cardMutationSubmitBtn" onclick="submitCardMutationPromptPassword()" style="padding: 10px 18px; border-radius: 12px; border: none; background: #10b981; color: white; font-size: 0.8rem; font-weight: 800; cursor: pointer;">Authorize Action</button>
                        </div>
                    </div>
                `;
        document.body.appendChild(modal);
    }
    const textEl = document.getElementById('cardMutationPromptText');
    if (textEl) {
        textEl.textContent = `Card Mutation protection is active. Enter your security passcode to ${action} this credential card.`;
    }
    modal.style.display = 'flex';
    if (history.pushState) {
        history.pushState({ modalOpen: true, modalId: 'cardMutationVerificationModal' }, '');
    }
    const input = document.getElementById('cardMutationPromptInputPassword');
    const submitBtn = document.getElementById('cardMutationSubmitBtn');
    const banner = document.getElementById('cardMutationLockoutBanner');

    const limiter = window.CosmoSecurityLimiter || (window.parent && window.parent.CosmoSecurityLimiter);
    if (limiter) {
        limiter.bindCountdown('card_mutation', input, submitBtn, banner, 'Authorize Action');
    }

    if (input && !input.disabled) {
        input.value = '';
        input.type = 'password';
        setTimeout(() => input.focus(), 100);
    }
};

window.closeCardMutationPromptModal = function (fromPopState = false) {
    const modal = document.getElementById('cardMutationVerificationModal');
    if (modal) modal.style.display = 'none';
    pendingMutationAuthorizedCallback = null;
    if (!fromPopState) {
        if (history.state && history.state.modalOpen && history.state.modalId === 'cardMutationVerificationModal') {
            history.back();
        }
    }
};

window.submitCardMutationPromptPassword = async function () {
    const limiter = window.CosmoSecurityLimiter || (window.parent && window.parent.CosmoSecurityLimiter);
    const input = document.getElementById('cardMutationPromptInputPassword');
    const submitBtn = document.getElementById('cardMutationSubmitBtn');
    const banner = document.getElementById('cardMutationLockoutBanner');

    if (limiter && limiter.isLocked('card_mutation')) {
        const secs = limiter.getRemainingSeconds('card_mutation');
        const mins = Math.ceil(secs / 60);
        const lockMsg = `🔒 Security Lockout Active! Please wait ${mins} min before retrying.`;
        if (typeof showAppToast === 'function') showAppToast(lockMsg, true);
        else if (typeof showToast === 'function') showToast(lockMsg, 'error', 'LOCKOUT');
        else if (window.parent && typeof window.parent.showToast === 'function') window.parent.showToast(lockMsg, 'error', 'LOCKOUT');
        return;
    }

    const entered = input ? input.value : '';
    const mutMgr = window.CosmoCardMutationManager || (window.parent && window.parent.CosmoCardMutationManager);
    const correct = mutMgr ? mutMgr.getCardMutationPassword() : '';

    const verifyFn = window.verifyAppLockSecret || verifyAppLockSecret;
    const isMatch = verifyFn ? await verifyFn(entered, correct) : (entered === correct);
    if (entered && isMatch) {
        if (limiter) limiter.recordSuccess('card_mutation');
        const cb = pendingMutationAuthorizedCallback;
        pendingMutationAuthorizedCallback = null;
        const modal = document.getElementById('cardMutationVerificationModal');
        if (modal) modal.style.display = 'none';
        if (typeof showAppToast === 'function') showAppToast("Passcode Verified. Authorizing Action...", false);
        else if (typeof showToast === 'function') showToast("Passcode Verified. Authorizing Action...", 'success', 'AUTHORIZED');
        if (typeof cb === 'function') {
            cb();
        }
    } else {
        if (limiter) {
            const status = limiter.recordFailure('card_mutation', 3, 5);
            limiter.bindCountdown('card_mutation', input, submitBtn, banner, 'Authorize Action');

            if (status.locked) {
                const lockMsg = "🚨 3 failed attempts! Card Mutation locked for 5 minutes.";
                if (typeof showAppToast === 'function') showAppToast(lockMsg, true);
                else if (typeof showToast === 'function') showToast(lockMsg, 'error', 'SECURITY LOCKOUT');
                else if (window.parent && typeof window.parent.showToast === 'function') window.parent.showToast(lockMsg, 'error', 'SECURITY LOCKOUT');
            } else {
                const errToast = `❌ Incorrect passcode! (${status.attemptsLeft} ${status.attemptsLeft === 1 ? 'attempt' : 'attempts'} remaining)`;
                if (typeof showAppToast === 'function') showAppToast(errToast, true);
                else if (typeof showToast === 'function') showToast(errToast, 'error', 'SECURITY LOCK');
                else if (window.parent && typeof window.parent.showToast === 'function') window.parent.showToast(errToast, 'error', 'SECURITY LOCK');
            }
        } else {
            const errToast = "❌ Incorrect passcode! Please try again.";
            if (typeof showAppToast === 'function') showAppToast(errToast, true);
            else if (typeof showToast === 'function') showToast(errToast, 'error', 'SECURITY LOCK');
        }
    }
};

window.getUserActivePlanTier = function () {
    try {
        let history = window._cosmoPurchaseHistoryState || [];
        if (!Array.isArray(history)) history = [];

        const ud = window.userData || (window.parent && window.parent.userData);
        if (ud && ud.subscription_history && Array.isArray(ud.subscription_history)) {
            history = [...history, ...ud.subscription_history];
        }

        const activeSub = localStorage.getItem('user_subscription');
        if (activeSub) {
            try {
                const parsedSub = JSON.parse(activeSub);
                if (parsedSub && parsedSub.planName) history.push(parsedSub);
            } catch (e) { }
        }

        const now = new Date();
        const active = history.find(item => {
            if (!item || !item.planName) return false;
            const name = String(item.planName).toLowerCase();
            if (['foundation', 'element'].includes(name)) return false;
            if (!item.expiryDate) return true;
            return new Date(item.expiryDate) > now;
        });

        if (active && active.planName) {
            const name = String(active.planName).toLowerCase();
            if (name.includes('quantum') || name.includes('ultra')) return 'Quantum';
            if (name.includes('matrix') || name.includes('pro')) return 'Matrix';
            if (name.includes('catalyst') || name.includes('velocity') || name.includes('max')) return 'Catalyst';
        }
    } catch (e) { }
    return 'Element';
};

window.PLAN_CARD_LIMITS = {
    'Element': 10,
    'Catalyst': 25,
    'Matrix': 50,
    'Quantum': Infinity
};

window.openPremiumLimitExceededModal = function (userTier = 'Element', currentCount = 10, limit = 10) {
    const tierNorm = String(userTier).toLowerCase();

    // Tier Color Theme: Element (Red #ef4444), Catalyst (Orange #f97316), Matrix (Blue #3b82f6), Quantum (Purple #a855f7)
    let themeColor = '#ef4444'; // Red for Element Plan
    let badgeText = 'ELEMENT PLAN LIMIT REACHED';
    let titleGradient = 'linear-gradient(135deg, #fca5a5 0%, #ef4444 100%)';
    let btnGradient = 'linear-gradient(135deg, #ef4444 0%, #dc2626 100%)';
    let btnShadow = '0 4px 14px rgba(239, 68, 68, 0.4)';
    let cardShadow = '0 30px 60px -12px rgba(0,0,0,0.7), 0 0 40px rgba(239, 68, 68, 0.2)';
    let btnLabel = '🚀 UPGRADE TO CATALYST (25 CARDS)';

    if (tierNorm.includes('catalyst') || tierNorm.includes('velocity') || tierNorm.includes('max')) {
        themeColor = '#f97316'; // Orange for Catalyst Plan
        badgeText = 'CATALYST PLAN LIMIT REACHED';
        titleGradient = 'linear-gradient(135deg, #fdba74 0%, #f97316 100%)';
        btnGradient = 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)';
        btnShadow = '0 4px 14px rgba(249, 115, 22, 0.4)';
        cardShadow = '0 30px 60px -12px rgba(0,0,0,0.7), 0 0 40px rgba(249, 115, 22, 0.2)';
        btnLabel = '🚀 UPGRADE TO MATRIX (50 CARDS)';
    } else if (tierNorm.includes('matrix') || tierNorm.includes('pro')) {
        themeColor = '#3b82f6'; // Blue for Matrix Plan
        badgeText = 'MATRIX PLAN LIMIT REACHED';
        titleGradient = 'linear-gradient(135deg, #93c5fd 0%, #3b82f6 100%)';
        btnGradient = 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)';
        btnShadow = '0 4px 14px rgba(59, 130, 246, 0.4)';
        cardShadow = '0 30px 60px -12px rgba(0,0,0,0.7), 0 0 40px rgba(59, 130, 246, 0.2)';
        btnLabel = '🚀 UPGRADE TO QUANTUM (UNLIMITED)';
    } else if (tierNorm.includes('quantum') || tierNorm.includes('ultra')) {
        themeColor = '#a855f7'; // Purple for Quantum Plan
        badgeText = 'QUANTUM PLAN REACHED';
        titleGradient = 'linear-gradient(135deg, #c084fc 0%, #a855f7 100%)';
        btnGradient = 'linear-gradient(135deg, #a855f7 0%, #7c3aed 100%)';
        btnShadow = '0 4px 14px rgba(168, 85, 247, 0.4)';
        cardShadow = '0 30px 60px -12px rgba(0,0,0,0.7), 0 0 40px rgba(168, 85, 247, 0.2)';
        btnLabel = '🚀 ELEVATE RANK NOW';
    }

    let unlockModal = document.getElementById('premium-unlock-modal');
    if (!unlockModal && window.parent && window.parent.document) {
        unlockModal = window.parent.document.getElementById('premium-unlock-modal');
    }

    if (unlockModal) {
        const cardBox = unlockModal.querySelector('.saas-premium-card');
        if (cardBox) cardBox.style.boxShadow = cardShadow;

        const badgeEl = unlockModal.querySelector('#premium-unlock-badge') || unlockModal.querySelector('p');
        const titleEl = unlockModal.querySelector('#premium-unlock-title') || unlockModal.querySelector('h3');
        const descEl = unlockModal.querySelector('#premium-unlock-desc') || unlockModal.querySelectorAll('p')[1];
        const upgradeBtn = unlockModal.querySelector('#premium-upgrade-btn') || unlockModal.querySelector('button');
        const iconEl = unlockModal.querySelector('#premium-unlock-icon');

        if (iconEl) iconEl.style.color = themeColor;
        if (badgeEl) {
            badgeEl.textContent = badgeText;
            badgeEl.style.color = themeColor;
        }
        if (titleEl) {
            titleEl.textContent = 'PLAN LIMIT REACHED';
            titleEl.style.background = titleGradient;
            titleEl.style.webkitBackgroundClip = 'text';
            titleEl.style.webkitTextFillColor = 'transparent';
        }
        if (descEl) {
            descEl.innerHTML = `You have reached the maximum limit of <b style="color:${themeColor};">${currentCount} of ${limit} cards</b> on your <b style="color:#ffffff;">${userTier} Plan</b>. Upgrade to unlock more credential card slots!`;
        }
        if (upgradeBtn) {
            upgradeBtn.textContent = btnLabel;
            upgradeBtn.style.background = btnGradient;
            upgradeBtn.style.boxShadow = btnShadow;
            upgradeBtn.onclick = function () {
                if (typeof window.closePremiumUnlockModal === 'function') window.closePremiumUnlockModal();
                else if (window.parent && typeof window.parent.closePremiumUnlockModal === 'function') window.parent.closePremiumUnlockModal();
                if (typeof window.switchView === 'function') window.switchView('upgrade');
                else if (window.parent && typeof window.parent.switchView === 'function') window.parent.switchView('upgrade');
            };
        }

        unlockModal.style.display = 'flex';
        return;
    }

    let modal = document.getElementById('premiumLimitExceededModal');
    if (!modal && window.parent && window.parent.document) {
        modal = window.parent.document.getElementById('premiumLimitExceededModal');
    }

    if (!modal) {
        modal = document.createElement('div');
        modal.id = 'premiumLimitExceededModal';
        modal.onclick = function (event) { if (event.target === modal) window.closePremiumLimitExceededModal(); };
        modal.style.cssText = 'display: none; position: fixed; top: 0; left: 0; width: 100%; height: 100%; z-index: 2147483645; background: rgba(0,0,0,0.65) !important; align-items: center; justify-content: center; flex-direction: column; text-align: center; backdrop-filter: blur(18px); -webkit-backdrop-filter: blur(18px);';

        modal.innerHTML = `
            <div class="saas-premium-card"
                style="background:rgba(18, 18, 24, 0.95) !important; padding:36px 28px; border-radius:24px; border:1px solid rgba(255,255,255,0.14); color:white !important; font-family:'Inter', sans-serif; box-shadow: ${cardShadow}; max-width: 400px; width: 90%; box-sizing: border-box; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                
                <div style="width:56px; height:56px; border-radius:50%; background:rgba(255,255,255,0.05); border: 1px solid rgba(255,255,255,0.15); display:flex; align-items:center; justify-content:center; margin-bottom: 16px; box-shadow: inset 0 0 12px rgba(255,255,255,0.05);">
                    <span class="material-symbols-outlined" style="font-size:28px; color: ${themeColor};">workspace_premium</span>
                </div>

                <p style="font-size:11px; opacity:0.85; letter-spacing:3px; text-transform:uppercase; font-weight:800; color:${themeColor} !important; margin:0 0 8px 0;">
                    ${badgeText}</p>

                <h3 style="font-size:22px; font-weight:900; margin-bottom:12px; letter-spacing:-0.3px; background: ${titleGradient}; background-clip: text; -webkit-background-clip: text; -webkit-text-fill-color: transparent; margin:0 0 12px 0; text-transform: uppercase; line-height: 1.2;">
                    PLAN LIMIT REACHED</h3>

                <p id="premiumLimitModalDesc" style="font-size:13.5px; opacity:0.85; margin-bottom:24px; line-height:1.55; color:rgba(255,255,255,0.85) !important; margin:0 0 24px 0;">
                    You have reached the maximum limit of <b id="premiumLimitCardCountText" style="color:${themeColor};">${currentCount} of ${limit} cards</b> on your <b id="premiumLimitTierText" style="color:#ffffff;">${userTier} Plan</b>. Upgrade to unlock more credential card slots!</p>

                <div style="display: flex; flex-direction: column; gap: 10px; width: 100%;">
                    <button id="premium-upgrade-btn" onclick="if(window.switchView) window.switchView('upgrade'); else if(window.parent && window.parent.switchView) window.parent.switchView('upgrade');"
                        style="width: 100%; padding: 14px; border-radius: 12px; border: none; background: ${btnGradient}; color: white; font-size: 14px; font-weight: 700; cursor: pointer; transition: all 0.2s ease; box-shadow: ${btnShadow}; text-transform: uppercase; letter-spacing: 0.5px;">
                        ${btnLabel}
                    </button>
                    <button onclick="window.closePremiumLimitExceededModal();"
                        style="width: 100%; padding: 12px; border-radius: 12px; border: 1px solid rgba(255,255,255,0.12); background: rgba(255,255,255,0.05); color: rgba(255,255,255,0.7); font-size: 13.5px; font-weight: 600; cursor: pointer; transition: all 0.2s ease;">
                        Remain on Current
                    </button>
                </div>
            </div>
        `;
        document.body.appendChild(modal);
        if (window.parent && window.parent.document && window.parent.document.body && window.parent !== window) {
            const pModal = modal.cloneNode(true);
            window.parent.document.body.appendChild(pModal);
        }
    }

    const cardCountEl = document.getElementById('premiumLimitCardCountText') || (window.parent && window.parent.document && window.parent.document.getElementById('premiumLimitCardCountText'));
    if (cardCountEl) cardCountEl.textContent = `${currentCount} of ${limit} cards`;

    const tierEl = document.getElementById('premiumLimitTierText') || (window.parent && window.parent.document && window.parent.document.getElementById('premiumLimitTierText'));
    if (tierEl) tierEl.textContent = `${userTier} Plan`;

    modal.style.display = 'flex';
    if (window.parent && window.parent.document) {
        const parentModal = window.parent.document.getElementById('premiumLimitExceededModal');
        if (parentModal) parentModal.style.display = 'flex';
    }
};

window.closePremiumLimitExceededModal = function () {
    let modal = document.getElementById('premiumLimitExceededModal');
    if (modal) modal.style.display = 'none';
    if (window.parent && window.parent.document) {
        let pModal = window.parent.document.getElementById('premiumLimitExceededModal');
        if (pModal) pModal.style.display = 'none';
    }
};

window.redirectToUpgradePage = function () {
    window.closePremiumLimitExceededModal();
    if (window.parent && typeof window.parent.switchView === 'function') {
        window.parent.switchView('upgrade');
    } else if (typeof window.switchView === 'function') {
        window.switchView('upgrade');
    } else if (window.parent && window.parent.location) {
        window.parent.location.href = '/templates/upgrade.html';
    } else {
        window.location.href = '/templates/upgrade.html';
    }
};

window.openSettingRequiredModal = function (settingType = 'mutation', action = 'edit') {
    let modal = document.getElementById('settingRequiredPromptModal');
    if (!modal) {
        modal = document.createElement('div');
        modal.className = 'confirm-modal-overlay';
        modal.id = 'settingRequiredPromptModal';
        modal.style.cssText = 'display: flex; z-index: 999999; position: fixed; inset: 0; background: rgba(0, 0, 0, 0.45); backdrop-filter: blur(10px); justify-content: center; align-items: center; padding: 16px;';
        document.body.appendChild(modal);
    }

    const isMutation = settingType === 'mutation';
    const actionVerb = action === 'delete' ? 'delete' : (action === 'edit' ? 'edit' : (action === 'download' ? 'download PDF for' : 'modify'));

    const icon = isMutation ? 'shield_lock' : 'picture_as_pdf';
    const badgeText = isMutation ? 'MUTATION LOCK REQUIRED' : 'SECURE PDF REQUIRED';
    const titleText = isMutation ? 'Card Mutation Setting Required' : 'Secure PDF Setting Required';
    const targetKey = isMutation ? 'card-mutation' : 'secure-pdf';
    const descText = isMutation
        ? `To <strong>${actionVerb}</strong> credential cards, the <strong>Card Mutation Lock</strong> setting must be turned ON with a security passcode. Please open Settings to configure and enable this security protection.`
        : `To <strong>download credential PDFs</strong>, the <strong>Secure PDF Download</strong> setting must be turned ON with a security passcode. Please open Settings to configure and enable this security protection.`;

    modal.innerHTML = `
        <div class="confirm-modal-card" style="background: rgba(255, 255, 255, 0.98); border: 1px solid rgba(245, 158, 11, 0.4); border-radius: 24px; padding: 28px; max-width: 440px; width: 90%; color: #0f172a; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25); text-align: center;">
            <div style="width: 56px; height: 56px; border-radius: 50%; background: #fef3c7; border: 1px solid #fde68a; display: flex; align-items: center; justify-content: center; margin: 0 auto 14px auto;">
                <span class="material-symbols-outlined" style="font-size: 30px; color: #d97706;">${icon}</span>
            </div>
            
            <div style="display: inline-block; padding: 4px 12px; background: #fffbeb; border: 1px solid #fef3c7; border-radius: 9999px; margin-bottom: 10px;">
                <span style="font-size: 10px; font-weight: 800; letter-spacing: 1px; color: #b45309; text-transform: uppercase;">${badgeText}</span>
            </div>

            <h3 class="confirm-modal-title" style="margin: 0 0 10px 0; font-size: 1.2rem; font-weight: 800; color: #0f172a;">
                ${titleText}
            </h3>

            <p class="confirm-modal-text" style="font-size: 0.85rem; color: #475569; margin: 0 0 22px 0; line-height: 1.55;">
                ${descText}
            </p>

            <div style="display: flex; gap: 10px; justify-content: center; width: 100%;">
                <button type="button" onclick="closeSettingRequiredModal()"
                    style="flex: 1; padding: 11px 16px; border-radius: 12px; border: 1px solid #cbd5e1; background: #f8fafc; color: #475569; font-size: 0.82rem; font-weight: 700; cursor: pointer; transition: background 0.2s;">
                    Cancel
                </button>
                <button type="button" onclick="navigateToSetting('${targetKey}')"
                    style="flex: 1.3; padding: 11px 18px; border-radius: 12px; border: none; background: linear-gradient(135deg, #d97706 0%, #b45309 100%); color: white; font-size: 0.82rem; font-weight: 800; cursor: pointer; box-shadow: 0 4px 12px rgba(217, 119, 6, 0.35); display: flex; align-items: center; justify-content: center; gap: 6px;">
                    <span class="material-symbols-outlined" style="font-size: 16px;">tune</span>
                    <span>Open Settings</span>
                </button>
            </div>
        </div>
    `;

    modal.style.display = 'flex';
    if (window.parent && window.parent.document && window.parent !== window) {
        try {
            let pModal = window.parent.document.getElementById('settingRequiredPromptModal');
            if (!pModal) {
                pModal = window.parent.document.createElement('div');
                pModal.className = 'confirm-modal-overlay';
                pModal.id = 'settingRequiredPromptModal';
                pModal.style.cssText = 'display: flex; z-index: 999999; position: fixed; inset: 0; background: rgba(0, 0, 0, 0.45); backdrop-filter: blur(10px); justify-content: center; align-items: center; padding: 16px;';
                window.parent.document.body.appendChild(pModal);
            }
            pModal.innerHTML = modal.innerHTML;
            pModal.style.display = 'flex';
        } catch (e) { }
    }
};

window.closeSettingRequiredModal = function () {
    let modal = document.getElementById('settingRequiredPromptModal');
    if (modal) modal.style.display = 'none';
    if (window.parent && window.parent.document) {
        try {
            let pModal = window.parent.document.getElementById('settingRequiredPromptModal');
            if (pModal) pModal.style.display = 'none';
        } catch (e) { }
    }
};

window.navigateToSetting = function (targetSetting) {
    try {
        sessionStorage.setItem('pending_settings_focus', targetSetting);
        localStorage.setItem('pending_settings_focus', targetSetting);
    } catch (e) { }

    window.closeSettingRequiredModal();

    if (window.parent && typeof window.parent.switchView === 'function') {
        window.parent.switchView('preferences');
    } else if (typeof window.switchView === 'function') {
        window.switchView('preferences');
    } else if (window.parent && window.parent.location) {
        window.parent.location.href = '/templates/preferences.html';
    } else {
        window.location.href = '/templates/preferences.html';
    }
};

window.checkFeatureAgeEligibility = function (featureName = 'Adding Vault Credentials') {
    let ud = window.userData || (window.parent && window.parent.userData) || (window.top && window.top.userData);
    if (!ud) {
        try {
            const enc = sessionStorage.getItem('userStoreEnc') || localStorage.getItem('userStoreEnc') ||
                (window.parent && window.parent.sessionStorage && window.parent.sessionStorage.getItem('userStoreEnc'));
            if (enc && typeof CryptoJS !== 'undefined' && typeof _getAppSecret === 'function') {
                const bytes = CryptoJS.AES.decrypt(enc, _getAppSecret());
                const parsed = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                if (parsed) ud = parsed;
            }
        } catch (e) { }
    }
    if (!ud) {
        try {
            const rawStore = localStorage.getItem('userStore') || (window.parent && window.parent.localStorage && window.parent.localStorage.getItem('userStore'));
            if (rawStore) ud = JSON.parse(rawStore);
        } catch (e) { }
    }

    let hasAge = false;
    let ageVal = null;

    if (ud) {
        if (ud.age !== undefined && ud.age !== null && String(ud.age).trim() !== '') {
            const a = parseFloat(ud.age);
            if (!isNaN(a)) {
                hasAge = true;
                ageVal = a;
            }
        }
        if (ud.dob && String(ud.dob).trim() !== '') {
            const dobDate = new Date(ud.dob);
            if (!isNaN(dobDate.getTime())) {
                const ageFromDob = (Date.now() - dobDate.getTime()) / (365.25 * 24 * 60 * 60 * 1000);
                if (!isNaN(ageFromDob)) {
                    hasAge = true;
                    if (ageVal === null || ageFromDob < ageVal) {
                        ageVal = ageFromDob;
                    }
                }
            }
        }
    }

    if (!hasAge) {
        return { allowed: false, reason: 'not_set' };
    }
    if (ageVal < 18) {
        return { allowed: false, reason: 'under_18' };
    }
    return { allowed: true };
};

window.openAgeVerificationModal = function (featureLabel = 'Adding Vault Credentials', isUnder18 = false) {
    const targetDoc = (window.top && window.top.document) ? window.top.document : document;
    let modal = targetDoc.getElementById('ageVerificationRequiredModal');
    if (!modal) {
        modal = targetDoc.createElement('div');
        modal.id = 'ageVerificationRequiredModal';
        modal.style.cssText = 'display: none; position: fixed; inset: 0; background: rgba(15, 23, 42, 0.7); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); z-index: 2147483647; align-items: center; justify-content: center; padding: 16px;';
        modal.innerHTML = '<div style="background: #ffffff; border-radius: 24px; padding: 28px 24px; max-width: 420px; width: 100%; box-shadow: 0 25px 60px rgba(0,0,0,0.3), 0 0 0 1px rgba(0,0,0,0.06); text-align: center; position: relative; font-family: \'Space Grotesk\', -apple-system, sans-serif;"><div id="globalAgeModalIconContainer" style="width: 56px; height: 56px; border-radius: 20px; margin: 0 auto 16px; display: flex; align-items: center; justify-content: center; font-size: 26px;">🛡️</div><h3 id="globalAgeModalTitle" style="margin: 0 0 8px 0; font-size: 19px; font-weight: 800; color: #0f172a; letter-spacing: -0.3px;">Age Verification Required</h3><p id="globalAgeModalDesc" style="margin: 0 0 22px 0; font-size: 13.5px; line-height: 1.55; color: #475569; font-weight: 500;">Age is not recorded in your profile. To add credentials, please update your Date of Birth in Account settings.</p><div id="globalAgeModalActionContainer" style="display: flex; flex-direction: column; gap: 10px;"><button id="globalAgeModalConfirmBtn" onclick="if(window.top&&window.top.goToAccountForAge){window.top.goToAccountForAge();}else if(window.goToAccountForAge){window.goToAccountForAge();}" style="width: 100%; padding: 12px 18px; border-radius: 14px; border: none; background: linear-gradient(135deg, #0284c7, #0369a1); color: #ffffff; font-size: 14px; font-weight: 800; cursor: pointer; transition: 0.2s; box-shadow: 0 4px 14px rgba(2, 132, 199, 0.35);">Go to Account & Set Age &rarr;</button><button onclick="if(window.top&&window.top.closeAgeVerificationModal){window.top.closeAgeVerificationModal();}else if(window.closeAgeVerificationModal){window.closeAgeVerificationModal();}" style="width: 100%; padding: 11px 18px; border-radius: 14px; border: 1.5px solid #cbd5e1; background: transparent; color: #64748b; font-size: 13.5px; font-weight: 700; cursor: pointer; transition: 0.2s;">Cancel</button></div></div>';
        targetDoc.body.appendChild(modal);
    }
    const iconCont = modal.querySelector('#globalAgeModalIconContainer');
    const titleEl = modal.querySelector('#globalAgeModalTitle');
    const descEl = modal.querySelector('#globalAgeModalDesc');
    const confirmBtn = modal.querySelector('#globalAgeModalConfirmBtn');
    if (isUnder18) {
        if (iconCont) { iconCont.style.background = 'rgba(239, 68, 68, 0.1)'; iconCont.innerText = '🔞'; }
        if (titleEl) { titleEl.innerText = 'Age Restricted (18+ Required)'; titleEl.style.color = '#dc2626'; }
        if (descEl) { descEl.innerHTML = 'You must be at least <strong>18 years old</strong> to use <strong>' + featureLabel + '</strong>.<br><br>Underage accounts cannot add, edit, or store encrypted credentials.'; }
        if (confirmBtn) { confirmBtn.style.display = 'none'; }
    } else {
        if (iconCont) { iconCont.style.background = 'rgba(2, 132, 199, 0.1)'; iconCont.innerText = '🛡️'; }
        if (titleEl) { titleEl.innerText = 'Age Verification Required'; titleEl.style.color = '#0f172a'; }
        if (descEl) { descEl.innerHTML = 'Your Date of Birth is not set in your profile.<br><br>To use <strong>' + featureLabel + '</strong>, you must be verified as 18+ by recording your Date of Birth in Account settings.'; }
        if (confirmBtn) { confirmBtn.style.display = 'block'; confirmBtn.innerText = 'Go to Account & Set Age →'; }
    }
    modal.style.display = 'flex';
};

window.closeAgeVerificationModal = function () {
    const targetDoc = (window.top && window.top.document) ? window.top.document : document;
    const modal = targetDoc.getElementById('ageVerificationRequiredModal');
    if (modal) modal.style.display = 'none';
};

window.goToAccountForAge = function () {
    window.closeAgeVerificationModal();
    if (window.parent && typeof window.parent.switchView === 'function') {
        window.parent.switchView('account');
    } else if (typeof window.switchView === 'function') {
        window.switchView('account');
    } else if (window.top && typeof window.top.switchView === 'function') {
        window.top.switchView('account');
    } else {
        window.location.href = '/account';
    }
};

window.checkTemplateMutationAuth = function (action = 'create', onAuthorized = null, currentCount = null) {
    const mgr = window.CosmoSecurePdfManager || (window.parent && window.parent.CosmoSecurePdfManager);
    let isLoggedIn = false;
    if (mgr && typeof mgr.isUserLoggedIn === 'function') {
        isLoggedIn = mgr.isUserLoggedIn();
    } else {
        if (localStorage.getItem('explicit_logout') === 'true') {
            isLoggedIn = false;
        } else {
            const pAuth = (window.parent && (window.parent.suiteAuth || window.parent.auth)) || window.suiteAuth || window.auth;
            const fbAuth = (window.auth || (window.parent && window.parent.auth));
            const currentUser = (pAuth && pAuth.currentUser) ? pAuth.currentUser : (fbAuth && fbAuth.currentUser);
            const userEnc = sessionStorage.getItem('userStoreEnc') || localStorage.getItem('userStoreEnc');
            const ud = window.userData || (window.parent && window.parent.userData);
            isLoggedIn = !!(currentUser && (userEnc || ud));
        }
    }

    if (!isLoggedIn) {
        const actionVerb = action === 'delete' ? 'delete' : (action === 'edit' ? 'edit' : 'create');
        const msg = `Login required to ${actionVerb} credentials. Please log in to your account.`;
        if (typeof showAppToast === 'function') {
            showAppToast(msg, true);
        } else if (typeof showToast === 'function') {
            showToast(msg, 'warning', 'LOGIN REQUIRED');
        } else if (window.parent && typeof window.parent.showToast === 'function') {
            window.parent.showToast(msg, 'warning', 'LOGIN REQUIRED');
        } else if (typeof window.pop === 'function') {
            window.pop(msg, 'warning');
        }
        return false;
    }

    // Age Verification Check: Check age eligibility for adding, editing, or deleting credentials
    const ageCheckFn = window.checkFeatureAgeEligibility || (window.parent && window.parent.checkFeatureAgeEligibility) || (window.top && window.top.checkFeatureAgeEligibility);
    if (typeof ageCheckFn === 'function') {
        const featureLabel = (action === 'create' || action === 'add') ? 'Adding Vault Credentials' : (action === 'delete' ? 'Deleting Vault Credentials' : 'Editing Vault Credentials');
        const ageCheck = ageCheckFn(featureLabel);
        if (!ageCheck.allowed) {
            const openAgeModalFn = window.openAgeVerificationModal || (window.parent && window.parent.openAgeVerificationModal) || (window.top && window.top.openAgeVerificationModal);
            if (typeof openAgeModalFn === 'function') {
                openAgeModalFn(featureLabel, ageCheck.reason === 'under_18');
            }
            return false;
        }
    }

    if (action === 'create') {
        const userTier = window.getUserActivePlanTier ? window.getUserActivePlanTier() : 'Element';
        const PLAN_CARD_LIMITS = window.PLAN_CARD_LIMITS || {
            'Element': 10,
            'Catalyst': 25,
            'Matrix': 50,
            'Quantum': Infinity
        };
        const limit = PLAN_CARD_LIMITS[userTier] !== undefined ? PLAN_CARD_LIMITS[userTier] : 10;

        if (limit !== Infinity && currentCount !== null && currentCount !== undefined && currentCount >= limit) {
            if (typeof window.openPremiumLimitExceededModal === 'function') {
                window.openPremiumLimitExceededModal(userTier, currentCount, limit);
            }
            return false;
        }
    }

    // If action is edit or delete, require Card Mutation setting to be enabled with passcode
    if (action === 'edit' || action === 'delete') {
        const mutMgr = window.CosmoCardMutationManager || (window.parent && window.parent.CosmoCardMutationManager);
        const isLockEnabled = mutMgr ? mutMgr.isCardMutationLockEnabled() : false;
        const pass = mutMgr ? mutMgr.getCardMutationPassword() : '';

        if (!isLockEnabled || !pass) {
            const fnReq = window.openSettingRequiredModal || (window.parent && window.parent.openSettingRequiredModal);
            if (typeof fnReq === 'function') {
                fnReq('mutation', action);
            } else {
                window.openSettingRequiredModal('mutation', action);
            }
            return false;
        }

        pendingMutationAuthorizedCallback = onAuthorized;
        const fn = window.openCardMutationPromptModal || (window.parent && window.parent.openCardMutationPromptModal);
        if (typeof fn === 'function') {
            fn(action);
        } else {
            window.openCardMutationPromptModal(action);
        }
        return false;
    }

    if (typeof onAuthorized === 'function') {
        onAuthorized();
    }
    return true;
};

window.CosmoSecurePdfManager = {
    isUserLoggedIn: function () {
        try {
            if (localStorage.getItem('explicit_logout') === 'true') return false;

            const pAuth = (window.parent && (window.parent.suiteAuth || window.parent.auth)) || window.suiteAuth || window.auth;
            const fbAuth = (window.auth || (window.parent && window.parent.auth));
            const currentUser = (pAuth && pAuth.currentUser) ? pAuth.currentUser : (fbAuth && fbAuth.currentUser);
            if (!currentUser) return false;

            const userEnc = sessionStorage.getItem('userStoreEnc') || localStorage.getItem('userStoreEnc');
            const ud = window.userData || (window.parent && window.parent.userData);
            if (!userEnc && !ud) return false;

            return true;
        } catch (e) { }
        return false;
    },
    isSecurePdfEnabled: function () {
        const contexts = [
            window.userData,
            (window.parent && window.parent !== window) ? window.parent.userData : null,
            (window.top && window.top !== window) ? window.top.userData : null
        ];
        for (const ud of contexts) {
            if (ud) {
                const cfg = (ud.settings && ud.settings.secure_pdf_config) || ud.secure_pdf_config;
                if (cfg && cfg.enabled !== undefined) return !!cfg.enabled;
            }
        }
        try {
            const enc = sessionStorage.getItem('userStoreEnc') || localStorage.getItem('userStoreEnc');
            if (enc && typeof CryptoJS !== 'undefined') {
                const bytes = CryptoJS.AES.decrypt(enc, _getAppSecret());
                const u = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                if (u && u.settings && u.settings.secure_pdf_config) {
                    return !!u.settings.secure_pdf_config.enabled;
                }
            }
        } catch (e) { }
        return false;
    },
    getSecurePdfPassword: function () {
        const contexts = [
            window.userData,
            (window.parent && window.parent !== window) ? window.parent.userData : null,
            (window.top && window.top !== window) ? window.top.userData : null
        ];
        for (const ud of contexts) {
            if (ud) {
                const cfg = (ud.settings && ud.settings.secure_pdf_config) || ud.secure_pdf_config;
                if (cfg && cfg.password) return cfg.password;
            }
        }
        try {
            const enc = sessionStorage.getItem('userStoreEnc') || localStorage.getItem('userStoreEnc');
            if (enc && typeof CryptoJS !== 'undefined') {
                const bytes = CryptoJS.AES.decrypt(enc, _getAppSecret());
                const u = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
                if (u && u.settings && u.settings.secure_pdf_config) {
                    return u.settings.secure_pdf_config.password || '';
                }
            }
        } catch (e) { }
        return '';
    },
    setSecurePdfConfig: function (enabled, password) {
        const config = { enabled: !!enabled, password: password !== undefined ? password : this.getSecurePdfPassword() };

        const contexts = [window, window.parent, window.top].filter(w => w && w.userData);
        contexts.forEach(ctx => {
            if (!ctx.userData.settings) ctx.userData.settings = {};
            ctx.userData.settings.secure_pdf_config = config;
        });

        try {
            document.querySelectorAll('.view-layer iframe, iframe').forEach(iframe => {
                try {
                    if (iframe.contentWindow) {
                        if (iframe.contentWindow.userData) {
                            if (!iframe.contentWindow.userData.settings) iframe.contentWindow.userData.settings = {};
                            iframe.contentWindow.userData.settings.secure_pdf_config = config;
                        }
                        if (typeof iframe.contentWindow.updateSettingsSecurePdfCardState === 'function') {
                            iframe.contentWindow.updateSettingsSecurePdfCardState();
                        }
                        if (typeof iframe.contentWindow.initSecurePdfModalUI === 'function') {
                            iframe.contentWindow.initSecurePdfModalUI();
                        }
                    }
                } catch (e) { }
            });
        } catch (e) { }

        const fn = window.saveSecurePdfConfigToFirebase || (window.parent && window.parent.saveSecurePdfConfigToFirebase) || (window.top && window.top.saveSecurePdfConfigToFirebase);
        if (typeof fn === 'function') {
            fn(config.enabled, config.password);
        }
        if (typeof window.updateSettingsSecurePdfCardState === 'function') {
            window.updateSettingsSecurePdfCardState();
        }
        if (window.parent && typeof window.parent.updateSettingsSecurePdfCardState === 'function') {
            window.parent.updateSettingsSecurePdfCardState();
        }
    },
    handlePDFDownloadSecurity: function (onAuthorized) {
        if (!this.isUserLoggedIn()) {
            showAppToast("Login required to download PDFs. Please log in first.", true);
            return false;
        }
        const isPdfEnabled = this.isSecurePdfEnabled();
        const savedPass = this.getSecurePdfPassword();

        if (!isPdfEnabled || !savedPass) {
            const fnReq = window.openSettingRequiredModal || (window.parent && window.parent.openSettingRequiredModal);
            if (typeof fnReq === 'function') {
                fnReq('secure-pdf', 'download');
            } else {
                window.openSettingRequiredModal('secure-pdf', 'download');
            }
            return false;
        }

        pendingPDFAuthorizedCallback = onAuthorized;
        window.openSecurePdfPromptModal();
        return false;
    },
    recordPdfDownload: function (countToAdd = 1, isEncrypted = false) {
        try {
            const getTelem = () => {
                if (window._cosmoPdfTelemetryState) return window._cosmoPdfTelemetryState;
                if (window.userData && window.userData.pdf_telemetry) return window.userData.pdf_telemetry;
                if (window.parent && window.parent._cosmoPdfTelemetryState) return window.parent._cosmoPdfTelemetryState;
                if (window.parent && window.parent.userData && window.parent.userData.pdf_telemetry) return window.parent.userData.pdf_telemetry;
                return { downloads_count: 0, encrypted_downloads_count: 0 };
            };

            const telem = getTelem();
            let currentCount = (telem.downloads_count || 0) + countToAdd;
            let encryptedCount = (telem.encrypted_downloads_count || 0) + (isEncrypted ? countToAdd : 0);

            const updatedTelem = {
                downloads_count: currentCount,
                encrypted_downloads_count: encryptedCount,
                last_updated: new Date().toISOString()
            };

            window._cosmoPdfTelemetryState = updatedTelem;
            if (window.userData) window.userData.pdf_telemetry = updatedTelem;
            if (window.parent && window.parent.userData) window.parent.userData.pdf_telemetry = updatedTelem;
            if (window.parent) window.parent._cosmoPdfTelemetryState = updatedTelem;
            if (window.top) window.top._cosmoPdfTelemetryState = updatedTelem;

            // Zero LocalStorage purge
            try {
                localStorage.removeItem('cosmo_pdf_downloads_count');
                localStorage.removeItem('cosmo_pdf_encrypted_downloads_count');
            } catch (e) { }

            const detail = { count: currentCount, encryptedCount: encryptedCount };
            window.dispatchEvent(new CustomEvent('cosmo_pdf_download_updated', { detail }));
            if (window.parent && window.parent !== window) {
                try { window.parent.dispatchEvent(new CustomEvent('cosmo_pdf_download_updated', { detail })); } catch (e) { }
            }
            if (window.top && window.top !== window) {
                try { window.top.dispatchEvent(new CustomEvent('cosmo_pdf_download_updated', { detail })); } catch (e) { }
            }

            if (typeof window.updateAnalyticsPdfDownloadsCount === 'function') {
                window.updateAnalyticsPdfDownloadsCount(currentCount, encryptedCount);
            }
            if (window.parent && typeof window.parent.updateAnalyticsPdfDownloadsCount === 'function') {
                window.parent.updateAnalyticsPdfDownloadsCount(currentCount, encryptedCount);
            }

            const iframeEl = document.getElementById('content-frame') || (window.parent && window.parent.document.getElementById('content-frame'));
            if (iframeEl && iframeEl.contentWindow && typeof iframeEl.contentWindow.updateAnalyticsPdfDownloadsCount === 'function') {
                iframeEl.contentWindow.updateAnalyticsPdfDownloadsCount(currentCount, encryptedCount);
            }

            // ⚡ INSTANT 0ms CLOUD PUSH TO FIREBASE FIRESTORE
            const syncCloudFn = window.syncAnalyticsToCloud || (window.parent && window.parent.syncAnalyticsToCloud) || (window.suiteAuthBridge && window.suiteAuthBridge.syncAnalyticsToCloud);
            if (typeof syncCloudFn === 'function') {
                syncCloudFn(null, updatedTelem);
            }

            return currentCount;
        } catch (e) {
            console.warn('[CosmoSecurePdfManager] recordPdfDownload error:', e);
        }
        return 0;
    },
    getPdfDownloadCount: function () {
        const telem = window._cosmoPdfTelemetryState || (window.userData && window.userData.pdf_telemetry) || (window.parent && window.parent._cosmoPdfTelemetryState);
        return telem ? (telem.downloads_count || 0) : 0;
    },
    getPdfEncryptedCount: function () {
        const telem = window._cosmoPdfTelemetryState || (window.userData && window.userData.pdf_telemetry) || (window.parent && window.parent._cosmoPdfTelemetryState);
        return telem ? (telem.encrypted_downloads_count || 0) : 0;
    }
};

window.recordPdfDownload = function (countToAdd = 1, isEncrypted = false) {
    if (window.CosmoSecurePdfManager && typeof window.CosmoSecurePdfManager.recordPdfDownload === 'function') {
        return window.CosmoSecurePdfManager.recordPdfDownload(countToAdd, isEncrypted);
    } else if (window.parent && window.parent.CosmoSecurePdfManager && typeof window.parent.CosmoSecurePdfManager.recordPdfDownload === 'function') {
        return window.parent.CosmoSecurePdfManager.recordPdfDownload(countToAdd, isEncrypted);
    } else {
        try {
            const telem = window._cosmoPdfTelemetryState || (window.userData && window.userData.pdf_telemetry) || { downloads_count: 0, encrypted_downloads_count: 0 };
            let currentCount = (telem.downloads_count || 0) + countToAdd;
            let encCount = (telem.encrypted_downloads_count || 0) + (isEncrypted ? countToAdd : 0);

            const updatedTelem = {
                downloads_count: currentCount,
                encrypted_downloads_count: encCount,
                last_updated: new Date().toISOString()
            };

            window._cosmoPdfTelemetryState = updatedTelem;
            if (window.userData) window.userData.pdf_telemetry = updatedTelem;
            if (window.parent && window.parent.userData) window.parent.userData.pdf_telemetry = updatedTelem;
            if (window.parent) window.parent._cosmoPdfTelemetryState = updatedTelem;
            if (window.top) window.top._cosmoPdfTelemetryState = updatedTelem;

            try {
                localStorage.removeItem('cosmo_pdf_downloads_count');
                localStorage.removeItem('cosmo_pdf_encrypted_downloads_count');
            } catch (e) { }

            const detail = { count: currentCount, encryptedCount: encCount };
            try { window.dispatchEvent(new CustomEvent('cosmo_pdf_download_updated', { detail })); } catch (e) { }
            try { if (window.parent && window.parent !== window) window.parent.dispatchEvent(new CustomEvent('cosmo_pdf_download_updated', { detail })); } catch (e) { }
            try { if (window.top && window.top !== window) window.top.dispatchEvent(new CustomEvent('cosmo_pdf_download_updated', { detail })); } catch (e) { }
            try {
                document.querySelectorAll('iframe').forEach(iframe => {
                    if (iframe.contentWindow) iframe.contentWindow.dispatchEvent(new CustomEvent('cosmo_pdf_download_updated', { detail }));
                });
            } catch (e) { }

            const syncCloudFn = window.syncAnalyticsToCloud || (window.parent && window.parent.syncAnalyticsToCloud) || (window.suiteAuthBridge && window.suiteAuthBridge.syncAnalyticsToCloud);
            if (typeof syncCloudFn === 'function') {
                syncCloudFn(null, updatedTelem);
            }

            return currentCount;
        } catch (e) { }
    }
    return 0;
};

/* ==========================================================================
   Cosmo Crypt — Universal Real-Time Notification Recording & Broadcast Engine
   ========================================================================== */
window.recordNotification = function (data) {
    try {
        if (!data) return null;
        const NOTIFS_KEY = 'Cosmo Crypt_notifications_v1';
        let notifs = [];
        try {
            const raw = localStorage.getItem(NOTIFS_KEY);
            if (raw) notifs = JSON.parse(raw);
        } catch (e) {
            notifs = [];
        }
        if (!Array.isArray(notifs)) notifs = [];

        const notifCreatedAt = data.createdAt || Date.now();
        const itemDate = new Date(notifCreatedAt);
        const isToday = new Date().toDateString() === itemDate.toDateString();
        const timeStr = itemDate.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });

        const notifItem = {
            id: data.id || ('notif-' + Date.now() + '-' + Math.random().toString(36).substr(2, 6)),
            createdAt: notifCreatedAt,
            category: data.category || 'system',
            priority: data.priority || 'normal',
            title: data.title || 'System Notification',
            subtitle: data.subtitle || 'Cosmo Crypt Event',
            icon: data.icon || 'https://cdn.cosmocrypt.com/templates-images/setting.png',
            iconType: data.iconType || 'icon-system',
            message: data.message || '',
            timestamp: data.timestamp || timeStr,
            timeGroup: data.timeGroup || (isToday ? 'today' : 'yesterday'),
            unread: data.unread !== undefined ? data.unread : true,
            pinned: !!data.pinned,
            type: data.type || 'standard',
            actions: data.actions || []
        };

        // Prepend and limit size to 100
        notifs = notifs.filter(n => n.id !== notifItem.id);
        notifs.unshift(notifItem);
        if (notifs.length > 100) notifs = notifs.slice(0, 100);

        localStorage.setItem(NOTIFS_KEY, JSON.stringify(notifs));

        // 1. BroadcastChannel across all tabs/windows
        try {
            if (window.BroadcastChannel) {
                const bc = new BroadcastChannel('cosmo_notifications_channel');
                bc.postMessage({ type: 'NEW_NOTIFICATION', notification: notifItem });
                bc.close();
            }
        } catch (e) { }

        // 2. Dispatch custom events locally and to parent/top/iframes
        const eventDetail = { notification: notifItem };
        try { window.dispatchEvent(new CustomEvent('cosmo_notification_created', { detail: eventDetail })); } catch (e) { }
        try { if (window.parent && window.parent !== window) window.parent.dispatchEvent(new CustomEvent('cosmo_notification_created', { detail: eventDetail })); } catch (e) { }
        try { if (window.top && window.top !== window) window.top.dispatchEvent(new CustomEvent('cosmo_notification_created', { detail: eventDetail })); } catch (e) { }
        try {
            document.querySelectorAll('iframe').forEach(iframe => {
                if (iframe.contentWindow) iframe.contentWindow.dispatchEvent(new CustomEvent('cosmo_notification_created', { detail: eventDetail }));
            });
        } catch (e) { }

        // 3. Direct invocation on active CosmoNotificationApp instance if loaded
        if (window.cosmoApp && typeof window.cosmoApp.handleIncomingNotification === 'function') {
            window.cosmoApp.handleIncomingNotification(notifItem);
        } else if (window.parent && window.parent.cosmoApp && typeof window.parent.cosmoApp.handleIncomingNotification === 'function') {
            window.parent.cosmoApp.handleIncomingNotification(notifItem);
        }

        return notifItem;
    } catch (err) {
        console.warn('[recordNotification error]:', err);
        return null;
    }
};

window.togglePasswordVisibility = function (inputId, btn) {
    const input = document.getElementById(inputId);
    if (!input) return;
    if (input.type === 'password') {
        input.type = 'text';
        if (btn) btn.innerText = '🔓';
    } else {
        input.type = 'password';
        if (btn) btn.innerText = '👁️';
    }
};

window.openSecurePdfPromptModal = function () {
    let modal = document.getElementById('securePdfVerificationModal');
    if (!modal) {
        modal = document.createElement('div');
        modal.className = 'confirm-modal-overlay';
        modal.id = 'securePdfVerificationModal';
        modal.style.cssText = 'display: flex; z-index: 999999; position: fixed; inset: 0; background: rgba(0, 0, 0, 0.4); backdrop-filter: blur(8px); justify-content: center; align-items: center;';
        modal.innerHTML = `
                    <div class="confirm-modal-card" style="background: rgba(255, 255, 255, 0.96); border: 1px solid rgba(16, 185, 129, 0.4); border-radius: 24px; padding: 28px; max-width: 440px; width: 90%; color: #0f172a; box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);">
                        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; text-align: center; gap: 8px; margin-bottom: 12px;">
                            <span class="material-symbols-outlined text-emerald-600" style="font-size: 32px;">shield_lock</span>
                            <h3 class="confirm-modal-title" style="margin: 0; font-size: 1.15rem; font-weight: 800; color: #0f172a; text-align: center;">Secure PDF Access</h3>
                        </div>
                        <p class="confirm-modal-text" style="font-size: 0.8rem; color: #475569; margin-bottom: 16px; text-align: center;">
                            Secure PDF protection is active. Enter your PDF Security Password to unlock the document export.
                        </p>
                        <div id="securePdfLockoutBanner" style="display: none; background: rgba(239, 68, 68, 0.1); border: 1px solid rgba(239, 68, 68, 0.3); border-radius: 12px; padding: 10px; color: #ef4444; font-size: 0.8rem; font-weight: 700; text-align: center; margin-bottom: 16px;"></div>
                        <div style="position: relative; margin-bottom: 20px;">
                            <input type="password" id="securePdfPromptInputPassword" placeholder="PDF Security Passcode..."
                                onkeydown="if(event.key==='Enter') submitSecurePdfPromptPassword()"
                                style="background: #ffffff; border: 1px solid #cbd5e1; border-radius: 12px; padding: 12px 40px 12px 14px; color: #0f172a; width: 100%; outline: none; font-size: 0.85rem;" />
                            <button type="button" onclick="togglePasswordVisibility('securePdfPromptInputPassword', this)"
                                style="position: absolute; right: 12px; top: 50%; transform: translateY(-50%); color: #64748b; background: none; border: none; cursor: pointer;">👁️</button>
                        </div>
                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;">
                            <button type="button" onclick="closeSecurePdfPromptModal()" style="padding: 10px 18px; border-radius: 12px; border: 1px solid #cbd5e1; background: #f8fafc; color: #475569; font-size: 0.8rem; font-weight: 700; cursor: pointer;">Cancel</button>
                            <button type="button" id="securePdfSubmitBtn" onclick="submitSecurePdfPromptPassword()" style="padding: 10px 18px; border-radius: 12px; border: none; background: #10b981; color: white; font-size: 0.8rem; font-weight: 800; cursor: pointer;">Unlock PDF</button>
                        </div>
                    </div>
                `;
        document.body.appendChild(modal);
    }
    modal.style.display = 'flex';
    if (history.pushState) {
        history.pushState({ modalOpen: true, modalId: 'securePdfVerificationModal' }, '');
    }
    const input = document.getElementById('securePdfPromptInputPassword');
    const submitBtn = document.getElementById('securePdfSubmitBtn');
    const banner = document.getElementById('securePdfLockoutBanner');

    const limiter = window.CosmoSecurityLimiter || (window.parent && window.parent.CosmoSecurityLimiter);
    if (limiter) {
        limiter.bindCountdown('secure_pdf', input, submitBtn, banner, 'Unlock PDF');
    }

    if (input && !input.disabled) {
        input.value = '';
        input.type = 'password';
        setTimeout(() => input.focus(), 100);
    }
};

window.closeSecurePdfPromptModal = function (fromPopState = false) {
    const modal = document.getElementById('securePdfVerificationModal');
    if (modal) modal.style.display = 'none';
    pendingPDFAuthorizedCallback = null;
    if (!fromPopState) {
        if (history.state && history.state.modalOpen && history.state.modalId === 'securePdfVerificationModal') {
            history.back();
        }
    }
};

window.submitSecurePdfPromptPassword = async function () {
    const limiter = window.CosmoSecurityLimiter || (window.parent && window.parent.CosmoSecurityLimiter);
    const input = document.getElementById('securePdfPromptInputPassword');
    const submitBtn = document.getElementById('securePdfSubmitBtn');
    const banner = document.getElementById('securePdfLockoutBanner');

    if (limiter && limiter.isLocked('secure_pdf')) {
        const secs = limiter.getRemainingSeconds('secure_pdf');
        const mins = Math.ceil(secs / 60);
        showAppToast(`🔒 Security Lockout Active! Please wait ${mins} min before retrying.`, true);
        return;
    }

    const entered = input ? input.value : '';
    const correct = window.CosmoSecurePdfManager ? window.CosmoSecurePdfManager.getSecurePdfPassword() : '';

    const verifyFn = window.verifyAppLockSecret || verifyAppLockSecret;
    const isMatch = verifyFn ? await verifyFn(entered, correct) : (entered === correct);
    if (entered && isMatch) {
        if (limiter) limiter.recordSuccess('secure_pdf');
        const cb = pendingPDFAuthorizedCallback;
        pendingPDFAuthorizedCallback = null;
        const modal = document.getElementById('securePdfVerificationModal');
        if (modal) modal.style.display = 'none';
        showAppToast("PDF Passcode Verified. Opening Export Modal...", false);
        if (typeof cb === 'function') {
            cb();
        }
    } else {
        if (limiter) {
            const status = limiter.recordFailure('secure_pdf', 3, 5);
            limiter.bindCountdown('secure_pdf', input, submitBtn, banner, 'Unlock PDF');

            if (status.locked) {
                showAppToast("🚨 3 failed attempts! Secure PDF locked for 5 minutes.", true);
            } else {
                showAppToast(`❌ Incorrect PDF passcode! (${status.attemptsLeft} ${status.attemptsLeft === 1 ? 'attempt' : 'attempts'} remaining)`, true);
            }
        } else {
            showAppToast("Incorrect PDF security password. Access denied.", true);
        }
    }
};

window.addEventListener('load', () => {
    if (window._0x83e2) {
        window._0x83e2.init();
    }
    if (typeof window.calculateAndSyncCardLimits === 'function') {
        window.calculateAndSyncCardLimits();
    }
});

window.addEventListener('storage', () => {
    if (typeof window.calculateAndSyncCardLimits === 'function') {
        window.calculateAndSyncCardLimits();
    }
});

// Dynamic routing when hash changes while the app is active
window.addEventListener('hashchange', () => {
    const hash = window.location.hash;
    if (hash) {
        const cleanHash = hash.replace('#', '').toLowerCase();
        const targetView = window.COSMO_ALIAS_MAP[cleanHash] || (window.COSMO_PAGES.includes(cleanHash) ? cleanHash : null);
        if (targetView && typeof switchView === 'function') {
            switchView(targetView);
        }
    }
});

// Launch Queue handling for modern PWAs focusing existing window
if ('launchQueue' in window) {
    window.launchQueue.setConsumer((launchParams) => {
        if (!launchParams.targetURL) return;
        try {
            const url = new URL(launchParams.targetURL);
            const hash = url.hash;
            if (hash) {
                const cleanHash = hash.replace('#', '').toLowerCase();
                const targetView = window.COSMO_ALIAS_MAP[cleanHash] || (window.COSMO_PAGES.includes(cleanHash) ? cleanHash : null);
                if (targetView && typeof switchView === 'function') {
                    switchView(targetView);
                }
            }
        } catch (e) {
            console.error("Launch Queue parsing failed:", e);
        }
    });
}

// ── INSTANT UPGRADE / DOWNGRADE REAL-TIME LISTENER ──
function handleSubscriptionChange(newPlan) {
    const plan = String(newPlan || localStorage.getItem('user_subscription') || 'element').toLowerCase();
    const modal = document.getElementById('premium-unlock-modal');
    let activeView = '';
    try { activeView = sessionStorage.getItem('current_suite_view') || window._currentSuiteViewState || ''; } catch (e) { activeView = window._currentSuiteViewState || ''; }
    const matchedSlug = window.COSMO_ALIAS_MAP[activeView.toLowerCase()] || (window.COSMO_PAGES.includes(activeView.toLowerCase()) ? activeView.toLowerCase() : null);

    if (matchedSlug) {
        const accessCheck = window.checkTemplateAccess(matchedSlug);
        if (!accessCheck.allowed) {
            document.querySelectorAll('.view-layer').forEach(viewLayer => {
                viewLayer.classList.remove('active');
                viewLayer.style.display = 'none';
            });
            if (typeof window.closeSPA === 'function') {
                window.closeSPA(true);
            }
            window.showPremiumUnlockModal(accessCheck.requiredPlan.toUpperCase());
        } else {
            if (modal && modal.style.display === 'flex') {
                window.closePremiumUnlockModal(true);
            }
        }
    } else {
        if (modal && modal.style.display === 'flex') {
            window.closePremiumUnlockModal(true);
        }
    }
}

window.addEventListener('storage', (e) => {
    if (e.key === 'user_subscription' || e.key === 'cosmocrypt_sub_enc') {
        handleSubscriptionChange(e.newValue);
    }
});

lucide.createIcons();

// =========================================================================
// 🛡️ COSMO CRYPT INACTIVITY & IDLE TIMEOUT MONITOR
// =========================================================================
const COSMO_IDLE_TIMEOUT_MS = 10 * 60 * 1000; // 10 minutes
window.COSMO_IDLE_TIMEOUT_MS = COSMO_IDLE_TIMEOUT_MS;

let _cosmoIdleTimer = null;

function _isCosmoUserActiveSession() {
    try {
        if (window.suiteAuthBridge && typeof window.suiteAuthBridge.getAuthUser === 'function') {
            const u = window.suiteAuthBridge.getAuthUser();
            if (u) return true;
        }
        if (window.userData && window.userData.uid) return true;
        if (sessionStorage.getItem('userStoreEnc') || localStorage.getItem('userStoreEnc')) return true;
    } catch (e) { }
    return false;
}

async function _handleCosmoInactivityLogout() {
    if (!_isCosmoUserActiveSession()) return;

    // Show high-priority Security Alert Toast
    try {
        const timeoutSeconds = Math.round(window.COSMO_IDLE_TIMEOUT_MS / 1000);
        const timeoutMsg = `Logged out due to ${timeoutSeconds >= 60 ? (timeoutSeconds / 60) + ' minutes' : timeoutSeconds + ' seconds'} of inactivity for security.`;
        if (typeof showToast === 'function') {
            showToast(timeoutMsg, true, 5000);
        } else if (window.showToast) {
            window.showToast(timeoutMsg, true, 5000);
        }
    } catch (e) { }

    // Execute logout sequence
    try {
        if (window.suiteAuthBridge && typeof window.suiteAuthBridge.logout === 'function') {
            await window.suiteAuthBridge.logout();
        }

        localStorage.setItem('explicit_logout', 'true');
        sessionStorage.removeItem('userStoreEnc');
        sessionStorage.removeItem('userStore');
        localStorage.removeItem('userStoreEnc');
        localStorage.removeItem('userStore');
        localStorage.removeItem('last_active_uid');
        localStorage.removeItem('cosmo_crypt_purchase_history');
        localStorage.removeItem('cosmo_user_plan');
        localStorage.removeItem('current_plan');
        localStorage.removeItem('cosmocrypt_sub_enc');
        localStorage.removeItem('cosmocrypt_sub_history');
        try { localStorage.removeItem('cosmo_device_id'); } catch (e) { }
        sessionStorage.removeItem('cosmo_unauth_banner_dismissed');
        window.userData = null;

        if (window.cosmoSubscription) {
            await window.cosmoSubscription.clearLocalCache();
        }
        localStorage.removeItem('user_subscription');
        localStorage.removeItem('premiumActive');
        localStorage.removeItem('had_premium_plan');
        localStorage.removeItem('last_notified_subscription');

        window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: 'element', newValue: 'element' } }));
        window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'premiumActive', val: 'false' } }));
        window.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'cosmo_crypt_purchase_history', val: null } }));
        window.dispatchEvent(new CustomEvent('cosmoCryptPlanChanged', { detail: { plan: 'element' } }));
        window.dispatchEvent(new CustomEvent('cosmoPlanChanged', { detail: { plan: 'element' } }));

        // Reset login frame
        const loginFrame = document.getElementById('login-frame');
        if (loginFrame) loginFrame.srcdoc = "";

        // Notify and clear all view iframes
        document.querySelectorAll('.view-layer iframe').forEach(iframe => {
            try {
                if (iframe.contentWindow) {
                    iframe.contentWindow.postMessage({ type: 'logout', isLoggedIn: false, plan: 'element' }, '*');
                    iframe.contentWindow.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'user_subscription', val: 'element', newValue: 'element' } }));
                    iframe.contentWindow.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'premiumActive', val: 'false' } }));
                    iframe.contentWindow.dispatchEvent(new CustomEvent('safeStorageChange', { detail: { key: 'cosmo_crypt_purchase_history', val: null } }));
                    iframe.contentWindow.dispatchEvent(new CustomEvent('cosmoCryptPlanChanged', { detail: { plan: 'element' } }));
                    iframe.contentWindow.dispatchEvent(new CustomEvent('cosmoPlanChanged', { detail: { plan: 'element' } }));
                    if (typeof iframe.contentWindow.updateAllSettingsAuthCards === 'function') {
                        iframe.contentWindow.updateAllSettingsAuthCards();
                    }
                    if (typeof iframe.contentWindow.resetEliteCenterToZero === 'function') {
                        iframe.contentWindow.resetEliteCenterToZero();
                    }
                }
                iframe.srcdoc = "";
            } catch (e) { }
        });

        // Close SPA / redirect to landing page
        if (typeof window.closeSPA === 'function') {
            window.closeSPA();
        } else if (typeof closeSPA === 'function') {
            closeSPA();
        } else {
            window.location.reload();
        }
    } catch (err) {
        console.error("Cosmo Crypt Inactivity logout error:", err);
    }
}

window.resetCosmoIdleTimer = function () {
    if (_cosmoIdleTimer) {
        clearTimeout(_cosmoIdleTimer);
        _cosmoIdleTimer = null;
    }

    if (_isCosmoUserActiveSession()) {
        _cosmoIdleTimer = setTimeout(_handleCosmoInactivityLogout, window.COSMO_IDLE_TIMEOUT_MS);
    }
};

// Listen for user interactions in main window
const _cosmoInteractionEvents = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'wheel', 'pointerdown'];
_cosmoInteractionEvents.forEach(evt => {
    window.addEventListener(evt, window.resetCosmoIdleTimer, { passive: true });
});

// Also reset when receiving messages from iframes
window.addEventListener('message', () => {
    window.resetCosmoIdleTimer();
});

// Attach listeners to child iframes
function _attachIframeIdleListeners() {
    document.querySelectorAll('iframe').forEach(iframe => {
        try {
            if (iframe.contentDocument && !iframe.dataset.idleTracked) {
                iframe.dataset.idleTracked = 'true';
                _cosmoInteractionEvents.forEach(evt => {
                    iframe.contentDocument.addEventListener(evt, window.resetCosmoIdleTimer, { passive: true });
                });
            }
        } catch (e) { }
    });
}

// Start timer and periodically attach listeners to newly opened iframe views
window.resetCosmoIdleTimer();
setInterval(_attachIframeIdleListeners, 2000);




